var globalWrapper = (typeof window !== "undefined" ? window : this);
if (!("fshr" in globalWrapper)) {
    globalWrapper.fshr = {};
}


/**
 *  show/hide content
 * Inicializace - element s třídou v proměnné cssClassJsTrigger
 * Atributy elementu
 * @data-showhide-selector = selector elementu který se má skrýt/zobrazit. Není-li definováno bere se selector z atributu href
 * @href = není-li definován showhide-selector bere se selector elementu pro skrytí/zobrazení odtud (eg. #element) */
(function ($, global) {
    var escKeyCode = 27;
    var cssClassHiddenContent = "fshr-hidden";
    var cssClassActiveTrigger = "fshr-active-trigger";
    var cssClassActiveContent = "fshr-active-content";
    var cssClassJsContent = "js-showHide-content";
    var cssClassJsTrigger = "js-showHide";

    function hideAllContent ($currentTrigger) {
        var $triggers = $("." + cssClassJsTrigger);
        $triggers.each(function () {
            var $trigger = $(this);
            var hideIsAllowed = true;
            if (typeof $currentTrigger !== "undefined" && ($trigger.is($currentTrigger))) {
                hideIsAllowed = false;
            }
            if (hideIsAllowed) {
                var contentSelector = $trigger.attr("data-showhide-selector") || $trigger.attr("href");
                $trigger.removeClass(cssClassActiveTrigger);
                var $visibleContent = global.getElementsBySelector(contentSelector, $trigger);
                $visibleContent.addClass(cssClassHiddenContent);
                $visibleContent.removeClass(cssClassActiveContent);
            }

        });
    }
    global.hideAllContent = hideAllContent;

    function showHideContent (event) {
        event.preventDefault();
        var $this = $(this);
        var contentSelector = $this.attr("data-showhide-selector") || $this.attr("href");
        var $content = global.getElementsBySelector(contentSelector, $this).first();
        var isContentHidden = $content.hasClass(cssClassHiddenContent);

        if (isContentHidden) {
            hideAllContent($this);
            $this.addClass(cssClassActiveTrigger);
            $content.removeClass(cssClassHiddenContent);
            $content.addClass(cssClassActiveContent);
        } else {
            hideAllContent();
        }
    }

    $(document).on("click", "." + cssClassJsTrigger, showHideContent);
    $(document).on("keyup", function (event) {
        var keyCode = event.keyCode;
        if (keyCode == escKeyCode) {
            hideAllContent();
        }
    });
    $(document).on("click", function (event) {
        var $target = $(event.target);
        var isInsideCalendar = $target.closest(".ui-datepicker-header").length;
        var isInsideTrigger = $target.closest("." + cssClassJsTrigger).length || $target.hasClass(cssClassJsTrigger);
        var isInsideContent = $target.closest("." + cssClassJsContent).length || $target.hasClass(cssClassJsContent);
        var isInsideChat = $target.closest("#daktela-chat-head").length;
        if (!isInsideTrigger && !isInsideContent && !isInsideCalendar && !isInsideChat) {
            hideAllContent();
        }
    });
})(jQuery, globalWrapper.fshr);


/* TO DISABLE */
/**
 *  hotel stars
 *  */
(function ($, global) {
    $(".js-stars").each(global.generateStars);
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 *  search menu
 *  */
(function ($, global) {
    var jsClassActive = "js-searchMenu--active";
    var cssClassActive = "fshr-searchMenu-handler--active";
    var cssClassContentActive = "fshr-searchMenu-content--active";
    var cssClassSelected = "fshr-searchMenu--selected";

    var menuSearchSelector = ".js-menuSearch";

    var animationDuration = 200;

    var escKeyCode = 27;

    function handleSearchMenu (event) {

        if (typeof event == "object" && "preventDefault" in event) {
            event.preventDefault();
        }
        var $menuSearchTrigger = $(this);
        var $allMenuSearchTriggers = $(menuSearchSelector);


        var contentType = $menuSearchTrigger.attr("data-menusearch-type");

        if (contentType) {

            if($menuSearchTrigger.hasClass("js-firstLoadSearchForm")){

                var searchForm = $menuSearchTrigger.attr("data-load-to-element");
                var $searchForm = $(searchForm);
                if(!$searchForm.hasClass('js-loadContentByAjax--loaded')){
                    $searchForm.trigger("load-content");
                    var _this = $(this);

                    setTimeout(function(){
                        _this.trigger("initialize-calendars");
                        _this.trigger("initialize-custom-selects", [$searchForm]);
                        _this.trigger("initialize-calendar-dates-list");
                        $searchForm.find(".js-createCols").trigger("create-col");
                    },1500);
                }
            }

            var seasonType = $menuSearchTrigger.attr("data-anchor-type");
            if (seasonType) {
                global.cookie.set('selectedSeason', seasonType, 2);
            }

            var $allMenuSearchContents = $(".js-menuSearch-content");
            if (!$menuSearchTrigger.hasClass(cssClassSelected) && $menuSearchTrigger.is(".js-searchMenu-season")) {
                var $seasonalCarousels = $(".js-carousel--seasonal");
                $seasonalCarousels.slick("slickUnfilter");
                var $allSeasonalContent = $(".js-seasonalContent");
                $allSeasonalContent.addClass("fshr-hidden");
                var $relevantSeasonalContent = $allSeasonalContent.filter(contentType);

                $relevantSeasonalContent.each(function(index, obj){

                    if($(this).hasClass("js-loadContentByAjax") && !$(this).hasClass("js-loadContentByAjax--loaded")){
                        $(this).trigger("load-content");
                    }
                });
                $relevantSeasonalContent.removeClass("fshr-hidden");
                $relevantSeasonalContent.find(".js-sameHeight").trigger("set-same-height");
                $seasonalCarousels.trigger("refilter");
            }
            var $menuSearchContent = $allMenuSearchContents;
            $menuSearchContent = $allMenuSearchContents.filter(contentType);


            if (!$menuSearchTrigger.is("[data-menusearch-universal]") && !$menuSearchTrigger.is("." + cssClassSelected)) {
                $allMenuSearchTriggers.removeClass(cssClassSelected);
                $allMenuSearchContents.removeClass(cssClassSelected);
                $menuSearchTrigger.addClass(cssClassSelected);
                $menuSearchContent.addClass(cssClassSelected);
            }

            $allMenuSearchContents.stop();

            var $otherOpenFilter = $allMenuSearchContents.filter(".js-menuSearch-content:not(" + contentType + ")." + cssClassContentActive);
            var $searchMenuSeasons = $menuSearchTrigger.closest(".fshr-searchMenu-seasons");

            if ($otherOpenFilter.length) {
                $("body").one("menusearchcontent-hidden", function () {
                    show($menuSearchTrigger, $menuSearchContent);
                });
                hide(null, $otherOpenFilter);
            } else {
                if (!$menuSearchTrigger.hasClass(cssClassSelected)) {
                    $searchMenuSeasons.removeClass("fshr-searchMenu-seasons--open");
                    hide($menuSearchTrigger, $menuSearchContent);
                } else {
                    $searchMenuSeasons.addClass("fshr-searchMenu-seasons--open");
                    show($menuSearchTrigger, $menuSearchContent);
                }
            }
        }
    }
    function show ($menuSearch, $menuSearchContent) {
        $menuSearchContent.addClass(cssClassContentActive);
        var $body = $("body");
        $menuSearchContent.slideDown({
            complete: function () {
                $body.trigger("menu-height-changed");
                $body.trigger("menu-height-changed-finish");
            },
            step: function () {
                $body.trigger("menu-height-changed");
            }
        }, animationDuration);
    }
    function hide ($menuSearch, $menuSearchContent) {
        $menuSearchContent.removeClass(cssClassContentActive);
        var $body = $("body");
        $menuSearchContent.slideUp({
            complete: function () {
                $body.trigger("menu-height-changed");
                $body.trigger("menu-height-changed-finish");
                $body.trigger("menusearchcontent-hidden");
            },
            step: function () {
                $body.trigger("menu-height-changed");
            }
        }, animationDuration);
    }


    $(document).on("click", menuSearchSelector, handleSearchMenu);

    if ($("form.fshr-page-search").length) {
        $(document).on("click", function (event) {
            var $target = $(event.target);
            var isInsideMenuSearchContent = $target.closest(".fshr-searchMenu").length;
            var isInsideMenuSearchOpener = $target.closest(".js-openFilter").length;
            var isInsideChat = $target.closest("#daktela-chat-head").length;
            var $menuSearchContent = $(".js-menuSearch-content");
            if (!isInsideMenuSearchContent && !isInsideMenuSearchOpener && !isInsideChat && $menuSearchContent.is(":visible:not(:animated)") && !$("body").hasClass("touch-device")) {
                var $menuSearch = $(menuSearchSelector);
                $menuSearch.each(handleSearchMenu);
            }
        });
        $(document).on("keyup", function (event) {
            var keyCode = event.keyCode;
            if (keyCode == escKeyCode) {
                var $menuSearchContent = $(".js-menuSearch-content");
                if ($menuSearchContent.is(":visible")) {
                    var $menuSearch = $(menuSearchSelector);
                    $menuSearch.each(handleSearchMenu);
                }
            }
        });
    }
})(jQuery, globalWrapper.fshr);



/* TO DISABLE */
/**
 *  tabs
 *  */
(function ($, global) {
    var tabContentSelector = ".js-tabContent";
    var tabControlSelector = ".js-tabControl";
    var cssClassActiveTabNavigation = "fshr-tab-anchor--active";
    var cssClassActiveTab = "fshr-tabContent--active";

    function tabsHandler (event) {
        event.preventDefault();
        var $this = $(this);
        var tabSelector = $this.attr("data-tab-selector") || $this.attr("href");
        showTabBaseHash(tabSelector);
        global.invalidateMaps();
    }
    function showTabBaseHash (tabSelector) {
        var noUrlChange = false;
        if (typeof tabSelector == "undefined") {
            noUrlChange = true;
            tabSelector = window.location.hash.replace("#/", "#");
            if(tabSelector.search("&")!=-1){
                var splited = tabSelector.split("&");
                tabSelector = splited[0];
                splited.shift();

                processSubHashParameters(splited);
            }
        }
        var $triggers = $(tabControlSelector + "[href='" + tabSelector + "']," + tabControlSelector + "[data-tab-selector='" + tabSelector + "']");
        if (tabSelector.length <= 1) {
            var $navigation = $(".js-tabParent:not([data-tab-nourl]) .fshr-tabsNavigation");
            $triggers = $navigation.find(".fshr-tabsNavigation-item.js-defaultTab a");
            if (!$triggers.length) {
                $triggers = $navigation.find(".fshr-tabsNavigation-item:first-child a");
            }
        }
        var $window = $(window);
        var scrollTop = $window.scrollTop();
        var viewportHeight = $window.outerHeight();
        $triggers.each(function () {

            var $this = $(this);

            tabSelector = $this.attr("data-tab-selector") || $this.attr("href") || $this.attr("data-value");

            var openTab = true;
            if (tabSelector == "#termins") {
                var globalAvailability = $this.is("[data-globaloccupancy-set]");
                if (!globalAvailability) {
                    var $popupWindow = $("#popup-availability");
                    if ($popupWindow.length) {
                        global.popup.open($popupWindow);
                        $popupWindow.addClass("js-remoteClick").attr("data-remote-selector", ".js-tabControl[href='#termins']");
                    }
                    openTab = false;
                }
            }

            if (openTab) {
                var parentSelector = $this.attr("data-tab-parentselector") || ".js-tabParent";
                var $parent = $this.closest(parentSelector);
                if ($parent.length) {
                    noUrlChange = $parent.is("[data-tab-nourl]") || noUrlChange;
                    var $tab = $parent.find(tabSelector);


                    var $tabsContent = $parent.find(tabContentSelector).filter(function () {
                        return $(this).closest(".js-tabParent").is($parent);
                    });
                    if ($tab.is(".js-cascadeCheckboxes")) {
                        var $valueToElement = $tab.find(".js-value-to-element").first();
                        if ($valueToElement.length) {
                            $valueToElement.trigger("value-change");
                        }
                    }
                    var $tabsControl = $parent.find(tabControlSelector).filter(function () {
                        return $(this).closest(".js-tabParent").is($parent);
                    });
                    if ($tab.length) {
                        $tabsContent.removeClass(cssClassActiveTab);
                        $tabsControl.removeClass(cssClassActiveTabNavigation);

                        $this.addClass(cssClassActiveTabNavigation);
                        $tab.addClass(cssClassActiveTab);
                        /*
                        var $mapElements = $tab.find(".js-google-map:not(.js-map-loaded)");
                        $mapElements.each(function () {
                            var $map = $(this);
                            global.initializeMap($map);
                        });*/
                        var $mapBranchElements = $tab.find(".js-google-map-branches:not(.js-map-loaded)");
                        $mapBranchElements.each(function () {
                            var $map = $(this);
                            global.initializeMapBranches($map);
                        });
                        var $animateNumbers = $tab.find(".js-numberAnimate:not(.js-animated)");
                        $tab.trigger("tab-open");
                        $tab.find(".js-lazyLoad").trigger("need-to-load");
                        $animateNumbers.trigger("animate-possible");
                    }

                    if (!noUrlChange) {
                        var $body = $("body");
                        $body.addClass("js-hashchange");
                        window.location.hash = tabSelector.replace("#", "#/");
                        $body.removeClass("js-hashchange");
                    }

                    if($this.hasClass("js-tab-load-by-ajax")){
                        var ajax_url = $this.attr("data-tab-load-url") || false;
                        if(!$tab.hasClass("js-tab-ajax-loaded")){
                            if(ajax_url){
                                $tab.addClass("fshr-tab--loading");
                                $.get(ajax_url, function(data){

                                        $tab.html(data);
                                        setTimeout(
                                            function(){
                                                $tab.find(".js-lazyLoad").trigger("need-to-load");
                                                $tab.find(".js-tooltip").each(global.initializeQtip);
                                                $tab.find(".js-readmore").trigger("readmore-initialize");
                                                $tab.find(".js-showMoreContainer").trigger("initialize-showmorecontainer");
                                                $tab.trigger("initialize-selects");
                                                $tab.trigger("initializeCounters");
                                            }, 500
                                        );
                                        $tab.addClass("js-tab-ajax-loaded");
                                        $tab.removeClass("fshr-tab--loading");


                                });
                            }
                        }
                    }
                }

            }
        });
        $triggers.removeClass(".js-noSendCustom");
        if(typeof tabSelector != "undefined"){
            $(tabSelector).trigger("scrollbarWidths");
        }
        $(window).trigger("tab-change");
    }

    $(document).on("click", tabControlSelector, tabsHandler);
    $(window).on("load hashchange", function () {
        if($("body.detail-kapacity").length === 0){
            showTabBaseHash();
        }
    });
    $(document).on("change", ".js-selectAsTabControl", function () {
        var $select = $(this);
        var tabSelector = $select.val();
        var $trigger = $select.closest(".js-tabParent").find(tabControlSelector + "[href='" + tabSelector + "']");
        setTimeout(function () {
            $trigger.click();
        });
    });

    function processSubHashParameters(restParameters) {

        if(restParameters.length > 0){

            for(var index in restParameters){

                var parameter = restParameters[index];

                var value = parameter.split("=")[1];
                value = value.replace("%20", " ");
                parameter = parameter.split("=")[0];

                parameter = parameter.split(".");
                var element = $(parameter[0] + "[" + parameter[1] + "=" + parameter[2] + "]");
                element.val(value).trigger("change");
            }
        }
    }

    $("body").on("change","select.js-changeHashByChangeValue", function(){
        var identifier = $(this).attr("data-hash-key");

        if(identifier.length > 0){
            var hash = window.location.hash;
            var route = "";

            if(hash.search("#/")>-1){
                var parameters = hash.split("&");
                route = parameters.shift();
            }else{
                var parameters = hash.split("&");
            }

            var newParams = [];
            if(parameters.length > 0){
                for(var index in parameters){
                    if(parameters[index].search("=")>-1){
                        var splited = parameters[index].split("=");

                        if(splited[0] == identifier){
                            if($(this).val().length > 0){
                                newParams[splited[0]] = $(this).val();
                            }
                        }else{
                            newParams[splited[0]] = splited[1];
                        }
                    }else{
                        newParams[index] = parameters[index];
                    }
                }
            }else{
                if($(this).val().length > 0){
                    newParams[identifier] = $(this).val();
                }
            }

            var finalParams = [];
            if(Object.keys(newParams).length>0){
                for(var i in newParams){
                    if(isNaN(i)){
                        finalParams.push(i + "=" + newParams[i]);
                    }else{
                        finalParams.push( newParams[i]);
                    }
                }
                window.location.hash = route + "&" + finalParams.join("&");
            }else{
                window.location.hash = route;
            }

        }
    });


})(jQuery, globalWrapper.fshr);


/**
 *  scroll to element after click
 *  */
(function ($, global) {
    function scrollTo (event, $element) {
        if (event.type == "click") {
            event.preventDefault();
        }
        var $this = $element;
        var scrollToElementSelector = $this.attr("data-scroll-to-selector") || $this.attr("href");
        var scrollInElementSelector = $this.attr("data-scroll-in-selector");
        var $scrollToElement = global.getElementsBySelector(scrollToElementSelector, $this);
        var $window = $(window);
        if ($scrollToElement.length) {
            var $animateElement = $("body, html");
            var scrollTo = $scrollToElement.offset().top;
            var $fixedMenu = $(".js-fixedMenu:visible");
            if ($fixedMenu.length) {
                scrollTo = scrollTo - $fixedMenu.outerHeight();
            }
            if (!$this.is("[data-scroll-to-exact-position]")) {
                scrollTo = scrollTo - ($window.outerHeight() / 5);
            }

            if (scrollInElementSelector) {
                var $scrollIn = global.getElementsBySelector(scrollInElementSelector, $this);
                if ($scrollIn.length) {
                    $animateElement = $scrollIn;
                    scrollTo = $scrollToElement.offset().top + $scrollIn.scrollTop() - $scrollIn.offset().top;
                }
            }
            var scrollSpeed = 300;
            $animateElement.animate({
                scrollTop: Math.ceil(scrollTo)
            }, scrollSpeed);
        }
    }
    $(document).on("click", ".js-scroll-to:not(input[type='checkbox'])", function (event) {
        var $element = $(this);
        scrollTo(event, $element);
    });
    $(document).on("change", "input[type='checkbox'].js-scroll-to", function (event) {
        var $element = $(this);
        scrollTo(event, $element);
    });

})(jQuery, globalWrapper.fshr);



/* TO DISABLE */
/**
 *  toggle slide
 *  */
(function ($, global) {
    function toggleSlide (event) {
        event.preventDefault();
        var $this = $(this);
        var $parent = $this.parent();
        var selector = $this.attr("data-toggleslide-selector") || $this.attr("href");
        var showText = $this.attr("data-toggleslide-showtext") || "";
        var hideText = $this.attr("data-toggleslide-hidetext") || "";
        var $element = global.getElementsBySelector(selector, $this);

        var cssClassActive = "fshr-active";


        var cssItemUnactive = $this.attr("data-unactive-class") || "";
        var cssItemActive = $this.attr("data-active-class") || "";

        var animationDuration = 300;
        var $window = $(window);
        if ($element.length) {
            $element.addClass("fshr-toggle-animated");
            if (!$parent.hasClass(cssClassActive)) {
                var $ajaxContentLoaded = $element.find(".js-loadContentByAjax:not(.js-searchFormLoader)");
                if ($ajaxContentLoaded.length) {
                    $ajaxContentLoaded.trigger("load-content");
                }
                $parent.addClass(cssClassActive);
                $element.closest(".fshr-slidingGroups-item, .js-slidingGroups-item").addClass(cssClassActive);
                if (hideText) {
                    $this.text(hideText);
                }

                $element.removeClass("fshr-hidden");
                $element.slideDown({
                    duration: animationDuration,
                    complete: function () {
                        $element.removeClass("fshr-toggle-animated");
                        $window.trigger("content-change");

                        if(cssItemUnactive && cssItemActive){
                            $this.removeClass(cssItemUnactive);
                            $this.addClass(cssItemActive);
                        }
                    }
                });
            } else {
                if (showText) {
                    $this.text(showText);
                }
                $parent.removeClass(cssClassActive);
                $element.closest(".fshr-slidingGroups-item, .js-slidingGroups-item").removeClass(cssClassActive);
                $element.slideUp({
                    duration: animationDuration,
                    complete: function () {
                        $element.removeClass("fshr-toggle-animated");
                        $element.addClass("fshr-hidden");
                        $window.trigger("content-change");

                        if(cssItemUnactive && cssItemActive){
                            $this.removeClass(cssItemActive);
                            $this.addClass(cssItemUnactive);
                        }
                    }
                });
            }
        }
        $element.trigger("toggle-show");
    }
    $(document).on("click", ".js-toggleSlide", toggleSlide);

})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 * search in dom
 * */
(function ($, global) {
    var timeout = 0;
    var objectForSearch = {};

    function searchInArray (searchString, arrayToSearch) {
        var result = [];
        for (var index = 0, count = arrayToSearch.length; index < count; index++) {
            var item = arrayToSearch[index];
            var textToShow = item.originalText;
            var separator = ": ";
            var prefixEndIndex = textToShow.search(separator);
            if (prefixEndIndex > 0) {
                prefixEndIndex = prefixEndIndex + separator.length;
            } else {
                prefixEndIndex = 0;
            }
            var text = item.searchText;
            var textIndex = text.search(searchString);
            if (textIndex > -1) {

                item.textStartIndex = textIndex + prefixEndIndex;
                result.push(item);
            }
        }
        return result;
    }
    function fillSearchArray (inputId, $searchInput) {
        var arrayForSearch = [];
        if (typeof $searchInput === "undefined") {
            $searchInput = $(this);
        }
        var $searchParent = $searchInput.closest(".js-searchParent");
        var $searchInTemp = $searchParent.find(".js-search-item label");
        var parentDomId = "";
        var parentText = "";

        $searchInTemp.each(function (itemIndex) {
            var $item = $(this);
            var searchId = itemIndex + 1;
            var textToSearch = $item.attr("data-searchtext");
            var textToShow = $item.text();
            var $checkbox = $item.find("input[type=checkbox]:first-child");
            var checkboxDomId = $checkbox.attr("id");
            if (!checkboxDomId) {
                checkboxDomId = "checkbox" + inputId + itemIndex;
            }
            checkboxDomId = checkboxDomId.replace(/ /g , "");
            $checkbox.attr("id", checkboxDomId);
            var checkboxId = $checkbox.attr("data-checkbox-id");
            var checkboxParentId = $checkbox.attr("data-parentcheckbox-id");
            var isParent = false;
            if (!checkboxParentId) {
                isParent = true;
                parentDomId = checkboxDomId;
                parentText = textToShow;
            } else if ($checkbox.attr("data-parenttext") && $checkbox.attr("data-parentdomid")) {
                parentText = $checkbox.attr("data-parenttext");
                parentDomId = $checkbox.attr("data-parentdomid");
            }
            $item.attr("data-searchid", searchId);
            arrayForSearch.push({
                searchId: searchId,
                searchText: textToSearch || (global.removeDiacritics(textToShow)).toLowerCase().trim(),
                originalText: textToShow,
                checkboxId: checkboxId,
                checkboxParentId: checkboxParentId,
                checkboxChecked: $checkbox.prop("checked"),
                isParent: isParent,
                parentText: parentText,
                checkboxDomId: checkboxDomId,
                checkboxParentDomId: parentDomId
            });
        });
        objectForSearch[inputId] = arrayForSearch;
    }
    function generateDestinations (destinations, $searchInput) {
        var $destinationsWrapper = $("<div class='js-search-item fshr-hidden'></div>");
        var destinationsCount = destinations.length;
        for (var destIndex = 0; destIndex < destinationsCount; destIndex++) {
            var destination = destinations[destIndex];
            var parentId = destination.parentId;
            var parentDomId = destination.parentDomId;
            var parentText = destination.parentText;
            var inputIsChecked = destination.inputChecked;
            var inputName = destination.inputName;
            var inputValue = destination.inputValue;
            var dataIndex = destination.inputDataIndex;
            var dataValue = destination.inputDataValue;
            var dataType = destination.inputDataType;

            var $input = $("<input type='checkbox'>");
            $input.prop("checked", inputIsChecked);
            $input.attr("data-parentcheckbox-id", parentId);
            $input.attr("data-parenttext", parentText);
            $input.attr("data-parentdomid", parentDomId);

            if (dataIndex) {
                $input.attr("data-index", dataIndex);
            }
            if (dataValue) {
                $input.attr("data-value", dataValue);
            }

            if (dataType) {
                $input.attr("data-type", dataType);
            }

            if (inputName || (!inputName && parseInt(inputName, 10) === 0)) {
                $input.attr("name", inputName);
            }
            if (inputValue || (!inputValue && parseInt(inputValue, 10) === 0)) {
                $input.attr("value", inputValue);
            }

            var $label = $("<label><span>" + parentText + ": " + destination.text + "</span></label>");
            $label.attr("data-searchtext", destination.searchText);
            var $item = $("<div class='fshr-list-item'></div>");
            $label.prepend($input);
            $item.append($label);
            $destinationsWrapper.append($item);
        }
        var $searchParent = $searchInput.closest(".js-searchParent");
        $searchParent.append($destinationsWrapper);
        $destinationsWrapper.trigger("cascade-change-finished");
    }

    var $searchInDom = $(".js-searchInDom");

    $searchInDom.on("focus", function (event) {
        var $searchInput = $(this);
        var id = $searchInput.attr("id");

        if (!$searchInput.is("[data-destinations-generated]")) {
            if ("scriptDestinations" in window) {
                generateDestinations(scriptDestinations, $searchInput); // destinations
            }

            // run after generateDestinations is fully loaded
            fillSearchArray(id, $searchInput);
            $searchInput.attr("data-destinations-generated", "true");
        }
    });

    $searchInDom.each(function () {
        var $searchInput = $(this);
        var $searchParent = $searchInput.closest(".js-searchParent");
        var $searchResult = $searchParent.find(".js-searchResult");
        var domIndex = $searchInput.attr("data-dom-index");

        $searchInput.on("keydown input focus", function (event) {
            var $input = $(this);
            var id = $input.attr("id");
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                var valueToSearch = global.removeDiacritics($input.val()).toLowerCase().trim();
                var valueToSearchLength = valueToSearch.length;
                var $result = $();
                if (valueToSearch.length > 2) {
                    var searchResults = searchInArray(valueToSearch, objectForSearch[id] ? objectForSearch[id] : []);
                    if (searchResults.length) {
                        $searchResult.removeClass("fshr-hidden");
                        $result = $("<div class='js-cascadeCheckboxes fshr-list fshr-list--cascadeCheckboxes js-isSearchWhisperer fshr-list--shrinked'></div>");
                        var $parent = $();
                        var parentId = 0;
                        for (var index = 0, count = searchResults.length; index < count; index++) {
                            var resultItem = searchResults[index];
                            var originalText = searchResults[index].originalText;
                            var searchId = resultItem.searchId;
                            var isParent = resultItem.isParent;
                            var checkboxId = resultItem.checkboxId;
                            var checkboxParentId = resultItem.checkboxParentId;
                            var checkboxDomId = resultItem.checkboxDomId;
                            var checkboxParentDomId = resultItem.checkboxParentDomId;
                            var checkboxParentText = resultItem.parentText;
                            var highlighted = originalText.substr(resultItem.textStartIndex, valueToSearchLength);
                            var resultText = originalText.replace(highlighted, "<b class='fshr-highlighted'>" + highlighted + "</b>");

                            var $linkedCheckbox = $searchParent.find("#" + checkboxDomId);
                            var $linkedParentCheckbox = checkboxParentDomId ? $searchParent.find("#" + checkboxParentDomId) : $();
                            var isChecked = $linkedCheckbox.prop("checked");
                            var isParentChecked = $linkedParentCheckbox.prop("checked");


                            var $item = $("<li><label><input type='checkbox' data-domid='" + checkboxDomId + "' data-parentcheckbox-id='" + checkboxParentId + "'" + (isChecked ? " checked='checked'" : "") + "><span>" + resultText + "</span></label></li>");
                            var $parentUl = $("");

                            if (isParent) {
                                $parent = $("<div class='fshr-list-item'><label><input type='checkbox' data-domid='" + checkboxParentDomId + "' data-checkbox-id='" + checkboxId  + "'" + (isChecked ? " checked='checked'" : "") + "><span>" + resultText + "</span></label></div>");
                                parentId = checkboxId;
                            } else if (parentId == checkboxParentId) {
                                $parentUl = $parent.find("ul");
                                if (!$parentUl.length) {
                                    var $ul = $("<ul></ul>");
                                    $ul.append($item);
                                    $parent.append($ul);
                                } else {
                                    $parentUl.append($item);
                                }
                            } else {
                                $parent = $("<div class='fshr-list-item'><label><input type='checkbox' data-domid='" + checkboxParentDomId + "' data-checkbox-id='" + checkboxParentId + "'" + (isParentChecked ? " checked='checked'" : "") + "><span>" + checkboxParentText + "</span></label><ul></ul></div>");
                                $parentUl = $parent.find("ul");
                                $parentUl.append($item);
                                parentId = checkboxParentId;
                            }

                            $result.append($parent);
                        }

                    } else {
                        $searchResult.addClass("fshr-hidden");
                    }
                } else {
                    $searchResult.addClass("fshr-hidden");
                }
                $searchResult.html("");
                $searchResult.append($result);
            }, 200);
        });
        $(document).on("click focus", function (event) {
            var $element = $(event.target);
            if (!$element.closest(".js-searchResult-wrapper").length) {
                $(".js-searchInDom").val("");
                $(".js-searchResult").html("").addClass("fshr-hidden");
            }
        });
    });
    $(document).on("change", ".js-searchResult input[type=checkbox]", function (event) {
        var $item = $(this);
        var isChecked = $item.prop("checked");
        var relatedItemId = $item.attr("data-domid");
        var $relatedItem = $("#" + relatedItemId);
        $relatedItem.prop("checked", isChecked);
        $relatedItem.trigger("change");
        $(".js-searchInDom").val("").focus();
        $(".js-searchResult").html("").addClass("fshr-hidden");
    });
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 *  show filter
 *  */
(function ($, global) {
    var escKeyCode = 27;
    var animationSpeed = 200;

    function openCloseFilter (event) {
        if (event) {
            event.preventDefault();
        }

        var $this = $(this);
        var filterSelector = $this.attr("data-filter-selector") || $this.attr("href");
        var $filter = global.getElementsBySelector(filterSelector, $this);
        var filterContentToOverlaySelector = $this.attr("data-filtercontent-selector");
        var $filterContentToOverlay = global.getElementsBySelector(filterContentToOverlaySelector, $this);
        var filterId = $filter.attr("id");
        var $filterRoot = $this.closest(".js-filter-parent");
        if ($(".js-searchResultFilters").length) {
            $filterRoot = $filter.closest(".js-filter-parent");
        }

        var $anotherOpenedFilters = $filterRoot.find(".js-filter.fshr-filter--active:not(#" + filterId + ")");
        $anotherOpenedFilters.each(function () {
            var $this = $(this);
            var id = $this.attr("id");
            var $button = $filterRoot.find(".js-showFilter[data-filter-selector='" + id + "']");
            $(".fshr-filterContentOverlay").removeClass("fshr-filterContentOverlay");
            if (!$button.length) {
                $button = $filterRoot.find(".js-showFilter[href='#" + id + "']");
            }
            $button.removeClass("fshr-button--filterActive");
            $this.removeClass("fshr-filter--active");
            $this.slideUp({
                duration: animationSpeed
            });
        });

        if ($filter.length) {
            var isActive = $filter.hasClass("fshr-filter--active");
            if (isActive) {
                $filter.stop(true, false);

                $this.removeClass("fshr-button--filterActive");
                $filter.removeClass("fshr-filter--active");
                $filter.trigger("filter-beforeclose");
                $filter.slideUp({
                    duration: animationSpeed,
                    complete: function () {
                        $filter.trigger("filter-close");
                    }
                });
                $("body").removeClass("fshr-filterIsOpened");
                $filterContentToOverlay.removeClass("fshr-filterContentOverlay");
            } else {
                $filter.stop(true, false);
                $filterContentToOverlay.addClass("fshr-filterContentOverlay");
                $this.addClass("fshr-button--filterActive");
                $filter.addClass("fshr-filter--active");
                $("body").addClass("fshr-filterIsOpened");
                var $tabs = $filter.find(".fshr-tabs");
                var $tabContent = $filter.find(".fshr-tabContent.fshr-tabContent--active");
                if (!$tabContent.length) {
                    $tabContent = $filter;
                }

                var $filterFooter = $filter.find(".fshr-filter-footer");
                var $contentBox = $filter.find(".fshr-tabContent-item");
                var $filterWindow = $filter.find(".js-filter-window");
                var $tabsNavigation = $filter.find(".fshr-tabsNavigation");
                var $searchHelper = $filter.find(".fshr-searchHelper");
                var filterWindowPaddingBottom = parseInt($filterWindow.css("padding-bottom"), 10);
                var bottomMargin = 25;
                $filter.trigger("filter-beforeopen");
                var $window = $(window);
                $filter.slideDown({
                    duration: animationSpeed,
                    complete: function () {
                        $filter.find(".js-searchInDom").focus();
                        $filter.trigger("filter-open");
                    },
                    step: function () {
                        if ($this.is("[data-filter-viewportheight]")) {
                            $tabContent.each(function () {
                                var $tab = $(this);
                                $contentBox = $tab.find(".fshr-tabContent-item");
                                $searchHelper = $tab.find(".fshr-searchHelper");
                                $filterFooter = $tab.find(".fshr-filter-footer");
                                var contentBoxPadding = parseInt($contentBox.css("padding-top"), 10) + parseInt($contentBox.css("padding-bottom"), 10);
                                var viewportHeight = $window.outerHeight();
                                var contentBoxOffsetTop = ($searchHelper.offset().top + $searchHelper.outerHeight()) - $window.scrollTop();
                                var filterFooterHeight = $filterFooter.outerHeight(true);
                                var contentBoxHeight = viewportHeight - filterFooterHeight - contentBoxOffsetTop - contentBoxPadding - filterWindowPaddingBottom - bottomMargin;
                                $contentBox.css({
                                    maxHeight: contentBoxHeight
                                });
                            });
                        }
                    }
                });
            }

        }
    }

    function closeFilter ($this) {
        var filterSelector = $this.attr("data-filter-selector") || $this.attr("href");
        var $filter = global.getElementsBySelector(filterSelector, $this);
        var filterContentToOverlaySelector = $this.attr("data-filtercontent-selector");
        var $filterContentToOverlay = global.getElementsBySelector(filterContentToOverlaySelector, $this);
        if ($filter.length && $filter.is(".fshr-filter--active")) {
            $filter.stop(true, false);

            $this.removeClass("fshr-button--filterActive");
            $filter.removeClass("fshr-filter--active");
            $filterContentToOverlay.removeClass("fshr-filterContentOverlay");
            $filter.trigger("filter-beforeclose");
            $filter.slideUp({
                duration: animationSpeed,
                complete: function () {
                    $filter.trigger("filter-close");
                }
            });
        }
        $("body").removeClass("fshr-filterIsOpened");
    }
    function closeFilters (event) {
        if (event) {
            event.preventDefault();
        }

        $(".fshr-filterIsOpened .js-showFilter").each(function () {
            $("body").removeClass("fshr-filterIsOpened");
            closeFilter($(this));
        });
    }

    function setFilterContentHeight ($filter) {
        if (global.widths.window <= global.widths.tablet) {
            var filterContentMargin = 0;
            var $filterHeader = $filter.find(".fshr-filter-header");
            var $filterContent = $filter.find(".fshr-filter-content");
            var $filterPseudoContent = $filterContent.find(".js-filterPseudoContent");
            var $filterContentTabNavigation = $filterContent.find(".fshr-tabsNavigation");
            var $filterFooter = $filter.find(".fshr-filter-footer");
            var $filterWrapper = $filter.find(".fshr-filter-wrapper");
            var $filterAddContent = $filter.find(".fshr-addContent");
            var filterWrapperHeight = $filterWrapper.height();
            var filterAddContent = $filterAddContent.outerHeight() || 0;
            var filterHeaderHeight = $filterHeader.outerHeight();
            var filterFooterHeight = $filterFooter.outerHeight();

            var heightForFilterContent = filterWrapperHeight - filterHeaderHeight - filterFooterHeight - filterContentMargin - filterAddContent;
            if (!$filterPseudoContent.length) {
                $filterContent.height(heightForFilterContent);
            } else {
                $filterPseudoContent.height(heightForFilterContent - $filterContentTabNavigation.outerHeight() || 0);
            }
        }
    }

    $(document).on("click", ".js-menuSearch-content .js-showFilter", function (event) {
        event.preventDefault();
        var $trigger = $(this);
        if (!$trigger.is(".fshr-button--filterActive")) {
            var $scrollToElement = $(".fshr-searchMenu");
            var $fixed = $(".js-fixedMenu");
            var scrollTo = $scrollToElement.offset().top - $fixed.outerHeight();
            window.scrollTo(0, scrollTo);
        }
        $trigger.each(openCloseFilter);
    });
    $(document).on("click", ".fshr-termins-filter .js-showFilter", openCloseFilter);
    $(document).on("click", ".js-filterClose", closeFilters);

    $(document).on("filter-open", ".js-filter", function () {
        var $filter = $(this);
        setFilterContentHeight($filter);
    });

    $(window).on("orientationchange",function(){
        var $filter = $(".fshr-filter--active");
        setFilterContentHeight($filter);
    });

    $(document).on("keyup", function (event) {
        var keyCode = event.keyCode;
        if (keyCode == escKeyCode) {
            closeFilters();
        }
    });

    $(document).on("mousedown", function (event) {
        var $target = $(event.target);

        var isInsideCalendar = $target.closest(".ui-datepicker-header").length || $target.is(".js-calendars-controls");
        var isInsideFilter = $target.closest(".js-filter").length;
        var isInsideFilterButton = $target.closest(".js-showFilter").length;
        var isInsideOpenFilter = $target.closest(".js-openFilter").length;
        var isSearchWhisperer = $target.closest(".js-isSearchWhisperer").length;
        var isInsideChat = $target.closest("#daktela-chat-head").length;

        if (!isInsideFilter && !isInsideFilterButton && !isInsideCalendar && !isSearchWhisperer && !isInsideChat && !isInsideOpenFilter) {
            closeFilters();
        }
    });

    $(document).on("tab-open", ".js-tabContent", function () {
        var $tab = $(this);
        var $filter = $tab.closest(".js-filter");
        if ($filter.length && $filter.is("[data-filter-viewportheight]")) {
            var $contentBox = $tab.find(".fshr-tabContent-item");
            var $filterFooter = $tab.find(".fshr-filter-footer");
            var $window = $(window);
            var $filterWindow = $filter.find(".js-filter-window");
            var filterWindowPaddingBottom = parseInt($filterWindow.css("padding-bottom"), 10);
            var bottomMargin = 25;
            var $searchHelper = $tab.find(".fshr-searchHelper");
            var contentBoxPadding = parseInt($contentBox.css("padding-top"), 10) + parseInt($contentBox.css("padding-bottom"), 10);
            var viewportHeight = $window.outerHeight();
            var contentBoxOffsetTop = ($searchHelper.offset().top + $searchHelper.outerHeight()) - $window.scrollTop();
            var filterFooterHeight = $filterFooter.outerHeight(true);
            var contentBoxHeight = viewportHeight - filterFooterHeight - contentBoxOffsetTop - contentBoxPadding - filterWindowPaddingBottom - bottomMargin;
            $contentBox.css({
                maxHeight: contentBoxHeight
            });
        }
    });
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 *  open filter after click sticky bar
 *  */
(function ($, global) {
    function openFilter (id, seasonType) {
        var $menuSearchContent = $(".js-menuSearch-content").filter(seasonType);
        var $filterButton = $menuSearchContent.find("a[href='" + id + "']");

        if ($filterButton.length) {

            $filterButton.click();
        }
    }

    $("body").on("menu-height-changed-finish", function () {
        var $menuSearch = $(".js-menuSearch.fshr-searchMenu--selected");
        var $menuSearchContent = $(".js-menuSearch-content.fshr-searchMenu--selected");
        if ($menuSearchContent.is(":visible")) {
            var filterId = $menuSearch.attr("data-filterid");
            if (filterId) {
                var seasonType = $menuSearch.attr("data-menusearch-type");
                openFilter(filterId, seasonType);
            }
        } else {
            $menuSearch.removeAttr("data-filterid");
        }
    });

    function handleFilterAndMenu ($menuSearch, filterId) {
        var seasonType = $menuSearch.attr("data-menusearch-type");
        var $menuSearchContent = $(".js-menuSearch-content").filter(seasonType);

        if (!$menuSearchContent.is(":visible")) {

            /* POKUD NENÍ MENU ROZVINUTÉ DĚLEJ NĚCO */
            $menuSearch.click();
            $menuSearch.attr("data-filterid", filterId);

        } else if (filterId) {

            /* POKUD JIŽ MENU JE ROZVINUTÉ DĚLEJ NĚCO JINÉHO */

            openFilter(filterId, seasonType);

        }
    }

    $(document).on("click", ".js-openFilter", function (event) {
        event.preventDefault();

        /* NASTAVI PROMENNE */
        var $trigger = $(this);
        var menuSelector = $trigger.attr("data-filtermenu-selector");
        var filterId = $trigger.attr("data-filtertoopenid") || $trigger.attr("href");
        var scrollTop = $trigger.is("[data-scrolltop]");
        var searchMenuLauncher = $(".js-searchMenuLauncher");

        /* menu search je  tlačítko na které když klikneme rozvine se vyheldávání */
        var $menuSearch = global.getElementsBySelector(menuSelector, $trigger);


        if (scrollTop) {
            window.scrollTo(0, 0);
        }

        /* Otevře hlavní menu */
        if(!searchMenuLauncher.parent().hasClass("fshr-active")){
            searchMenuLauncher.click();
            setTimeout(function () {
                /* předá k handlování */
                handleFilterAndMenu($menuSearch, filterId);
            },500);
        }else{
            /* předá k handlování */
            handleFilterAndMenu($menuSearch, filterId);
        }



    });
})(jQuery, globalWrapper.fshr);




/**
 *  popup window
 *  */
(function ($, global) {
    var KEYCODE_ESC = 27;
    var ANIMATION_DURATION = 200;
    var CLASS_JS_POPUPWINDOW = "js-popupWindow";
    var CLASS_JS_POPUPWINDOW_OVERLAY = "js-popupWindow-overlay";
    var CLASS_JS_POPUPWINDOW_SHOW = "js-popupWindow--show";
    var CLASS_JS_POPUPWINDOW_CLOSE = "js-popupWindow--close";
    var CLASS_JS_POPUPWINDOW_CONTENT = "js-popupWindow-content";
    var CLASS_JS_EVENTSTART_OUTSIDE = "js-eventStart--outside";

    function setPosition ($popupWindow) {
        var $window = $(window);
        var $parent = $popupWindow.parent();
        var padding = $parent.outerHeight() - $parent.height();
        var windowHeight = $window.outerHeight() - padding;
        var popupHeight = $popupWindow.outerHeight();
        if (windowHeight < popupHeight) {
            var currentScrollTop = $window.scrollTop();
            var isScrolledDown = global.actualScrollTop < currentScrollTop;
            var scrollDifference = currentScrollTop - global.actualScrollTop;
            global.actualScrollTop = currentScrollTop;
            var minimumTopMargin = windowHeight-popupHeight;
            var maximumTopMargin = 0;
            var actualTopMargin = parseInt($popupWindow.css("margin-top"));
            var newTopMargin = actualTopMargin - scrollDifference;

            if (isScrolledDown) {
                if (newTopMargin < minimumTopMargin) {
                    newTopMargin = minimumTopMargin;
                }
            } else {
                if (newTopMargin > maximumTopMargin) {
                    newTopMargin = maximumTopMargin;
                }
            }

            $popupWindow.css("margin-top", newTopMargin);
        } else {
            $popupWindow.css("margin-top", 0);
        }
    }

    function showPopupWindow (event) {
        event.preventDefault();
        var $popupWindowCaller = $(this);
        var dynamicLoad = $popupWindowCaller.attr("data-dynamicLoad") || false;
        var windowSelector = $popupWindowCaller.attr("data-popupwindow-selector") || $popupWindowCaller.attr("href");
        var $popupWindow = global.getElementsBySelector(windowSelector, $popupWindowCaller);
        if ($popupWindow.length) {
            closePopupWindows();
            global.popup.open($popupWindow);

            // dynamické načítání popupu
            if(dynamicLoad){

                var id = $popupWindowCaller.attr("data-dynamicLoad-id") || "common";
                var loadedId = $popupWindow.find(".js-popupload-destination").attr("data-dynamicLoad-id");
                if($(".js-calendarBar").length > 0){
                    var startDate = $(".js-calendarBar").attr("data-datebar-start-selected");
                    var endDate = $(".js-calendarBar").attr("data-datebar-end-selected");
                    dynamicLoad = dynamicLoad + "&terminOd=" + startDate + "&terminDo=" + endDate;
                }

                if(id !== loadedId){
                    $popupWindow.find(".js-popupWindow").addClass("fshr-loadingPopup");

                    $.get(dynamicLoad, function(data){
                        if("html" in data && data.html.length > 0 && "status" in data && data.status==1){
                            setTimeout(function(){
                                $popupWindow.find(".js-popupload-destination").html(data.html);
                                $popupWindow.find(".js-popupload-destination").attr("data-dynamicLoad-id", id);
                                $popupWindow.find(".js-popupWindow").removeClass("fshr-loadingPopup");
                                $popupWindow.find(".js-tooltip").each(global.initializeQtip);
                                //$popupWindow.trigger("scrollbarWidths");
                                //$popupWindow.trigger("addPriceListListeners");
                                $popupWindow.trigger("add-scrollers");
                            }, 500);
                        }else{
                            $popupWindow.find(".js-popupload-destination").html("Omlouváme se. Obsah se nepodařilo načíst.");
                        }
                    }).fail(function(e){
                        $popupWindow.find(".js-popupload-destination").html("Omlouváme se. Obsah se nepodařilo načíst.");
                        console.log("Failed to load popup");
                    });
                }
            }


        }
    }
    function remotePopupClick () {
        var $remotePopupClick = $(".js-popupWindow-overlay.js-remoteClick");
        $remotePopupClick.each(function () {
            var $remoteClick = $(this);
            if ($remoteClick.length) {
                var itemSelector = $remoteClick.attr("data-remote-selector");
                $(itemSelector).trigger("click");
                $remoteClick.removeClass("js-remoteClick");
                $remoteClick.removeAttr("data-remote-selector");
            }
        });
        $(document).off("cookie-set", remotePopupClick);
    }
    function closePopupWindows (event) {
        if (event) {
            event.preventDefault();
        }

        var $body = $("body");
        var $visiblePopups = $(".js-popupWindow:visible");
        if ($visiblePopups.length) {
            $visiblePopups.trigger("popup-close");
            var $ajaxMessages = $visiblePopups.find(".js-ajaxResultMessage");
            $ajaxMessages.each(function () {
                var $message = $(this);
                $message.html("");
                $message.removeClass("fshr-ajaxResultMessage--success fshr-ajaxResultMessage--error");
            });
        }
        var $remotePopupClick = $visiblePopups.closest(".js-remoteClick");
        if ($remotePopupClick) {
            $($remotePopupClick.attr("data-remote-selector")).trigger("click");
        }
        $body.removeClass("fshr-popupWindow--opened");
        $("." + CLASS_JS_POPUPWINDOW_OVERLAY).fadeOut({
            duration: ANIMATION_DURATION
        });
    }
    global.popup.close = closePopupWindows;

    function setPopupWindowContentHeight($popupWindow) {
        var $popupHeader = $popupWindow.find(".fshr-popupWindow-header");
        var $popupFooter = $popupWindow.find(".fshr-popupWindow-footer");
        var $popupContent = $popupWindow.find(".fshr-popupWindow-content");
        var $popupWindowCenter = $popupWindow.closest(".fshr-popupWindow-center");

        var padding = $popupWindow.outerHeight() - $popupWindow.height() + $popupWindowCenter.outerHeight() - $popupWindowCenter.height();

        var headerHeight = $popupHeader.outerHeight();
        var footerHeight = $popupFooter.outerHeight(true);

        var contentHeight = $(window).outerHeight() - headerHeight - footerHeight - padding;
        $popupContent.height(contentHeight);
    }

    $(document).on("click touchend", "." + CLASS_JS_POPUPWINDOW_SHOW, showPopupWindow);
    $(document).on("click touchstart", "." + CLASS_JS_POPUPWINDOW_CLOSE, closePopupWindows);
    $(document).on("mousedown touchstart", "." + CLASS_JS_POPUPWINDOW_OVERLAY, function (event) {
        var $overlayItem = $(this);
        var $target = $(event.target);
        var isInsidePopup = $target.closest("." + CLASS_JS_POPUPWINDOW).length;
        if (!isInsidePopup) {
            $overlayItem.addClass(CLASS_JS_EVENTSTART_OUTSIDE);
        } else {
            $overlayItem.removeClass(CLASS_JS_EVENTSTART_OUTSIDE);
        }
    });
    $(document).on("click touchend", "." + CLASS_JS_POPUPWINDOW_OVERLAY, function (event) {
        var $popup = $(this);
        var $target = $(event.target);
        var isInsidePopup = $target.closest("." + CLASS_JS_POPUPWINDOW).length;
        if (!isInsidePopup && $popup.hasClass(CLASS_JS_EVENTSTART_OUTSIDE)) {
            $popup.removeClass(CLASS_JS_EVENTSTART_OUTSIDE);
            closePopupWindows();
        }
    });
    $(document).on("keyup", function (event) {
        var keyCode = parseInt(event.keyCode, 10);
        if (keyCode === KEYCODE_ESC) {
            closePopupWindows();
        }
    });
    $(window).on("scroll", function () {
        $("." + CLASS_JS_POPUPWINDOW + ":not(.js-popupWindow--scrollInside):visible").each(function () {
            setPosition($(this));
        });
    });
    $(window).on("resize", function () {
        $("." + CLASS_JS_POPUPWINDOW + ":visible").each(function () {
            var $popupWindow = $(this);
            if (!$popupWindow.is(".js-popupWindow--scrollInside")) {
                $popupWindow.css("margin-top", 0);
                setPosition($popupWindow);
                global.popup.scrollable($popupWindow);
            } else {
                setPopupWindowContentHeight($popupWindow);
            }
        });
    });
    $(document).on("popup-afteropen", "." + CLASS_JS_POPUPWINDOW + ":visible", function () {
        var $popupWindow = $(this);
        if (!$popupWindow.is(".js-popupWindow--scrollInside")) {
            global.popup.scrollable($popupWindow);
        } else {
            setPopupWindowContentHeight($popupWindow);
        }
    });
    $(document).on("ready", function () {
        var hash = window.location.hash.replace("#/", "").replace("#", "");

        if (hash && hash.search("&")==-1) {
            var $popupWindow = $("#" + hash + ".js-popupWindow-overlay");
            if ($popupWindow.length) {
                global.popup.open($popupWindow);
            }
        }
    });
})(jQuery, globalWrapper.fshr);



/* TO DISABLE */
/**
 * cascade checkboxes
 * */
(function ($, global) {
    var CLASS_JS_CHECKBOXESCASCADE = "js-cascadeCheckboxes";

    function handleInputsMapItem (inputsMap, checkboxId, parentId, checked) {
        $.each(inputsMap, function (id, element) {
            if (typeof checkboxId !== "undefined" && checkboxId && checkboxId == element.parentId) {
                element.checked = checked;
                handleInputsMapItem(inputsMap, id, element.parentId, checked);
            }
            if (typeof parentId !== "undefined" && parentId && parentId == id) {
                var allChildrenAreChecked = true;
                $.each(inputsMap, function (childrenId, childrenElement) {
                    if (childrenElement.parentId == parentId) {
                        if (!childrenElement.checked) {
                            allChildrenAreChecked = false;
                            return false;
                        }
                    }
                });
                element.checked = allChildrenAreChecked;
                handleInputsMapItem(inputsMap,null,element.parentId,element.checked);
            }
        });
    }
    function createInputsMap ($root, $modifiedCheckbox) {
        var inputsMap = {};
        var modifiedCheckboxId = $modifiedCheckbox.attr("data-checkbox-id");
        var modifiedCheckboxParentId = $modifiedCheckbox.attr("data-parentcheckbox-id");
        var $inputs = $root.find("input.fshr-form-input[type=checkbox]:not(:disabled)");

        $inputs.each(function () {
            var $input = $(this);

            var checkboxId = $input.attr("data-checkbox-id");

            var parentId = $input.attr("data-parentcheckbox-id");
            var checked = $input.prop("checked");
            var elementId = $input.attr("id");

            if (modifiedCheckboxId == checkboxId) {
                checked = $modifiedCheckbox.prop("checked");
            }
            inputsMap[checkboxId] = {
                parentId: parentId,
                checked: checked,
                elementId: elementId,
                $input: $input,
                handled: false
            };

        });

        handleInputsMapItem(inputsMap, modifiedCheckboxId, modifiedCheckboxParentId, $modifiedCheckbox.prop("checked"));

        return inputsMap;
    }

    /*
    function handleParentCheckboxChange ($checkbox, $root) {
        var checkboxId = $checkbox.attr("data-checkbox-id");
        if (checkboxId) {
            var $childrenCheckboxes = $root.find("input[data-parentcheckbox-id='" + checkboxId + "']:not(:disabled)");
            var currentCheckedState = $checkbox.prop("checked");
            $childrenCheckboxes.prop("checked", currentCheckedState);
            var $elements = $childrenCheckboxes.add($checkbox);
            var $checked = global.checkSameCheckbox($elements);
            $checked.each(function () {
                var $input = $(this);
                var parentId = $input.attr("data-checkbox-id");
                var inputState = $input.prop("checked");
                $root.find("input[type=checkbox][data-parentcheckbox-id='" + parentId + "']:not(:disabled)").prop("checked", inputState);
            });
        }
    }
    function handleChildrenCheckboxChange ($checkbox, $root) {
        var checkboxId = $checkbox.attr("data-parentcheckbox-id");
        if (checkboxId) {
            var $parentCheckbox = $root.find("input[data-checkbox-id='" + checkboxId + "']:not(:disabled)");
            var $childrenCheckboxes = $root.find("input[data-parentcheckbox-id='" + checkboxId + "']:not(:disabled)");
            var $checkedChildren = $childrenCheckboxes.filter("input:checked");
            var allChildrenAreChecked = $childrenCheckboxes.length == $checkedChildren.length;
            $parentCheckbox.prop("checked", allChildrenAreChecked);
            var $elements = $parentCheckbox.add($checkbox);
            var $checked = global.checkSameCheckbox($elements);
            $checked.each(function () {
                var $input = $(this);
                var parentId = $input.attr("data-parentcheckbox-id");
                var $parentInput = $root.find("input[type=checkbox][data-checkbox-id='" + parentId + "']:not(:disabled)");
                var $inputChildren = $root.find("input[type=checkbox][data-parentcheckbox-id='" + parentId + "']:not(:disabled)");
                var $checkedInputChildren = $inputChildren.filter("input:checked");
                if ($inputChildren.length == $checkedInputChildren.length) {
                    $parentInput.prop("checked", true);
                } else {
                    $parentInput.prop("checked", false);
                }
            });
        }
    }*/
    function handleCascadeCheckboxes (event) {

        var $checkbox = $(this);
        var $root = $checkbox.closest("." + CLASS_JS_CHECKBOXESCASCADE);

        var map = createInputsMap($root, $checkbox);

        $.each(map, function (id, element) {
            element.$input.prop("checked", element.checked);
            if (element.$input.attr("data-item-id")) {
                global.checkSameCheckbox(element.$input);
            }
        });

        //handleParentCheckboxChange($checkbox, $root);
        //handleChildrenCheckboxChange($checkbox, $root);


        if (event.type !== "reset-change") {
            $checkbox.closest("." + CLASS_JS_CHECKBOXESCASCADE).trigger("cascade-change-finished");
        }

    }
    $(document).on("change custom-change", "." + CLASS_JS_CHECKBOXESCASCADE + " input[type=checkbox]", handleCascadeCheckboxes);
    $(document).on("reset-change", "." + CLASS_JS_CHECKBOXESCASCADE + " input[type=checkbox]", handleCascadeCheckboxes);

})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 * value to element
 * */
(function ($, global) {
    function pushToArrayIfNecessary (array, valueToPush) {
        if ($.inArray(valueToPush, array) === -1) {
            array.push(valueToPush);
        }
        return array;
    }
    function getSelectInputValue ($selectInput) {
        var value = $selectInput.attr("data-value-to-element");
        if (!value && $selectInput.is("select")) {
            var $selectedOptions = $selectInput.find("option:selected");
            value = [];
            $selectedOptions.each(function () {
                var $selectedOption = $(this);
                var optionValue = $selectedOption.attr("data-value-to-element") || $selectedOption.attr("data-value") || $selectedOption.attr("value") || $selectedOption.html();
                value.push(optionValue);
            });
        };
        if (!value && !$selectInput.is("select")) {
            value = $selectInput.parent().text();
        }
        if (!value) {
            value = $selectInput.val();
        }

        if (value instanceof Array) {
            value = value.join(", ");
        }
        return value;
    }
    function getElementValue ($element) {
        var value = "";
        if ($element.is("select") || $element.is(":checked")) {
            value = getSelectInputValue($element);
        }

        if ($element.is("input:not([type=checkbox])") && $element.is("input:not([type=radio])") && !$element.is(".js-calendar-value")) {
            value = $element.val();
        }

        if (!$element.is("select") && !$element.is("input")) {
            var $formElements = $element.find("input:checked, select");
            var valueArray = [];
            var excludedArray = [];
            var parentsCheckboxIds = {};
            $formElements.each(function () {
                var $formElement = $(this);
                if (!$formElement.is(".js-valueToElement-exclude")) {
                    var isCustomSelect = $formElement.is("select.js-custom-select");
                    var isSelect = $formElement.is("select");
                    var isCustomMultipleSelect = false;
                    var isExcludedIfOthers = $formElement.is("[data-value-to-element-exclude]");

                    var onlyThis = $formElement.is("[data-value-to-element-only]");
                    if (onlyThis) {
                        valueArray = [];
                    }

                    if (isCustomSelect) {
                        isCustomMultipleSelect = $formElement.prop("multiple");
                    }
                    var isCascadeCheckbox = $formElement.is("input[data-parentcheckbox-id]") || $formElement.is("input[data-checkbox-id]");
                    var value = getSelectInputValue($formElement).trim();
                    if (isCascadeCheckbox) {
                        var parentCheckboxId = $formElement.attr("data-parentcheckbox-id");
                        var checkboxId = $formElement.attr("data-checkbox-id");
                        if (parentCheckboxId) {
                            if (!parentsCheckboxIds[parentCheckboxId]) {
                                if (!isExcludedIfOthers) {
                                    valueArray = pushToArrayIfNecessary(valueArray, value);
                                } else {
                                    excludedArray = pushToArrayIfNecessary(excludedArray, value);
                                }
                            }
                        } else if (checkboxId) {
                            if (!isExcludedIfOthers) {
                                valueArray = pushToArrayIfNecessary(valueArray, value);
                            } else {
                                excludedArray = pushToArrayIfNecessary(excludedArray, value);
                            }
                        }
                        if (checkboxId) {
                            parentsCheckboxIds[checkboxId] = true;
                        }
                    } else if (!isCustomMultipleSelect ) {
                        if (!isExcludedIfOthers) {
                            valueArray = pushToArrayIfNecessary(valueArray, value);
                        } else {
                            excludedArray = pushToArrayIfNecessary(excludedArray, value);
                        }
                    } else if (isSelect) {
                        var $selectedOption = $formElement.find("option:selected");
                        isExcludedIfOthers = $selectedOption.is("[data-value-to-element-exclude]");
                        onlyThis = $selectedOption.is("[data-value-to-element-only]");
                        if (!isExcludedIfOthers) {
                            valueArray = pushToArrayIfNecessary(valueArray, value);
                        } else {
                            excludedArray = pushToArrayIfNecessary(excludedArray, value);
                        }
                    }
                    if (onlyThis) {
                        return false;
                    }
                }
            });
            if (!valueArray.length) {
                valueArray = excludedArray;
            }
            value = valueArray.join(", ");
        }


        if ($element.is(".js-calendar-value")) {
            value = $.datepicker.formatDate("dd.mm.y", new Date(global.createDateObjectFromString($element.val())));
        }
        if ($element.is(".js-datepicker")) {
            value = $.datepicker.formatDate("dd.mm.y", $element.datepicker("getDate"));
        }
        if (value === null || !value.length) {
            value = "Nerozhoduje";
        }
        return value;
    }
    function handleValues ($element, data) {
        var value = "";
        var elementsCountSelector = data["dom-count-selector"];
        var valueSuffix = data["suffix"];
        var valueElementSelector = data["selector"];
        if (elementsCountSelector) {
            var $elementsForCount = $element.find(elementsCountSelector);
            value = $elementsForCount.length + "";
            var $selects = $elementsForCount.filter("select");
            if ($selects.length) {
                value = 0;
                $selects.each(function () {
                    var $select = $(this);
                    var selectValue = parseInt($select.val());
                    if (!isNaN(selectValue)) {
                        value = value + selectValue;
                    }
                });
            }
        } else {
            value = getElementValue($element);
        }
        value = value + "";

        if (valueSuffix && (value.toLowerCase() != "nerozhoduje")) {
            value = value + " " + global.getProperSuffix(value, valueSuffix);
        }
        if (valueElementSelector) {
            var $valueElement = global.getElementsBySelector(valueElementSelector, $element);
            $valueElement.text(value);
            $valueElement.trigger("custom-value-changed");
        }
    }
    $(document).on("change input select-change fshr-modification reset-change dom-change date-change value-change", ".js-value-to-element", function (event) {
        var $element = $(this);
        var elementsCountSelector = $element.attr("data-value-to-element-dom-count-selector") || "";
        var valueElementSelector = $element.attr("data-value-to-element-selector") || "";
        var valueSuffix = $element.attr("data-value-to-element-suffix") || "";

        var datas = [{
            "dom-count-selector": elementsCountSelector,
            "suffix": valueSuffix,
            "selector": valueElementSelector
        }];

        var multipleDatas = $element.attr("data-value-to-element");

        if (global.isJSON(multipleDatas)) {
            datas = JSON.parse(multipleDatas);
        }

        for (var index = 0, datasCount = datas.length; index < datasCount; index++) {
            handleValues($element, datas[index]);
        }
    });
})(jQuery, globalWrapper.fshr);



/**
 *  select to html
 *  */
(function ($, global) {
    var KEYCODE_ESC = 27;

    var selectCount = 0;

    var CLASS_CSS_ITEM = "fshr-select-item";
    var CLASS_CSS_OPTIONS = "fshr-select-options";
    var CLASS_CSS_OPTIONS_WRAPPER = "fshr-select-optionsWrapper";
    var CLASS_CSS_OPTION = "fshr-select-option";
    var CLASS_CSS_OPTION_GROUPED = "fshr-option--grouped";
    var CLASS_CSS_OPTION_SELECTED = "fshr-select-option--selected";
    var CLASS_CSS_OPTION_LABEL = "fshr-select-option-label";
    var CLASS_CSS_ITEM_DEFAULTSELECTED = "fshr-selected-by-default";
    var CLASS_CSS_CHECKBOX = "fshr-select-checkbox";
    var CLASS_CSS_OPTGROUP = "fshr-select-optgroup";
    var CLASS_CSS_OPTGROUP_LABEL = "fshr-select-optgroup-label";
    var CLASS_CSS_SELECT_STYLED = "fshr-select--styled";
    var CLASS_CSS_SELECT_FAKE = "fshr-select--fake";
    var CLASS_CSS_VALUE = "fshr-select-value";
    var CLASS_CSS_CONTROLS = "fshr-select-controls";
    var CLASS_CSS_CONTROLS_LINK = "fshr-select-controls-link";
    var CLASS_CSS_BUTTON = "fshr-button";
    var CLASS_CSS_BUTTONIMPORTANCE = "fshr-button--commonImportance";

    var CLASS_JS_SELECT = "js-selectCustom";
    var CLASS_JS_SELECT_OPTION = "js-option";
    var CLASS_JS_SELECT_OPEN = "js-select--open";
    var CLASS_JS_SELECT_VALUE = "js-select-value";
    var CLASS_JS_SELECT_DISABLED = "js-select--disabled";
    var CLASS_JS_SELECT_ITEM = "js-select-item";
    var CLASS_JS_SELECT_HANDLER = "js-select-handler";
    var CLASS_JS_SELECT_OPTGROUP = "js-select-optgroup";
    var CLASS_JS_SELECT_WRAPPER = "js-select-wrapper";
    var CLASS_JS_SELECT_FAKE = "js-select-fake";
    var CLASS_JS_VALUETOELEMENT = "js-value-to-element";
    var CLASS_JS_OPTIONS_WRAPPER = "js-select-optionsWrapper";
    var CLASS_JS_CONTROLS = "js-select-controls";
    var CLASS_JS_SELECTALL = "js-select-all";
    var CLASS_JS_SELECTNOTHING = "js-select-nothing";
    var CLASS_JS_SELECTCONFIRM = "js-select-confirm";

    var CLASS_JS_CHECKBOXESCASCADE = "js-cascadeCheckboxes";

    function optionsToHtml ($children, isMultiple, selectItemId) {
        var $optionsHtml = $("<ul class='" + CLASS_CSS_OPTIONS + (isMultiple ? " " + CLASS_JS_CHECKBOXESCASCADE : "") + "'></ul>");
        $children.each(function () {
            selectItemId = selectItemId + 1;
            var $selectChildren = $(this);
            var isDefault = (typeof $selectChildren.attr("data-select-default") !== "undefined");
            var isChangeDefault = (typeof $selectChildren.attr("data-change-detection-default") !== "undefined");
            $selectChildren.attr("data-id", selectItemId);
            var isHidden = $selectChildren.attr("data-optionhidden") || false;
            var liClasses = [CLASS_JS_SELECT_ITEM];
            if (isDefault) {
                liClasses.push(CLASS_CSS_ITEM_DEFAULTSELECTED);
            }
            var customClasses = $selectChildren.attr("class") || "";
            if (customClasses) {
                liClasses.push(customClasses);
            }
            var $selectChildrenHtml = $("<li class='" + liClasses.join(" ") + "'></li>");
            if (isHidden) {
                $selectChildrenHtml.hide();
            }
            var checkbox = "";
            var isSelected = $selectChildren.prop("selected");
            if (isMultiple) {
                var id = selectCount + selectItemId + new Date().getTime();
                var definedCheckboxId = $selectChildren.attr("data-checkbox-id");
                var cascadeCheckboxId = definedCheckboxId || id;
                var attrDataCheckboxId = ' data-checkbox-id="' + cascadeCheckboxId + '"';
                if (definedCheckboxId) {
                    $selectChildrenHtml.addClass(CLASS_CSS_OPTION_GROUPED);
                }


                var attrDataParentCheckboxId = "";
                var cascadeParentCheckboxId = $selectChildren.attr("data-parentcheckbox-id");
                if (cascadeParentCheckboxId) {
                    attrDataParentCheckboxId = ' data-parentcheckbox-id="' + cascadeParentCheckboxId + '"';
                }
                checkbox = "<input id='inputId" + id + "' type='checkbox'" + attrDataCheckboxId + attrDataParentCheckboxId + " class='" + CLASS_CSS_CHECKBOX + " fshr-form-input'" + (isChangeDefault ? " data-change-detection-default" : "") + (isSelected ? " checked='checked'" : "") + ">";
            } else if (isSelected) {
                $selectChildrenHtml.addClass(CLASS_CSS_OPTION_SELECTED);
            }
            $selectChildrenHtml.attr("data-id", selectItemId);
            if ($selectChildren.attr("data-season-only")) {
                $selectChildrenHtml.attr("data-season-only", $selectChildren.attr("data-season-only"));
            }
            if (isDefault) {
                $selectChildrenHtml.attr("data-select-default", isDefault);
            }
            if (isChangeDefault) {
                $selectChildrenHtml.attr("data-change-detection-default", isChangeDefault);
            }
            $selectChildrenHtml.addClass(CLASS_CSS_ITEM + " " + CLASS_JS_SELECT_ITEM);
            if ($selectChildren.is("option")) {
                var optionValue = $selectChildren.attr("data-value") || $selectChildren.val();
                var optionText = $selectChildren.text();
                $selectChildrenHtml.addClass(CLASS_CSS_OPTION + " " + CLASS_JS_SELECT_OPTION);
                $selectChildrenHtml.attr("data-value", optionValue);
                $selectChildrenHtml.html("<label class='" + CLASS_CSS_OPTION_LABEL + " " + CLASS_JS_SELECT_HANDLER + (isMultiple ? " fshr-form-label--checkbox" : "") + "'>" + checkbox + "<span" + (isMultiple ? " class='fshr-form-label-item'" : "") + ">" + optionText + "</span>" + "</label>");
            } else {
                var optgroupValue = $selectChildren.attr("label");
                $selectChildrenHtml.addClass(CLASS_CSS_OPTGROUP + " " + CLASS_JS_SELECT_OPTGROUP);
                $selectChildrenHtml.html("<label class='" + CLASS_CSS_OPTGROUP_LABEL + "'>" + checkbox + optgroupValue + "</label>");
                var $optgroupChildren = optionsToHtml($selectChildren.children(), isMultiple, (selectItemId * 10));
                $selectChildrenHtml.append($optgroupChildren);
            }
            $optionsHtml.append($selectChildrenHtml);
        });
        return $optionsHtml;
    }
    function selectToHtml () {
        selectCount = selectCount++;
        var $select = $(this);
        var isMultiple = $select.prop("multiple");
        var $children = $select.children();
        var index = 0;
        var valueId = $select.attr("data-select-value-id") || "";
        var selectClass = $select.attr("class").replace(CLASS_JS_SELECT, "").replace(CLASS_JS_VALUETOELEMENT, "");

        $select.wrap("<div class='" + CLASS_CSS_SELECT_STYLED + " " + CLASS_JS_SELECT_WRAPPER + " "+ selectClass + (isMultiple ? " fshr-select-multiple" : "") + "'></div>");
        $select.after("<div class='" + CLASS_CSS_SELECT_FAKE + " " + CLASS_JS_SELECT_FAKE + "'></div>");
        var $pseudoSelect = $select.parent().find("." + CLASS_JS_SELECT_FAKE);

        var $optionsWrapper = $("<div class='" + CLASS_CSS_OPTIONS_WRAPPER + " " + CLASS_JS_OPTIONS_WRAPPER + "'></div>");
        $optionsWrapper.append(optionsToHtml($children, isMultiple, index));
        $pseudoSelect.prepend($optionsWrapper);


        var additionalClasses = $select.attr("data-select-class");
        if (!additionalClasses) {
            additionalClasses = "";
        }
        $pseudoSelect.prepend("<div" + (valueId ? " id='" + valueId +"'" : "") + " class='" + CLASS_CSS_VALUE + " " + CLASS_JS_SELECT_VALUE + " " + additionalClasses + "'></div>");

        var $checkedParentCheckboxes = $optionsWrapper.find("." + CLASS_JS_CHECKBOXESCASCADE + " input[type=checkbox][data-checkbox-id]:checked");
        if ($checkedParentCheckboxes.length) {
            $checkedParentCheckboxes.each(function () {
                var $parentCheckbox = $(this);
                var id = $parentCheckbox.attr("data-checkbox-id");
                $optionsWrapper.find("input[type=checkbox][data-parentcheckbox-id=" + id + "]").prop("checked", true);
            });
        }
        updateValue($select);
        updateHtmlDisabled($select);

        if (isMultiple) {
            var $controlsFooter = $("<div class='" + CLASS_CSS_CONTROLS + " " + CLASS_JS_CONTROLS + "'><a href='#' class='" + CLASS_JS_SELECTALL + " " + CLASS_CSS_CONTROLS_LINK + "'>" + global.localization.select.all + "</a> <a href='#' class='" + CLASS_JS_SELECTNOTHING + " " + CLASS_CSS_CONTROLS_LINK + "'>" + global.localization.select.nothing + "</a> <a href='#' class='" + CLASS_JS_SELECTCONFIRM + " " + CLASS_CSS_BUTTON + " " + CLASS_CSS_BUTTONIMPORTANCE + "'>OK</a></div>");
            $optionsWrapper.append($controlsFooter);
            var valueToElementExclude = $select.is(".js-valueToElement-exclude");
            if (valueToElementExclude) {
                $pseudoSelect.find("input").addClass("js-valueToElement-exclude");
            }
        }
        $select.addClass("js-selectGenerated");
        $select.trigger("select-generated");
    }
    global.selectToHtml = selectToHtml;
    function updateValue ($select) {
        var $root = $select.parents("." + CLASS_JS_SELECT_WRAPPER);
        var $value = $root.find("." + CLASS_JS_SELECT_VALUE);
        var $selectedOptions = $select.find("option:not(:disabled):selected");
        if (!$selectedOptions.length) {
            $selectedOptions = $select.find("option:first-child");
        }
        var valueText = [];
        $selectedOptions.each(function () {
            valueText.push($(this).text());
        });
        if (valueText instanceof  Array) {
            valueText = valueText.join(", ");
        }
        $value.text(valueText);
    }
    function updateHtmlDisabled ($object) {
        var isDisabled = $object.prop("disabled");
        var $root = $object.parents("." + CLASS_JS_SELECT_WRAPPER);
        var $fakeSelect = $root.find("." + CLASS_JS_SELECT_FAKE);

        if (isDisabled) {
            $fakeSelect.addClass(CLASS_JS_SELECT_DISABLED);
        } else {
            $fakeSelect.removeClass(CLASS_JS_SELECT_DISABLED);
        }
    }
    function handleInputsAfterChange () {
        var $this = $(this);
        var $rootParent = $this.closest("." + CLASS_JS_SELECT_WRAPPER);
        var $select = $rootParent.find("." + CLASS_JS_SELECT);
        var $checkedInputs = $rootParent.find("input:checked:not(:disabled)");
        $select.find("option").prop("selected", false);
        $checkedInputs.each(function () {
            var $this = $(this);
            var id = $this.closest("." + CLASS_JS_SELECT_ITEM).attr("data-id");
            var $properOption = $select.find("option[data-id=" + id + "]");
            var cascadeParentCheckboxId = $this.attr("data-parentcheckbox-id");
            if (cascadeParentCheckboxId) {
                var $parentCheckbox = $rootParent.find("input[data-checkbox-id=" + cascadeParentCheckboxId + "]:not(:disabled)");
                if ($parentCheckbox.prop("checked")) {
                    $properOption.prop("selected", false);
                } else {
                    $properOption.prop("selected", true);
                }
            } else {
                $properOption.prop("selected", true);
            }
        });
        if (!$checkedInputs.filter(":checked").length) {
            $select.find("option[data-select-default]").prop("selected", true);
        }
        $select.trigger("select-change");
    }
    function handleOptionClick ($this, dontTrigger) {
        if ((typeof $this === "undefined") || ("type" in $this)) {
            $this = $(this);
        }
        var $rootParent = $this.closest("." + CLASS_JS_SELECT_WRAPPER);
        var $select = $rootParent.find("." + CLASS_JS_SELECT);
        var isMultiple = $select.prop("multiple");
        var isCheckboxHandler = $select.is(".js-selectToCheckbox");
        if (!isMultiple) {
            var $parent = $this.closest("." + CLASS_JS_SELECT_ITEM);
            var id = $parent.attr("data-id");
            var $properOption = $select.find("[data-id=" + id + "]");
            if (!isCheckboxHandler) {
                var isSelected = $properOption.prop("selected");

                $rootParent.find("." + CLASS_CSS_OPTION_SELECTED).removeClass(CLASS_CSS_OPTION_SELECTED);
                $parent.addClass(CLASS_CSS_OPTION_SELECTED);

                if (!isSelected) {
                    $properOption.prop("selected", !isSelected);
                }
            } else {
                var checkboxId = $properOption.attr("data-checkbox-id");
                if (typeof checkboxId !== "undefined") {
                    $properOption.prop("selected", false);
                    var selector = $select.attr("data-checkboxes-selector") || "";
                    var $checkboxes = global.getElementsBySelector(selector, $select);
                    var $validCheckbox = $checkboxes.filter("[data-checkbox-id='" + checkboxId + "']");
                    $validCheckbox.prop("checked", true);
                    $validCheckbox.trigger("change");
                }
            }
        }
        if (!dontTrigger) {
            $select.trigger("select-change");
            $select.trigger("change");
        }
    }
    function getPositionGaps ($root) {
        var gaps = {
            top: 0,
            bottom: 0
        };

        var $window = $(window);
        var viewPortHeight = $window.height();
        var $selectValue = $root.find("." + CLASS_JS_SELECT_VALUE);
        var scrollTop = $window.scrollTop();

        var selectValueTop = 0;
        var selectValueHeight = 0;

        if ($selectValue.length) {
            selectValueTop = $selectValue.offset().top - scrollTop;
            selectValueHeight = $selectValue.outerHeight();
        }

        gaps.top = selectValueTop;
        gaps.bottom = viewPortHeight - (selectValueTop + selectValueHeight);

        return gaps;
    }
    function handleFakeSelectClick (event) {
        var $this = $(this);
        var $root = $this.parents("." + CLASS_JS_SELECT_WRAPPER);
        var $controls = $root.find("." + CLASS_JS_CONTROLS);
        var $select = $root.find("." + CLASS_JS_SELECT);
        var isMultiple = $select.prop("multiple");
        var rootIndex = $root.index();
        var viewportEdgeGapZone = 15;
        if ($root.length) {
            if ($root.hasClass(CLASS_JS_SELECT_OPEN)) {
                if (!isMultiple) {
                    $root.removeClass(CLASS_JS_SELECT_OPEN);
                } else if (typeof event !== "undefined") {
                    var $target = $(event.target);
                    if ($target.closest("." + CLASS_JS_SELECT_VALUE).length || $target.hasClass(CLASS_JS_SELECT_VALUE)) {
                        $root.removeClass(CLASS_JS_SELECT_OPEN);
                    }
                }
            } else {
                closeStyledSelects(rootIndex);
                $root.addClass(CLASS_JS_SELECT_OPEN);

                var gaps = getPositionGaps($root);
                var controlsHeight = 0;
                if ($controls.length) {
                    controlsHeight = $controls.outerHeight();
                }
                var maxHeight = gaps.bottom - viewportEdgeGapZone - controlsHeight;
                var $options = $root.find("." + CLASS_CSS_OPTIONS);
                var optionsHeight = $options.outerHeight();

                $options.css({
                    maxHeight: ""
                });
                $options.css({
                    maxHeight: maxHeight
                });
                if (optionsHeight > maxHeight) {
                    $options.addClass("fshr-contentScrolled");
                } else {
                    $options.removeClass("fshr-contentScrolled");
                }
            }
        }
    }
    function closeStyledSelects (exceptIndex) {
        var $elements = $("." + CLASS_JS_SELECT_WRAPPER + "." + CLASS_JS_SELECT_OPEN);
        if (typeof exceptIndex !== "undefined") {
            $elements.removeClass(CLASS_JS_SELECT_OPEN);
        } else {
            $elements.not(":eq(" + exceptIndex + ")").removeClass(CLASS_JS_SELECT_OPEN);
        }
        $elements.trigger("select-closed");
    }
    function setCheckboxChecked ($checkboxes, newCheckedState) {
        //var $root = $checkboxes.closest("." + CLASS_JS_SELECT_WRAPPER);
        //var $select = $root.find("select");
        //var $options = $select.find("option:not([data-select-default])");
        //var $defaultOptions = $select.find("option[data-select-default]");
        //$options.prop("selected", newCheckedState);
        //$defaultOptions.prop("selected", !newCheckedState);
        $checkboxes.prop("checked", newCheckedState);
        $checkboxes.first().trigger("cascade-change-finished");
        /*
        $select.trigger("select-change");
        $select.closest(".js-change-detection").trigger("change-detected");
            */
    }
    function handleSelectAllClick (event) {
        event.preventDefault();
        var $this = $(this);
        var $parent = $this.closest("." + CLASS_JS_OPTIONS_WRAPPER);
        var $checkboxes = $parent.find(".js-select-item:not(.fshr-selected-by-default)").find("input[type=checkbox]:not(:disabled)");
        setCheckboxChecked($checkboxes, true);
    }
    function handleSelectNothingClick (event) {
        event.preventDefault();
        var $this = $(this);
        var $parent = $this.closest("." + CLASS_JS_OPTIONS_WRAPPER);
        var $checkboxes = $parent.find("input[type=checkbox]");
        setCheckboxChecked($checkboxes, false);
    }
    function updateOptionsVisibility ($select) {
        var $options = $select.find("option");
        var $parent = $select.closest("." + CLASS_JS_SELECT_WRAPPER);
        var $fakeOptions = $parent.find("." + CLASS_JS_SELECT_ITEM);
        $options.each(function () {
            var $option = $(this);
            var optionId = $option.attr("data-id");
            var isHidden = $option.is("[data-optionhidden]");
            var $currentFakeOption = $fakeOptions.filter("[data-id='" + optionId + "']");
            if (isHidden) {
                $currentFakeOption.hide();
            } else {
                $currentFakeOption.show();
            }
        });
    }


    $(document).on("change reset-change select-change select-generated", "select." + CLASS_JS_SELECT, function (event) {
        var $select = $(this);

        var $optionClick = $select;
        var isMultiple = $select.prop("multiple");
        var $parent = $select.closest("." + CLASS_JS_SELECT_WRAPPER);
        if (!isMultiple) {
            var $selectedOption = $select.find("option:selected");
            var id = $selectedOption.attr("data-id");
            var $handleOption = $parent.find("." + CLASS_JS_SELECT_ITEM + "[data-id='" + id + "'] ." + CLASS_JS_SELECT_HANDLER);
            if ($handleOption.length) {
                $optionClick = $handleOption;
            }
        }
        if ($select.is(".js-selectFilterOptions")) {
            var filteredSelectSelector = $select.attr("data-selectfilter-selector") || "";
            var $filteredSelect = global.getElementsBySelector(filteredSelectSelector, $select);
            if ($filteredSelect.length && $selectedOption) {
                var filterId = $selectedOption.attr("data-selectFilter");
                var $filteredSelectOptions = $filteredSelect.find("option");
                var filteredOptionsCount = $filteredSelectOptions.length;
                for (var index = 0; index < filteredOptionsCount; index++) {
                    var $option = $($filteredSelectOptions[index]);
                    var optionFilterId = $option.attr("data-selectFilter");
                    var isSelected = $option.prop("selected");
                    if (optionFilterId && filterId) {
                        if (optionFilterId == filterId) {
                            $option.removeAttr("data-optionhidden");
                            $option.show();
                            $option.prop("selected", isSelected);
                        } else {
                            $option.attr("data-optionhidden", "true");
                            $option.hide();
                            $option.prop("selected", false);
                        }
                    } else {
                        $option.removeAttr("data-optionhidden");
                        $option.show();
                        $option.prop("selected", isSelected);
                    }
                }
                $filteredSelect.trigger("change");
                updateOptionsVisibility($filteredSelect);
            }
        }
        handleOptionClick($optionClick, true);
        updateValue($select);
        updateHtmlDisabled($select);
    });

    $(document).on("cascade-change-finished", "." + CLASS_JS_SELECT_WRAPPER + " ." + CLASS_JS_CHECKBOXESCASCADE, handleInputsAfterChange);
    $(document).on("click", "." + CLASS_CSS_OPTIONS + "." + CLASS_JS_CHECKBOXESCASCADE + " ." + CLASS_JS_SELECT_HANDLER, function () {
        $(this).closest("." + CLASS_JS_SELECT_WRAPPER).addClass("js-select--modifiedByUser");
    });
    $(document).on("click", "." + CLASS_CSS_OPTIONS + ":not(." + CLASS_JS_CHECKBOXESCASCADE + ") ." + CLASS_JS_SELECT_HANDLER, handleOptionClick);
    $(document).on("click", "." + CLASS_JS_SELECT_FAKE + ":not(." + CLASS_JS_SELECT_DISABLED + ")", handleFakeSelectClick);
    $(document).on("click", "." + CLASS_JS_SELECTALL, handleSelectAllClick);
    $(document).on("click", "." + CLASS_JS_SELECTNOTHING, handleSelectNothingClick);
    $(document).on("click", function (event) {
        var $target = $(event.target);
        var isSelectConfirm = $target.closest("." + CLASS_JS_SELECTCONFIRM).length;
        var closeSelects = !$target.closest("." + CLASS_JS_SELECT_WRAPPER).length;
        if (isSelectConfirm) {
            event.preventDefault();
            closeSelects = true;
        }
        var isInsideChat = $target.closest("#daktela-chat-head").length;
        if (closeSelects && !isInsideChat) {
            closeStyledSelects();
        }
    });
    $(document).on("keyup", function (event) {
        var keyCode = event.keyCode;
        if (keyCode == KEYCODE_ESC) {
            closeStyledSelects();
        }
    });
    // for modifications event
    $(document).on("fshr-modification", "select." + CLASS_JS_SELECT, function () {
        var $this = $(this);
        updateValue($this);
        updateHtmlDisabled($this);
    });

    $(document).on("initialize-custom-selects", function (e, element) {
        if(element){
            $(element).find("select." + CLASS_JS_SELECT).each(selectToHtml);
        }else{
            $("select." + CLASS_JS_SELECT).each(selectToHtml);
        }

    });

    $(document).trigger("initialize-custom-selects");

})(jQuery, globalWrapper.fshr);




/* TO DISABLE */
/**
 * Datepicker
 * Inicializace - Element pro datepicker se inicializuje na elementu s třídou .js-datepicker
 * Atributy elementu
 * @data-datepicker-mindate = řetězec minimálního data, které pro datepicker jde zadat viz dokumentace jquery ui datepicker
 * @data-datepicker-trigger-selector = selector elementu, do kterého se vypíše vybraná hodnota datepickeru
 * @data-datepicker-setmindate-for-selector = vybraná hodnota data se pro element s tímto selectorem nastaví jako minimální datum
 * @data-datepicker-setmindate-days = přičte počet dní k aktulnímu datu a nastaví jej jako minimální datum pro setmindate-for-selector
 * @data-datepicker-range-selector = selector elementu pro který se nastavuje min-max rozsah data
 * @data-datepicker-range-min = počet dní do minulosti o který se může maximálně lišit element z range-selector oproti aktuálnímu datu datepickeru
 * @data-datepicker-range-max = počet dní do budoucnosti o který se může maximálně lišit element z range-selector oproti aktuálnímu datu datepickeru
 * @data-datepicker-start-selector = selector datepickeru pro počáteční datum - není-li uvedeno bere se aktuální (aktivní) element
 * @data-datepicker-end-selector = selector datepickeru pro koncové datum - není-li uvedeno bere se aktuální (aktivní) element
 * @data-datepicker-days-selector = selector elementu ve kterém se má zobrazit počet dní (datum z end-selector minus datum ze start-selector)
 * */
(function ($, global) {
    var day = "day";
    var month = "month";
    var year = "year";
    $.datepicker.setDefaults(global.localization.calendar);
    var datePickerOptions = {
        changeMonth: true,
        changeYear: true,
        selectOtherMonths: true,
        showOtherMonths: true,
        dateFormat: 'dd.mm.yy D',
        minDate: global.dates.minimum,
        maxDate: global.dates.maximum,
        onClose: function () {
            $(".js-remote-blur").removeClass("js-remote-blur");
        },
        onSelect: function (value, instance) {
            var $object = $(this);
            var mindateForSelector = $object.attr("data-datepicker-setmindate-for-selector");
            var $mindateForElement = global.getElementsBySelector(mindateForSelector, $object);
            var mindateDaysDifference = parseInt($object.attr("data-datepicker-setmindate-days"), 10) || 0;

            $mindateForElement.each(function () {
                var $this = $(this);
                var minimumDate = new Date(instance.selectedYear, instance.selectedMonth, parseInt(instance.selectedDay, 10) + mindateDaysDifference);
                $this.datepicker("option", "minDate", minimumDate);
                updateValue($this);
                $this.trigger("change");
            });

            var dateForSelector = $object.attr("data-datepicker-setdate-for-selector");
            var $dateForElement = global.getElementsBySelector(dateForSelector, $object);
            var dateDaysDifference = parseInt($object.attr("data-datepicker-setdate-days"), 10) || 0;

            if (dateDaysDifference) {
                $dateForElement.each(function () {
                    var $this = $(this);
                    var date = new Date(instance.selectedYear, instance.selectedMonth, parseInt(instance.selectedDay, 10) + dateDaysDifference);
                    $this.datepicker("setDate", date);
                    updateValue($this);
                    $this.trigger("change");
                });
            }

            if (!$object.closest(".js-resetInProgress").length) {
                setRangeIfNecessary($object);
            }

            updateValue($object);
            setDaysCountValue($object);


            var defaultDate = parseInt($object.attr("data-datepicker-defaultdate-after-initialize"), 10);
            var currentDate = $object.datepicker("getDate").getTime();
            if (defaultDate !== currentDate) {
                $object.addClass("js-datepicker-is-modified");
            } else {
                $object.removeClass("js-datepicker-is-modified");
            }

            var $parent = $object.closest(".js-change-detection");
            if ($parent.length) {
                $parent.trigger("change-detected");
            }
            if ($object.is("#filter-return-date") || $object.is("#filter-departure-date") || $object.is("#filter-return-date-detail") || $object.is("#filter-departure-date-detail")) {
                //global.daysCountRestrictions($object);
            }
            $object.trigger("change");
            global.hideAllContent();
        }
    };

    function setDaysCountValue ($object) {
        var valueToSelector = $object.attr("data-datepicker-days-selector");
        var daysCountReturned = 0;
        if (valueToSelector) {
            valueToSelector = valueToSelector.split(";");
            if (valueToSelector.length) {
                $.each(valueToSelector, function (index, selector) {
                    var $valueToElement = global.getElementsBySelector(selector, $object);

                    if ($valueToElement.length) {
                        var startDateSelector = $object.attr("data-datepicker-start-selector") || "";
                        var $startDateElement = global.getElementsBySelector(startDateSelector, $object);
                        if (!$startDateElement.length) {
                            $startDateElement = $object;
                        }
                        var endDateSelector = $object.attr("data-datepicker-end-selector") || "";
                        var $endDateElement = global.getElementsBySelector(endDateSelector, $object);
                        if (!$endDateElement.length) {
                            $endDateElement = $object;
                        }

                        var daysCount = global.getDaysCountAndMiliseconds($startDateElement.datepicker("getDate"), $endDateElement.datepicker("getDate")).daysCount;

                        var suffix = global.getProperSuffix(daysCount, global.localization.nights.join(","));
                        $valueToElement.text(daysCount + " " + suffix);
                        daysCountReturned = daysCount;
                    }
                })
            }
        }
        return daysCountReturned;
    }
    function updateValue ($object, noInput) {
        var dateFormat = $object.datepicker("option", "dateFormat");
        var currentDate = $object.datepicker("getDate");
        var value = $.datepicker.formatDate(dateFormat, currentDate);

        var triggerSelector = $object.attr("data-datepicker-trigger-selector");
        var $trigger = global.getElementsBySelector(triggerSelector, $object);

        if ($trigger.length) {
            $trigger.text(value);
        }

        if (typeof noInput === "undefined") {
            updateInput($object);
        }

        return value;
    }
    global.updateValue = updateValue;
    function updateInput ($datepicker) {
        var inputSelector = $datepicker.attr("data-input-selector");
        if (inputSelector) {
            var $input = global.getElementsBySelector(inputSelector, $datepicker);

            if ($input.length) {
                var dateFormat = $input.data("data-input-format") || "yy-mm-dd";
                var currentDate = $datepicker.datepicker("getDate");
                var value = $.datepicker.formatDate(dateFormat, currentDate);

                $input.val(value);
                $input.trigger("change");
            }
        }
    }
    function setRangeIfNecessary ($object) {
        var rangeMaximumDays = parseInt($object.attr("data-datepicker-range-max"), 10) || 0;
        var rangeMinimumDays = parseInt($object.attr("data-datepicker-range-min"), 10) || 0;
        var setRangeForSelector = $object.attr("data-datepicker-range-selector");
        var $setRangeForElement = global.getElementsBySelector(setRangeForSelector, $object);

        if (((rangeMaximumDays > 0) || (rangeMinimumDays > 0)) && $setRangeForElement.length) {

            var daysCountAndMiliseconds = global.getDaysCountAndMiliseconds($object.datepicker("getDate"), $setRangeForElement.datepicker("getDate"));
            var dateDifferenceDays = daysCountAndMiliseconds.daysCount;

            var currentDate = $object.datepicker("getDate");
            var setDate = $setRangeForElement.datepicker("getDate");

            var $filter = $setRangeForElement.closest(".js-filter");

            if (dateDifferenceDays < -rangeMinimumDays) {
                currentDate.setDate(currentDate.getDate() - rangeMinimumDays);
                $setRangeForElement.datepicker("setDate", currentDate);
                $setRangeForElement.trigger("change");
                var newMinValue = updateValue($setRangeForElement);

                var minimumRangeReachText = $object.attr("data-datepicker-range-min-reached-text");
                if (minimumRangeReachText) {
                    minimumRangeReachText = minimumRangeReachText.replace("%1", rangeMinimumDays);
                    minimumRangeReachText = minimumRangeReachText.replace("%2", newMinValue);
                    alert(minimumRangeReachText);
                    if (!$filter.is(":visible")) {
                        $filter.trigger("filter-close");
                    }
                }
            }
            if (dateDifferenceDays > rangeMaximumDays) {
                currentDate.setDate(currentDate.getDate() + rangeMaximumDays);
                $setRangeForElement.datepicker("setDate", currentDate);
                $setRangeForElement.trigger("change");
                var newMaxValue = updateValue($setRangeForElement);

                var maximumRangeReachText = $object.attr("data-datepicker-range-max-reached-text");
                if (maximumRangeReachText) {
                    maximumRangeReachText = maximumRangeReachText.replace("%1", rangeMaximumDays);
                    maximumRangeReachText = maximumRangeReachText.replace("%2", newMaxValue);
                    alert(maximumRangeReachText);
                    if (!$filter.is(":visible")) {
                        $filter.trigger("filter-close");
                    }
                }
            }
        }
    }
    function initializeDatePicker () {
        var $datepicker = $(this);

        var customOptions = {};
        var minDateString = $datepicker.attr("data-datepicker-mindate");
        if (minDateString) {
            customOptions.minDate = minDateString;
        }
        var defaultDateString = $datepicker.attr("data-datepicker-defaultdate");
        if (defaultDateString) {
            customOptions.defaultDate = defaultDateString;
        }

        var removeDefaultDate = $datepicker.is("[data-datepicker-nodefaultdate]");
        if (removeDefaultDate) {
            customOptions.defaultDate = null;
        }
        var newobject = $.extend(datePickerOptions, customOptions);
        $datepicker.datepicker(newobject);

        var defaultDate = $datepicker.datepicker("getDate");
        if (removeDefaultDate) {
            defaultDate = false;
            $datepicker.find(".ui-state-active").removeClass("ui-state-active");
        }
        if (defaultDate) {
            var defaultValueInMilliseconds = $datepicker.datepicker("getDate").getTime();
            $datepicker.attr("data-datepicker-defaultdate-after-initialize", defaultValueInMilliseconds);
        }
        var dateString = $datepicker.attr("data-datepicker-value");
        if (dateString && !removeDefaultDate) {
            $datepicker.datepicker("setDate", dateString);
        }

        if (dateString || (defaultDate && !removeDefaultDate)) {
            updateValue($datepicker, true);
        }

        var inputSelector = $datepicker.attr("data-input-selector");
        if (inputSelector) {
            var $input = global.getElementsBySelector(inputSelector, $datepicker);
            if ($input.length) {
                $input.val($.datepicker.formatDate("yy-mm-dd", defaultDate));
                $input.on("custom-change", function () {
                    var inputValue = $input.val();
                    var parsedDate = $.datepicker.parseDate("yy-mm-dd", inputValue);
                    var dateFormat = $datepicker.datepicker("option", "dateFormat");
                    var value = $.datepicker.formatDate(dateFormat, parsedDate);

                    $datepicker.datepicker("setDate", value);
                    $datepicker.find('.ui-datepicker-current-day').click();
                });
            }
        }

        if (!removeDefaultDate) {
            $datepicker.trigger("date-change");
        }
    }

    $(".js-datepicker").each(initializeDatePicker);
    $(document).on("fshr-modification", ".js-datepicker", function (event, object) {
        var $this = $(this);
        updateValue($this);
        setDaysCountValue($this);
    });


})(jQuery, globalWrapper.fshr);


/* TO DISABLE */
/**
 *  remote focus handler
 *  */
(function ($, global) {
    var cssClassIsFocused = "js-is-focused";

    function remoteFocus (event) {
        event.preventDefault();
        var $this = $(this);
        var elementSelector = $this.attr("data-remote-selector") || $this.attr("href");
        var $element = global.getElementsBySelector(elementSelector, $this);

        $element.trigger("focus");
        $this.addClass("js-remote-blur");
    }
    function remoteBlur (event) {
        event.preventDefault();
        var $this = $(this);
        var elementSelector = $this.attr("data-remote-selector") || $this.attr("href");
        var $element = global.getElementsBySelector(elementSelector, $this);

        $element.trigger("blur");
        $this.removeClass("js-remote-blur");
    }
    function initRemoteFocus () {
        var $this = $(this);
        var elementSelector = $this.attr("data-remote-selector") || $this.attr("href");
        var $element = global.getElementsBySelector(elementSelector, $this);

        $element.on("blur", function () {
            $this.removeClass(cssClassIsFocused);
        });
    }
    $(document).on("click", ".js-remote-focus:not(.js-remote-blur)", remoteFocus);
    $(document).on("click", ".js-remote-blur", remoteBlur);
    $(document).on("click", function (event) {
        var $target = $(event.target);
        var $focusTriggerElement = $target.closest(".js-remote-focus");
        if (!$focusTriggerElement.length) {
            $(".js-remote-blur").removeClass("js-remote-blur");
        }
    });
    $(".js-remote-focus").each(initRemoteFocus);
})(jQuery, globalWrapper.fshr);


/* TO DISABLE */
/**
 * modificators
 * */
(function ($, global) {

    function removeCssClass ($element, cssClass) {
        $element.removeClass(cssClass);
    }
    function addCssClass ($element, cssClass) {
        $element.addClass(cssClass);
    }
    function removeAttributes ($element, attributes) {
        for (var index = 0, attributesCount = attributes.length; index < attributesCount ; index++) {
            var attribute = attributes[index];
            $element.removeAttr(attribute);
        }
    }
    function addAttributes ($element, attributes) {
        for (var attribute in attributes) {
            if (attributes.hasOwnProperty(attribute)) {
                var value = attributes[attribute];
                $element.attr(attribute, value);
            }
        }
    }
    function modifyContent ($element, content) {
        $element.html(content);
    }

    function initializeModificator (event) {
        var $this = $(this);
        var eventType = event.type;
        var isDoable = true;
        var $modificatorElements = $this;
        switch (eventType) {
            case "click":
                if ($this.is("[type='radio'], [type='checkbox'], select")) {
                    isDoable = false;
                }
            break;
            case "change":
            case "select-change":
            case "reset-change":
                if ($this.is("[type='radio']") && !$this.is(":checked")) {
                    isDoable = false;
                }
                if ($this.is("select")) {
                    $modificatorElements = $this.find("option:selected");
                }
            break;
        }

        if (isDoable) {
            $modificatorElements.each(function () {
                var $modificatorElement = $(this);
                var modificators = $modificatorElement.attr("data-modificator");
                if ($modificatorElement.is("[type='checkbox']") && !$modificatorElement.is(":checked")) {
                    modificators = $modificatorElement.attr("data-modificator-unchecked");
                }
                if (typeof modificators !== "undefined") {
                    var modificatorsData = JSON.parse(modificators);
                    var attributesObjectName = "attributes";
                    var cssClassObjectName = "cssClass";

                    for (var selector in modificatorsData) {
                        if (modificatorsData.hasOwnProperty(selector)) {
                            var data = modificatorsData[selector];
                            var $element = global.getElementsBySelector(selector, $modificatorElement);
                            if ($element.length) {
                                var attributesToAdd = {};
                                var attributesToRemove = {};
                                var cssClassToAdd = "";
                                var cssClassToRemove = "";

                                if ("add" in data) {
                                    var addData = data.add;
                                    if (cssClassObjectName in addData) {
                                        cssClassToAdd = addData[cssClassObjectName];
                                    }
                                    if (attributesObjectName in addData) {
                                        attributesToAdd = addData[attributesObjectName];
                                    }
                                }
                                if ("remove" in data) {
                                    var removeData = data.remove;
                                    if (cssClassObjectName in removeData) {
                                        cssClassToRemove = removeData[cssClassObjectName];
                                    }
                                    if (attributesObjectName in removeData) {
                                        attributesToRemove = removeData[attributesObjectName];
                                    }
                                }
                                if ("content" in data) {
                                    modifyContent($element, data.content);
                                }

                                addCssClass($element, cssClassToAdd);
                                removeCssClass($element, cssClassToRemove);
                                addAttributes($element, attributesToAdd);
                                removeAttributes($element, attributesToRemove);
                            }
                        }
                    }
                    for (var modifiedSelector in modificatorsData) {
                        if (modificatorsData.hasOwnProperty(modifiedSelector)) {
                            var $modifiedElement = global.getElementsBySelector(modifiedSelector, $modificatorElement);
                            if ($modifiedElement.length) {
                                $modifiedElement.trigger("fshr-modification", {
                                    modifiedBy: $this
                                });
                            }
                        }
                    }
                }
            })
        }
    }

    $(document).on("click change select-change", ".js-modificator", initializeModificator);
    $(document).on("reset-change", ".js-change-detection .js-modificator", initializeModificator);

})(jQuery, globalWrapper.fshr);


/* TO DISABLE */
/**
 * add/remove content from template
 * */
(function ($, global) {
    function getMinMaxTemplatesCount ($template) {
        return {
            min: parseInt($template.attr("data-clone-mincount"), 10) || 0,
            max: parseInt($template.attr("data-clone-maxcount"), 10) || 0

        }
    }
    function updateTemplatesNumber ($template) {
        var $templateParent = $template.closest(".js-clone-parent") || $template.parent();
        var $templates = $templateParent.find(".fshr-cloned-template");
        var templateIndex = 0;
        $templates.each(function () {
            var $actualTemplate = $(this);
            var currentNumber = templateIndex + 1;
            $actualTemplate.attr("data-clone-index", currentNumber);
            templateIndex = templateIndex + 1;
            var $templateNumber = $actualTemplate.find(".js-cloned-position");
            if ($templateNumber) {
                $templateNumber.text(currentNumber);
            }
        });
    }
    function replaceElement ($element, replaceWith) {
        $element.replaceWith(function () {
            var $newElement = $(replaceWith, {html: $(this).html()});
            $.each(this.attributes, function (index, attribute) {
                $newElement.attr(attribute.name, attribute.value);
            });
            return $newElement;
        });
        return $element;
    }
    function replaceFormElements ($template) {
        var $pseudoSelects = $template.find(".js-templateSelect");
        var $pseudoOptions = $template.find(".js-templateOption");
        var $pseudoInputs = $template.find(".js-templateInput");
        if ($pseudoOptions.length) {
            $pseudoOptions.each(function() {
                if (!$(this).is("option")) {
                    replaceElement($(this), "<option>");
                }
            });
        }
        if ($pseudoSelects.length) {
            $pseudoSelects.each(function() {
                if (!$(this).is("select")) {
                    replaceElement($(this), "<select>");
                }
            });
            $template.find("select.js-selectCustom:not(.js-selectGenerated)").each(global.selectToHtml);
        }
        if ($pseudoInputs.length) {
            $pseudoInputs.each(function() {
                if (!$(this).is("input")) {
                    replaceElement($(this), "<input>");
                }
            });
        }
        return $template;
    }
    function addTemplates ($template) {
        var $templateParent = $template.closest(".js-clone-parent") || $template.parent();
        var $templatesInDom = $templateParent.find(".js-template-to-clone");
        var lastTemplateIndex = $templatesInDom.last().attr("data-clone-index");
        if (!lastTemplateIndex) {
            lastTemplateIndex = $templatesInDom.length;
        } else {
            lastTemplateIndex = parseInt(lastTemplateIndex, 10) + 1;
        }
        var $clonedTemplate = $template.clone();
        replaceFormElements($clonedTemplate);
        $clonedTemplate.removeAttr("id");
        $clonedTemplate.removeClass("js-default-template");
        $clonedTemplate.addClass("fshr-cloned-template");
        $clonedTemplate.attr("data-clone-index", lastTemplateIndex);
        $clonedTemplate.find("select[name]").each(function () {
            var $select = $(this);
            var name = $select.attr("name");
            name = name.replace(new RegExp("{INDEX}", "gi"), lastTemplateIndex-1);
            $select.attr("name", name);
        });
        $templateParent.append($clonedTemplate);
        var $pairedElements = $clonedTemplate.find("[data-remote-selector]");
        $pairedElements.each(function () {
            var $pairedElement = $(this);
            var remoteSelector = $pairedElement.attr("data-remote-selector");
            var eachSelectors = remoteSelector.split(",");
            var newSelectors = [];
            $.each(eachSelectors, function (index, remoteSelector) {
                var remoteSelectorArray = remoteSelector.split(" ");
                remoteSelector = ".js-template-to-clone[data-clone-index=" + lastTemplateIndex + "]";
                remoteSelectorArray.splice(remoteSelectorArray.length - 1, 0, remoteSelector);
                newSelectors.push(remoteSelectorArray.join(" "));
            });
            $pairedElement.attr("data-remote-selector", newSelectors.join(","));
        });
    }
    function handleTemplatesAdding (event, eventData) {
        event.preventDefault();
        var $cloneHandler = $(this);
        var templateSelector = $cloneHandler.attr("data-clone-template-selector") || $cloneHandler.attr("href");
        var $templates = global.getElementsBySelector(templateSelector, $cloneHandler);

        var count = (eventData && eventData.count) ? eventData.count : 1;
        $templates.each(function () {
            var $template = $(this);
            for (var index = 0; index < count; index++) {
                addTemplates($template);
                updateTemplatesNumber ($template);
                handleMinMaxRestrictions($template);
            }
        });

        $cloneHandler.trigger("custom-click");
        $templates.trigger("dom-change");
    }
    function handleTemplatesRemove (event) {
        var $this = $();
        if ("preventDefault" in event) {
            event.preventDefault();
            $this = $(this);
        } else {
            $this = event;
        }
        var templateToRemoveSelector = $this.attr("data-selector-template-to-remove") || $this.attr("href");
        if (!templateToRemoveSelector) {
            templateToRemoveSelector = "closest(.js-template-to-clone)";
        }
        var $templateToRemove = global.getElementsBySelector(templateToRemoveSelector, $this);

        if ($templateToRemove.length) {
            $templateToRemove.addClass("js-removed-from-dom");
            $this.trigger("custom-click");
            var $parentOfRemove = $templateToRemove.parent();

            // při přímém odebrání elementu (bez setTimeout) se zavřou filtry, při volání setTimeout vše funguje jak má
            setTimeout(function () {
                $templateToRemove.removeClass("fshr-cloned-template");
                updateTemplatesNumber($templateToRemove);
                handleMinMaxRestrictions($templateToRemove);
                $templateToRemove.remove();
                $parentOfRemove.trigger("dom-change");
            }, 0);
        }

    }
    global.templateRemove = handleTemplatesRemove;

    function handleMinMaxRestrictions ($template) {
        var minMaxCount = getMinMaxTemplatesCount($template);
        var maximumClonedCount = minMaxCount.max;
        var minimumClonedCount = minMaxCount.min;
        var $templateParent = $template.closest(".js-clone-parent") || $template.parent();
        var allTemplatesCount = $templateParent.find(".fshr-cloned-template").length;
        if (allTemplatesCount > minimumClonedCount) {
            $templateParent.addClass("fshr-cloned-removeable");
        } else {
            $templateParent.removeClass("fshr-cloned-removeable");
        }
        var handlerSelector = $template.attr("data-clone-handler-selector") || (".js-clone[data-clone-template-selector='#" + $template.attr("id") + "']");
        var $cloningHandler = global.getElementsBySelector(handlerSelector, $template);
        if (typeof $cloningHandler !== "undefined" && $cloningHandler.length) {
            if (allTemplatesCount === maximumClonedCount) {
                $cloningHandler.addClass("js-disabled fshr-button--disabled");
            } else {
                $cloningHandler.removeClass("js-disabled fshr-button--disabled");
            }
        }
    }
    function initializeTemplateAdding () {
        var $template = $(this);
        var clonedCount = parseInt($template.attr("data-clone-defaultcount"), 10);
        if (!clonedCount) {
            clonedCount = getMinMaxTemplatesCount($template).min;
        }
        var $templateParent = $template.closest(".js-clone-parent") || $template.parent();
        var actualTemplatesCount = $templateParent.find(".fshr-cloned-template").length;
        if (actualTemplatesCount < clonedCount) {
            for (var step = 0; step < clonedCount; step++) {
                addTemplates($template);
            }
        }
        updateTemplatesNumber($template);
        handleMinMaxRestrictions($template);
    }


    $(document).on("click", ".js-clone:not(.js-disabled)", handleTemplatesAdding);
    $(document).on("click", ".js-clone-remove", handleTemplatesRemove);
    $(".js-template-to-clone").each(initializeTemplateAdding);

})(jQuery, globalWrapper.fshr);



/* TO DISABLE */
/**
 * detect change from default state and reset to default state
 * */
(function ($, global) {
    var changeTimeoutId = 0;
    var $previousElement = $();
    function handleChangeResetButton () {
        var $element = $(this);
        if ($element.is($previousElement)) {
            clearTimeout(changeTimeoutId);
        } else {
            $previousElement = $element;
        }
        changeTimeoutId = setTimeout(function () {
            var resetButtonSelector = $element.attr("data-reset-button-selector") || ".js-clear";
            var $resetButton = $element.find(resetButtonSelector);
            var $changeStyleButton = $();
            var changeStyleButtonSelector = $element.attr("data-changestylebutton-selector");
            if (typeof changeStyleButtonSelector !== "undefined") {
                $changeStyleButton = global.getElementsBySelector(changeStyleButtonSelector, $element);
            }
            var $animateButton = $();
            var animateButtonSelector = $element.attr("data-reset-animate-selector");
            if (typeof animateButtonSelector !== "undefined") {
                $animateButton = $element.find(animateButtonSelector);
            }

            var $selectsWithDefaultOptions = $element.find("option[data-change-detection-default]").closest("select");
            var $notDefaultOptions = $selectsWithDefaultOptions.find("option:not([data-change-detection-default]):selected");
            $notDefaultOptions = $notDefaultOptions.filter(function () {
                return !$(this).closest(".js-datepicker").length;
            });
            var isNotDefaultSelect = $notDefaultOptions.length;

            var $notDefaultInputs = $element.find("input:not([data-change-detection-default]):checked");
            $notDefaultInputs = $notDefaultInputs.filter(function () {
                var $this = $(this);
                var returnValue = true;
                if ($this.is("[data-parentcheckbox-id]")) {
                    var parentId = $this.attr("data-parentcheckbox-id");
                    var $root = $this.closest(".js-cascadeCheckboxes");
                    var $parentInput = $root.find("[data-checkbox-id=" + parentId + "]:checked");
                    returnValue = !$parentInput.length;
                }

                return returnValue;
            });
            var isNotDefaultInput = $notDefaultInputs.length;

            var isNotDefaultDatepicker = $element.find(".js-datepicker-is-modified").length;

            var isNotDefaultCalendar = $element.find(".js-calendar--isModified").length;

            var domItemSelector = $element.attr("data-change-detection-dom-default-selector");
            var domItemDefaultCount = parseInt($element.attr("data-change-detection-dom-default-count"), 10);
            var isNotDefaultDom = false;

            if (domItemSelector && domItemDefaultCount) {
                var $domItems = $element.find(domItemSelector + ":not(.js-removed-from-dom)");
                isNotDefaultDom = $domItems.length !== domItemDefaultCount;
            }

            var animationSpeed = 400;
            $animateButton.stop();
            if (isNotDefaultSelect || isNotDefaultInput || isNotDefaultDatepicker || isNotDefaultDom || isNotDefaultCalendar) {
                $changeStyleButton.addClass("fshr-button--filterChanged");
                $resetButton.removeClass("disabled fshr-button--disabled");
                $animateButton.fadeIn(animationSpeed);
                $element.addClass("fshr-contentChanged");
            } else {
                $changeStyleButton.removeClass("fshr-button--filterChanged");
                $resetButton.each(function () {
                    var $button = $(this);
                    if (!$button.is(".js-stayVisible")) {
                        $button.addClass("disabled fshr-button--disabled");
                    }
                });
                $animateButton.each(function () {
                    var $button = $(this);
                    if (!$button.is(".js-stayVisible")) {
                        $button.fadeOut(animationSpeed);
                    }
                });
                $element.removeClass("fshr-contentChanged");
            }
            $resetButton.trigger("reset-button-set");
        }, 10);
    }
    function triggerChangeEvent ($element) {
        if (typeof $element !== "undefined") {
            $element = $(this);
        }
        var $parent = $element.closest(".js-change-detection");
        $parent.trigger("change-detected");
    }
    function resetSelects ($parent) {
        var $selects = $parent.find("select");
        $selects.each(function () {
            var $select = $(this);
            if ($select.is(".js-selectCustom") && $select.closest(".js-select--modifiedByUser").length) {
                $select.closest(".js-select--modifiedByUser").removeClass("js-select--modifiedByUser");
            }
            var $options = $select.find("option");
            $options.each(function () {
                var $option = $(this);
                var isDefault = $option.is("[data-change-detection-default]");
                $option.prop("selected", isDefault);
            });
            $select.trigger("reset-change");
        });
    }
    function resetRadiosAndCheckboxes ($parent) {
        var $radiosOrCheckboxes = $parent.find("input:not([data-change-detection-default]):checked, input[data-change-detection-default]:not(:checked)");
        var $defaultItems = $parent.find("input[data-change-detection-default]");
        $radiosOrCheckboxes.each(function () {
            var $radioOrCheckbox = $(this);
            var isDefault = $radioOrCheckbox.is("[data-change-detection-default]");
            $radioOrCheckbox.prop("checked", isDefault);
        });
        $defaultItems.trigger("reset-change");
        $radiosOrCheckboxes.filter(":not([data-change-detection-default])").trigger("reset-change");
        var $cascadeCheckboxes = $parent.find(".js-cascadeCheckboxes");
        if (!$cascadeCheckboxes.length) {
            $cascadeCheckboxes = $parent.closest(".js-cascadeCheckboxes");
        }
        $cascadeCheckboxes.trigger("cascade-change-finished");
    }
    function resetDatepickers ($parent) {
        var $datepickers = $parent.find(".js-datepicker-is-modified");
        $datepickers.each(function () {
            var $datepicker = $(this);
            $datepicker.datepicker("setDate", new Date(parseInt($datepicker.attr("data-datepicker-defaultdate-after-initialize"), 10)));
            $datepicker.find(".ui-state-active").trigger("click");
        });
        $datepickers.trigger("reset-change");
    }
    function resetDom ($parent) {
        var $domResets = $parent.filter("[data-change-detection-dom]");

        $domResets.each(function () {
            var $domReset = $(this);
            var defaultCount = parseInt($domReset.attr("data-change-detection-dom-default-count")) || 0;
            var defaultSelector = $domReset.attr("data-change-detection-dom-default-selector");

            var $actualInDom = $domReset.find(defaultSelector);
            var actualInDomCount = $actualInDom.length;
            var needRemove = (actualInDomCount > defaultCount);
            var needAdd = (actualInDomCount < defaultCount);
            var difference = Math.abs(actualInDomCount - defaultCount);

            if (needRemove) {
                var minimumCount = actualInDomCount-difference;
                for (var removeIndex = actualInDomCount-1; minimumCount !== removeIndex; removeIndex--) {
                    var elemToRemove = $actualInDom[removeIndex];
                    elemToRemove.parentNode.removeChild(elemToRemove);
                }
                global.templateRemove($actualInDom.eq(minimumCount));
            }
            if (needAdd) {
                var addSelector = $domReset.attr("data-change-detection-dom-add-selector");
                var $addControl = $domReset.find(addSelector);
                for (var addIndex = 0; addIndex < difference; addIndex++) {
                    $addControl.click();
                }
            }
        });



    }
    function resetCalendars ($parent) {
        var $calendars = $parent.find(".js-calendar--isModified");
        $calendars.trigger("regenerate-calendar");
    }
    function resetChanges (event) {
        event.preventDefault();
        var $element = $(this);
        var $parent = $element.closest(".js-change-detection");
        var resetButtonSelector = $parent.attr("data-reset-button-selector") || ".js-clear";
        var $animateButton = $();
        var animateButtonSelector = $parent.attr("data-reset-animate-selector");
        if (typeof animateButtonSelector !== "undefined") {
            $animateButton = $parent.find(animateButtonSelector);
        }

        $parent.addClass("js-resetInProgress");
        resetDom($parent);
        setTimeout(function () {
            resetDatepickers($parent);
            resetSelects($parent);
            resetRadiosAndCheckboxes($parent);
            resetCalendars($parent);
            $parent.removeClass("js-resetInProgress");
            $parent.trigger("change-detected");
            $parent.trigger("data-reseted");
            $animateButton.fadeOut(400);
        }, 0);
        $parent.find(resetButtonSelector).addClass("disabled fshr-button--disabled");
        var changeStyleButtonSelector = $parent.attr("data-changestylebutton-selector");
        if (typeof changeStyleButtonSelector !== "undefined") {
            var $changeStyleButton = global.getElementsBySelector(changeStyleButtonSelector, $parent);
            $changeStyleButton.removeClass("fshr-button--filterChanged");
        }
    }

    function initGlobalReset () {
        var $button = $(this);
        var changeDetectionSelector = $button.attr("data-globalreset-selector") || "closest(.js-tabContent)";
        var $changeDetectionElement = global.getElementsBySelector(changeDetectionSelector, $button);

        $changeDetectionElement.on("reset-button-set", function () {
            var $clearButtons = $changeDetectionElement.find(".js-clear");
            var allDisabled = !$clearButtons.filter(":not(.fshr-button--disabled)").length;
            if (allDisabled) {
                $button.addClass("disabled fshr-button--disabled");
            } else {
                $button.removeClass("disabled fshr-button--disabled");
            }
        });
    }

    var selectorSelects = ".js-change-detection select:not(.js-modification-reseted)";
    var selectorDom = ".js-change-detection[data-change-detection-dom]";
    var selectorInputs = ".js-change-detection:not(.js-cascadeCheckboxes) input:not(.fshr-select-checkbox)";
    var selectorCascadeCheckboxes = ".js-change-detection .js-cascadeCheckboxes:not(.fshr-select-options), .js-change-detection.js-cascadeCheckboxes:not(.fshr-select-options)";

    $(document).on("change select-change", selectorSelects, triggerChangeEvent);
    $(document).on("dom-change", selectorDom, triggerChangeEvent);
    $(document).on("change", selectorInputs, triggerChangeEvent);
    $(document).on("cascade-change-finished", selectorCascadeCheckboxes, triggerChangeEvent);

    $(document).on("change-detected", ".js-change-detection", handleChangeResetButton);
    $(document).on("click", ".js-clear", resetChanges);

    $(".js-globalClear").each(initGlobalReset);
    $(document).on("click", ".js-globalClear", function (event) {
        event.preventDefault();
        var $button = $(this);
        var changeDetectionSelector = $button.attr("data-globalreset-selector") || "closest(.js-tabContent)";
        var $changeDetectionElement = global.getElementsBySelector(changeDetectionSelector, $button);

        $changeDetectionElement.find(".js-clear").trigger("click");
    });
})(jQuery, globalWrapper.fshr);



/* TO DISABLE */
/**
 * button as checkbox
 * */
(function ($, global) {
    function handleButtonAsCheckbox () {
        var $input = $(this);
        var $button = $input.closest(".js-buttonAsCheckbox");
        if ($input.is(":checked")) {
            $button.addClass("fshr-button--iconActive");
        } else {
            $button.removeClass("fshr-button--iconActive");
        }
    }
    $(document).on("change reset-change", ".js-buttonAsCheckbox input", handleButtonAsCheckbox);
    $(".js-buttonAsCheckbox").each(handleButtonAsCheckbox);
})(jQuery, globalWrapper.fshr);



/* TO DISABLE */
/**
 * bar as checkboxes
 * */
(function ($, global) {
    function handleBarAsCheckboxes () {
        var $currentInput = $(this);
        var $parent = $currentInput.closest(".js-barAsCheckboxParent");
        var isInputChecked = true;
        var checkedStatus = true;
        $currentInput.addClass("current-input");
        var $allInputs = $parent.find("input");
        $allInputs.each(function () {
            var $input = $(this);

            if (isInputChecked) {
                $input.prop("checked", checkedStatus);
            }
            if ($input.hasClass("current-input")) {
                checkedStatus = false;
            }
            if (!isInputChecked) {
                $input.prop("checked", checkedStatus);
            }
        });
        $currentInput.removeClass("current-input");
    }
    $(document).on("change", ".js-barAsCheckbox input", handleBarAsCheckboxes);
    $(document).on("change reset-change", ".js-barAsCheckbox input", function () {
        var $currentInput = $(this);
        var $parent = $currentInput.closest(".js-barAsCheckboxParent");
        var checkedInputsCount = $parent.find("input:checked").length;
        if (checkedInputsCount) {
            $parent.addClass("fshr-someChecked");
        } else {
            $parent.removeClass("fshr-someChecked");
        }
    });
    $(document).on("mouseover", ".js-barAsCheckbox", function () {
        var $actualItem = $(this);
        var $parent = $actualItem.closest(".js-barAsCheckboxParent");
        var $allItems = $parent.find(".js-barAsCheckbox");
        $actualItem.addClass("current-item");
        var addClass = true;
        $allItems.each(function () {
            var $item = $(this);
            if (addClass) {
                $item.addClass("fshr-hovered");
            } else {
                $item.removeClass("fshr-hovered");
            }
            if ($item.hasClass("current-item")) {
                addClass = false;
            }
        });
        $actualItem.removeClass("current-item");
    });
    $(document).on("mouseout", ".js-barAsCheckbox", function () {
        var $parent = $(this).closest(".js-barAsCheckboxParent");
        $parent.find(".fshr-hovered").removeClass("fshr-hovered");
    });
    $(document).on("click", ".js-barAsCheckbox-clear", function () {
        var $parent = $(this).parent();
        var $inputs = $parent.find("input");
        $inputs.prop("checked", false);
        $parent.find(".fshr-someChecked").removeClass("fshr-someChecked");
        $parent.trigger("change");
        $parent.closest(".js-change-detection").trigger("change-detected");
    });
})(jQuery, globalWrapper.fshr);


/* TO DISABLE */
/**
 * slider
 * */
(function ($, global) {
    function setProperOption ($options, currentIndex) {
        $options.prop("selected", false);
        $options.eq(currentIndex).prop("selected", true);
    }

    $(".js-slider").each(function () {
        var $slider = $(this);
        var textFormatAsIs = $slider.is("[data-textAsIs]");
        var $sliderParent = $slider.closest(".js-sliderParent");
        var $minimumSelect = $sliderParent.find(".js-sliderMinimumValue");
        var $maximumSelect = $sliderParent.find(".js-sliderMaximumValue");
        var sliderStep = 1;
        var sliderMinimum = 0;
        var sliderMaximum = $maximumSelect.find("option").length - 1;
        var currentMinimumIndex = $minimumSelect.find("option:selected").index() || sliderMinimum;
        var currentMaximumIndex = $maximumSelect.find("option:selected").index() || sliderMinimum;
        var sliderValueMinimumText = $minimumSelect.val();
        var sliderValueMaximumText = $maximumSelect.val();
        var sliderValueMinimum = parseInt(sliderValueMinimumText, 10);
        var sliderValueMaximum = parseInt(sliderValueMaximumText, 10);
        var sliderCurrency = $slider.attr("data-currency") || "Kč";
        $slider.slider({
            range: true,
            min: sliderMinimum,
            max: sliderMaximum,
            step: sliderStep,
            values: [currentMinimumIndex, currentMaximumIndex],
            slide: function (event, ui) {
                var optionIndexMinimum = ui.values[0];
                var $minimumOptions = $minimumSelect.find("option");
                setProperOption($minimumOptions, optionIndexMinimum);
                var minimumValue = $minimumSelect.val();
                var $minimumTooltip = $slider.find(".js-sliderTooltip-minimum .js-sliderTooltip-value");
                var minimumHtml = global.formatNumberAsPrice(parseInt(minimumValue, 10)) + " " + sliderCurrency;
                if (textFormatAsIs) {
                    minimumHtml = minimumValue;
                }
                $minimumTooltip.html(minimumHtml);

                var optionIndexMaximum = ui.values[1];
                var $maximumOptions = $maximumSelect.find("option");
                setProperOption($maximumOptions, optionIndexMaximum);
                var maximumValue = $maximumSelect.val();
                var $maximumTooltip = $slider.find(".js-sliderTooltip-maximum .js-sliderTooltip-value");
                var maximumHtml = global.formatNumberAsPrice(parseInt(maximumValue, 10)) + " " + sliderCurrency;
                if (textFormatAsIs) {
                    maximumHtml = maximumValue;
                }

                $slider.trigger("sliderSet", [minimumValue, maximumValue]);

                $maximumTooltip.html(maximumHtml);

                $slider.closest(".js-change-detection, .js-domFilter, .js-searchResultFilters").trigger("change-detected");
            },
            create: function (event, ui) {
                var minimumHtml = global.formatNumberAsPrice(sliderValueMinimum) + " " + sliderCurrency;
                var maximumHtml = global.formatNumberAsPrice(sliderValueMaximum) + " " + sliderCurrency;
                if (textFormatAsIs) {
                    minimumHtml = sliderValueMinimumText;
                    maximumHtml = sliderValueMaximumText;
                }
                var $minimumTooltip = $("<div class='fshr-sliderTooltip fshr-sliderTooltip--minimum js-sliderTooltip-minimum'><span class='js-sliderTooltip-value fshr-sliderTooltip-value'>" + minimumHtml + "</span></div>");
                var $maximumTooltip = $("<div class='fshr-sliderTooltip fshr-sliderTooltip--maximum js-sliderTooltip-maximum'><span class='js-sliderTooltip-value fshr-sliderTooltip-value'>" + maximumHtml + "</span></div>");
                var $uiHandlers = $slider.find(".ui-slider-handle");
                var $minimumHandler = $uiHandlers.filter(":eq(0)");
                var $maximumHandler = $uiHandlers.filter(":eq(1)");
                $minimumHandler.append($minimumTooltip);
                $maximumHandler.append($maximumTooltip);
            }
        });
    });
    $(".js-sliderSimple").each(function () {
        var $slider = $(this);
        var textFormatAsIs = $slider.is("[data-textAsIs]");
        var $sliderParent = $slider.closest(".js-sliderParent");
        var $tooltip = $sliderParent.find(".js-sliderTooltip");
        var $select = $sliderParent.find(".js-sliderValue");
        var sliderMinimum = 0;
        var sliderMaximum = $select.find("option").length - 1;
        var valueIndex = $select.find("option:selected").index() || 0;
        $tooltip.html($select.find("option:selected").text());
        $slider.slider({
            range: "min",
            min: sliderMinimum,
            max: sliderMaximum,
            step: 1,
            value: valueIndex,
            slide: function (event, ui) {
                var optionIndexValue = ui.value;
                var $options = $select.find("option");
                setProperOption($options, optionIndexValue);
                var value = $options.filter(":selected").text();
                var html = value;
                if (textFormatAsIs) {
                    html = value;
                }
                $tooltip.html(html);

                $slider.closest(".js-change-detection, .js-domFilter, .js-searchResultFilters").trigger("change-detected");
            }
        });
    });
    $(document).on("reset-change change", ".js-sliderMinimumValue, .js-sliderMaximumValue", function () {

        var $select = $(this);
        var selectValue = parseInt($select.val(), 10);
        var selectIndex = $select.find("option:selected").index() || 0;
        var $parent = $select.closest(".js-sliderParent");
        var $slider = $parent.find(".js-slider");
        var sliderCurrency = $slider.attr("data-currency") || "Kč";
        var $minimumTooltip = $slider.find(".js-sliderTooltip-minimum .js-sliderTooltip-value");
        var $maximumTooltip = $slider.find(".js-sliderTooltip-maximum .js-sliderTooltip-value");
        var sliderValues = $slider.slider("option", "values");
        var isMaximum = $select.is(".js-sliderMaximumValue");
        if (isMaximum) {
            sliderValues[1] = selectIndex;
            $maximumTooltip.html(global.formatNumberAsPrice(selectValue) + " " + sliderCurrency);
        } else {
            sliderValues[0] = selectIndex;
            $minimumTooltip.html(global.formatNumberAsPrice(selectValue) + " " + sliderCurrency);
        }
        $slider.slider("option", "values", sliderValues);

    });
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 *  resize map
 *  */
(function ($, global) {
    function resizeRecenterMap (map, newCenter) {
        google.maps.event.trigger(map, "resize");
        map.setCenter(newCenter);
    }
    function resizeRecenterMapLEAFLET (map) {
        map.invalidateSize();
    }
    global.resizeRecenterMap = resizeRecenterMapLEAFLET;

    $(document).on("click", ".js-expand-map", function (event) {
        event.preventDefault();
        var $this = $(this);
        var mapId= $this.attr("href").replace("#", "");
        var map = global.commonMaps[mapId].map;
        if (map) {
            var newCenter = map.getCenter();
            var $map = $("#" + mapId);
            var biggerText = $this.attr("data-text-bigger") || "Zvětšit mapu";
            var smallerText = $this.attr("data-text-smaller") || "Zmenšit mapu";
            var currentPadding = parseInt($map.css("padding-top"), 10);
            var multiplier = 2;
            var padding = currentPadding/multiplier;
            if ($this.hasClass("expanded")) {
                $this.removeClass("expanded");
                $this.text(biggerText);
            } else {
                $this.addClass("expanded");
                padding = currentPadding*multiplier;
                $this.text(smallerText);
            }
            $map.animate({
                paddingTop:  padding
            }, {
                step: function () {
                    resizeRecenterMapLEAFLET(map);
                },
                complete: function () {
                    resizeRecenterMapLEAFLET(map);
                }
            });
        }
    });
})(jQuery, globalWrapper.fshr);


/* TO DISABLE */
/**
 *  reset maps infoBoxes offset
 *  */
(function ($, global) {
    var resizeTimeoutId = 0;
    $(window).on("resize orientationchange", function () {
        clearTimeout(resizeTimeoutId);
        resizeTimeoutId = setTimeout(function () {
            var mapsExists = "commonMaps" in global;
            if (mapsExists) {
                for (var mapId in global.commonMaps) {
                    if (global.commonMaps.hasOwnProperty(mapId)) {
                        var mapInfo = global.commonMaps[mapId];
                        var infoBoxes = mapInfo.infoBoxes;
                        global.mapsFcs.setProperOffsetToAllInfoBoxesLEAFLET(infoBoxes);
                    }
                }
            }
        }, 100);
    });
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 *  simple google map
 *  */
(function ($, global) {
    function initializeMap ($mapElement) {
        if (!$mapElement.is(".js-mapPrepared")) {
            var locationsVariableName = $mapElement.attr("data-map-location-variable-name") || "googleMapLocations";
            var locations = window[locationsVariableName] || [];

            var mapZoomLevel = 1;

            var mapId = $mapElement.attr("id");
            if (!mapId) {
                mapId = "commonMap" + $mapElement.index() + (new Date().getTime());
                $mapElement.attr("id", mapId);
            }

            global.commonMaps = global.commonMaps || {};
            global.commonMaps[mapId] = {};

            var mapOptions = {
                zoom: mapZoomLevel,
                scrollwheel: false,
                zoomControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                //center: new google.maps.LatLng(50.0833, 14.4667),
                center: new google.maps.LatLng(0, 0),
                disableDefaultUI: true,
                streetViewControl: true
            };

            var mapElement = $mapElement[0];
            var map = new google.maps.Map(mapElement, mapOptions);
            global.commonMaps[mapId].map = map;

            var $fullscreenHandler = $("<span class='js-fullscreen fshr-map-to-fullscreen' data-fullscreen-selector='closest(.js-google-map)'>fullscreen</span>");
            var isFullscreenEnabled = "requestFullscreen" in mapElement || "webkitRequestFullscreen" in mapElement || "mozRequestFullScreen" in mapElement || "msRequestFullscreen" in mapElement;

            if (isFullscreenEnabled) {
                map.controls[google.maps.ControlPosition.TOP_RIGHT].push($fullscreenHandler[0]);
            }

            var dataToSend = $mapElement.attr("data-map-marker-params");

            if (locations.length) {
                global.mapsFcs.showHotelsOnMap(map, locations, true, true);

                var boundsChangeEvent = google.maps.event.addListener(map, 'bounds_changed', function() {
                    global.setMapZoom(map);
                    google.maps.event.removeListener(boundsChangeEvent);
                });
                google.maps.event.addListener(map, 'idle', function() {
                    if (!$mapElement.hasClass("js-map-loaded")) {
                        $mapElement.addClass("js-map-loaded");
                    }
                });
            } else if (dataToSend) {
                var options = {
                    success: function (result) {
                        if ("data" in result) {
                            locations = result.data;
                            window[locationsVariableName] = locations;

                            if (locations.length) {
                                global.mapsFcs.showHotelsOnMap(map, locations, true, true);

                                var boundsChangeEvent = google.maps.event.addListener(map, 'bounds_changed', function() {
                                    global.setMapZoom(map);
                                    google.maps.event.removeListener(boundsChangeEvent);
                                });

                                if (global.commonMaps[mapId].mapClusters) {
                                    google.maps.event.addListener(global.commonMaps[mapId].mapClusters, 'clusteringend', function() {
                                        if (!$mapElement.hasClass("js-map-loaded")) {
                                            if ($mapElement.hasClass("js-showCurrent")) {
                                                map.setZoom(11);
                                            }
                                            $mapElement.addClass("js-map-loaded");
                                            $mapElement.removeClass("fshr-mapLoading");
                                        }
                                    });
                                }
                            } else {
                                $mapElement.attr("data-maptext-nodata", global.localization.mapNoData);
                                $mapElement.addClass("js-map-loaded fshr-map--noData");
                                $mapElement.removeClass("fshr-mapLoading");
                            }
                        }
                    },
                    error: function () {
                        $mapElement.attr("data-maptext-nodata", global.localization.mapNoData);
                        $mapElement.addClass("js-map-loaded fshr-map--noData");
                        $mapElement.removeClass("fshr-mapLoading");
                    }
                };
                $mapElement.addClass("fshr-mapLoading");
                global.ajax.functions.send(global.ajax.url.map, dataToSend, options, "simpleMap");
            } else {
                $mapElement.attr("data-maptext-nodata", global.localization.mapNoData);
                $mapElement.addClass("js-map-loaded fshr-map--noData");
                $mapElement.removeClass("fshr-mapLoading");
            }
            $mapElement.addClass("js-mapPrepared");
        }
    }

    function initializeMapLEAFLET ($mapElement) {
        if (!$mapElement.is(".js-mapPrepared")) {
            $mapElement.addClass("fshr-mapLoading");
            var locationsVariableName = $mapElement.attr("data-map-location-variable-name") || "googleMapLocations";
            var locations = window[locationsVariableName] || [];

            var mapZoomLevel = 1;

            var mapId = $mapElement.attr("id");
            if (!mapId) {
                mapId = "commonMap" + $mapElement.index() + (new Date().getTime());
                $mapElement.attr("id", mapId);
            }

            global.commonMaps = global.commonMaps || {};
            global.commonMaps[mapId] = {};

            var mapOptions = {
                zoom: mapZoomLevel,
                scrollWheelZoom: false,
                zoomControl: true,
                attributionControl: false,
                maxZoom: 18,
                //mapTypeId: google.maps.MapTypeId.ROADMAP,
                center: [50.0833, 14.4667]
                //center: new google.maps.LatLng(0, 0),
                //disableDefaultUI: true
                //streetViewControl: true
            };

            var mapElement = $mapElement[0];
            var map = L.map(mapElement, mapOptions);

            /*
            L.tileLayer(global.mapSourceUrl, {
                maxZoom: 18
            }).addTo(map);

             */
            var gl = L.mapboxGL({
                accessToken: "no-token",
                style: global.mapSourceUrl,
                maxZoom: 18
            }).addTo(map);


            global.commonMaps[mapId].map = map;

            var isFullscreenEnabled = "requestFullscreen" in mapElement || "webkitRequestFullscreen" in mapElement || "mozRequestFullScreen" in mapElement || "msRequestFullscreen" in mapElement;

            if (isFullscreenEnabled) {
                //map.controls[google.maps.ControlPosition.TOP_RIGHT].push($fullscreenHandler[0]);
                var mapFullscreen = L.control({position: 'topright'});
                mapFullscreen.onAdd = function () {
                    var returnElement = L.DomUtil.create("span", "");
                    $(returnElement).addClass("js-fullscreen fshr-map-to-fullscreen").attr("data-fullscreen-selector", "closest(.js-google-map)").html("fullscreen");
                    //return "<span class='js-fullscreen fshr-map-to-fullscreen' data-fullscreen-selector='closest(.js-google-map)'>fullscreen</span>";
                    return returnElement;
                };
                //map.controls[google.maps.ControlPosition.TOP_CENTER].push(filter.element[0]);
                mapFullscreen.addTo(map);
            }

            var dataToSend = $mapElement.attr("data-map-marker-params");

            if (locations.length) {

                global.setMapZoom(map);
                global.mapsFcs.showHotelsOnMapLEAFLET(map, locations, true, true);
                $mapElement.addClass("js-map-loaded");

            } else if (dataToSend) {
                var options = {
                    success: function (result) {
                        if ("data" in result) {
                            locations = result.data;
                            window[locationsVariableName] = locations;

                            if (locations.length) {
                                global.setMapZoom(map);

                                global.mapsFcs.showHotelsOnMapLEAFLET(map, locations, true, true);

                                if (!$mapElement.hasClass("js-map-loaded")) {
                                    setTimeout(function(e){
                                        $mapElement.addClass("js-map-loaded");
                                        $mapElement.removeClass("fshr-mapLoading");
                                    },2000);
                                }
                            } else {
                                $mapElement.attr("data-maptext-nodata", global.localization.mapNoData);
                                $mapElement.addClass("js-map-loaded fshr-map--noData");
                                $mapElement.removeClass("fshr-mapLoading");
                            }
                        }
                    },
                    error: function () {
                        $mapElement.attr("data-maptext-nodata", global.localization.mapNoData);
                        $mapElement.addClass("js-map-loaded fshr-map--noData");
                        $mapElement.removeClass("fshr-mapLoading");
                    }
                };
                $mapElement.addClass("fshr-mapLoading");
                global.ajax.functions.send(global.ajax.url.map, dataToSend, options, "simpleMap");
            } else {
                $mapElement.attr("data-maptext-nodata", global.localization.mapNoData);
                $mapElement.addClass("js-map-loaded fshr-map--noData");
                $mapElement.removeClass("fshr-mapLoading");
            }
            $mapElement.addClass("js-mapPrepared");
        }

        var legend = $(".js-map-legend");
        var jsmapwrapper = legend.closest(".js-mapWrapper");
        jsmapwrapper.find(".js-google-map").append(legend);
    }

    global["initializeMap"] = initializeMapLEAFLET;
    function initAllElements () {
        var $mapElements = $(".js-google-map:not(.js-mapPrepared):visible");
        $mapElements.each(function () {
            var $map = $(this);
            $map.html("");
            if (!$map.is(".js-lazyLoad")) {
                initializeMapLEAFLET($map);
            }
        });
    }
    initAllElements();
    /*
    if (typeof google !== "undefined" && $mapElement.length) {
        $(document).on("click", ".js-google-map:not('.js-mapPrepared')", function () {
            var $map = $(this);
            $map.html("").addClass("js-mapCouldBeShown");
        });
    }*/
    $(window).on("tab-change", function () {
        initAllElements();
    });
    $(document).on("webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange", function () {
        var isInFullscreen = $(document.fullscreenElement).length;
        if (document.webkitFullscreenElement) {
            isInFullscreen = $(document.webkitFullscreenElement).length;
        } else if (document.mozFullScreenElemen) {
            isInFullscreen = $(document.mozFullScreenElement).length;
        } else if (document.msFullscreenElement) {
            isInFullscreen = $(document.msFullscreenElement).length;
        }

        var $elements = $(".js-fullscreen-enabled");
        $elements.each(function () {
            var $this = $(this);
            if ($this.is(".js-google-map")) {
                /*
                var mapId = $this.attr("id");
                var map = global.commonMaps[mapId].map;

                 */

                if (isInFullscreen) {
                    $this.css({
                        paddingTop: 0,
                        height: "100%"
                    });
                } else {
                    $this.css({
                        paddingTop: "",
                        height: ""
                    });
                    $this.removeClass("js-fullscreen-enabled");
                    $this.find(".js-fullscreen-close").addClass("js-fullscreen").removeClass("js-fullscreen-close");
                }
                /*
                if (mapId) {
                    var lat = parseFloat($this.attr("data-map-center-lat"));
                    var lng = parseFloat($this.attr("data-map-center-lng"));
                    //var mapCenter = new google.maps.LatLng(lat, lng);
                    //global.resizeRecenterMap(map, mapCenter);
                }

                 */
            }
        });
    });
    $(document).on("click", ".js-fullscreen", function (event) {
        event.preventDefault();
        var $this = $(this);
        var elementSelector = $this.attr("data-fullscreen-selector") || $this.attr("href");
        if (elementSelector) {
            var $elementToFullscreen = global.getElementsBySelector(elementSelector, $this);
            /*
            var mapId = $elementToFullscreen.attr("id");
            var map = global.commonMaps[mapId].map;
            var mapCenter = map.getCenter();
            console.log(mapCenter);
            $elementToFullscreen.attr("data-map-center-lat", mapCenter.lat);
            $elementToFullscreen.attr("data-map-center-lng", mapCenter.lng);
            */

            var elementToFullscreen = $elementToFullscreen[0];
            var isInFullscreen = false;
            if ("requestFullscreen" in elementToFullscreen) {
                elementToFullscreen.requestFullscreen();
                isInFullscreen = true;
            } else if ("webkitRequestFullscreen" in elementToFullscreen) {
                elementToFullscreen.webkitRequestFullscreen();
                isInFullscreen = true;
            } else if ("mozRequestFullScreen" in elementToFullscreen) {
                elementToFullscreen.mozRequestFullScreen();
                isInFullscreen = true;
            } else if ("msRequestFullscreen" in elementToFullscreen) {
                elementToFullscreen.msRequestFullscreen();
                isInFullscreen = true;
            }
            if (isInFullscreen) {
                $this.removeClass("js-fullscreen").addClass("js-fullscreen-close");
                $elementToFullscreen.addClass("js-fullscreen-enabled");
            }
        }
    });
    $(document).on("click", ".js-fullscreen-close", function (event) {
        event.preventDefault();
        if ("exitFullscreen" in document) {
            document.exitFullscreen();
        } else if ("webkitExitFullscreen" in document) {
            document.webkitExitFullscreen();
        } else if ("mozCancelFullScreen" in document) {
            document.mozCancelFullScreen();
        } else if ("msExitFullscreen" in document) {
            document.msExitFullscreen();
        }
    });
})(jQuery, globalWrapper.fshr);

/**
 *  skimap
 *  */
(function ($, global) {
    var tileSize = 256;

    function getNormalizedCoord(coord, zoom) {
        var y = coord.y;
        var x = coord.x;

        var tileRange = 1 << zoom;

        if (y < 0 || y >= tileRange) {
            return null;
        }
        if (x < 0 || x >= tileRange) {
            return null;
        }

        x = (x - Math.floor(x/tileRange)*tileRange);

        return {x: x, y: y};
    }

    function isHigherThenViewport (leftTop, rightBottom, map, $map) {
        var mapHeight = getDistanceInPx(map, new google.maps.LatLng(leftTop.lat, leftTop.lng), new google.maps.LatLng(rightBottom.lat, leftTop.lng), map.getZoom());
        var mapViewportHeight = $map.parent().outerHeight();
        return mapHeight > mapViewportHeight;
    }

    function getDistanceInPx (map, position1, position2, zoom) {
        var p1 = map.getProjection().fromLatLngToPoint(position1);
        var p2 = map.getProjection().fromLatLngToPoint(position2);

        var pixelSize = Math.pow(2, -zoom);

        var distance = Math.sqrt((p1.x-p2.x)*(p1.x-p2.x) + (p1.y-p2.y)*(p1.y-p2.y))/pixelSize;

        return distance;
    }

    function initializeMapSki ($mapElement) {
        var skimapUrl = $mapElement.attr("data-skimap-url") || "Content/images/";
        var skimapId = $mapElement.attr("data-skimap-id") || "";
        var tilesUrl = skimapUrl + skimapId + "/";

        var mapId = $mapElement.attr("id");
        if (!mapId) {
            mapId = "skiMap" + $mapElement.index() + (new Date().getTime());
            $mapElement.attr("id", mapId);
        }
        var mapOptions = {
            center: {lat: 0, lng: 0},
            zoom: 3,
            minZoom: 1,
            maxZoom: 4,
            streetViewControl: false,
            mapTypeControl: false
        };
        console.log('mapOptions', mapOptions);

        global.skiMaps = global.skiMaps || {};
        global.skiMaps[mapId] = {};

        var mapElement = $mapElement[0];

        dataLayer.push({
            event: 'trackEvent',
            eventCategory: 'googleMapsSki',
            eventAction: 'googleMapsLoad',
            eventValue: 1
        });
        var map = new google.maps.Map(mapElement, mapOptions);
        global.skiMaps[mapId].map = map;

        var skiMapType = new google.maps.ImageMapType({
            getTileUrl: function(coord, zoom) {
                var normalizedCoord = getNormalizedCoord(coord, zoom);
                if (!normalizedCoord) {
                    return null;
                }
                return tilesUrl + zoom + '/' + normalizedCoord.x + '_' + normalizedCoord.y + '.jpg';
            },
            tileSize: new google.maps.Size(tileSize, tileSize),
            maxZoom: 4,
            minZoom: 1,
            name: 'ski'
        });

        map.mapTypes.set('ski', skiMapType);
        map.setMapTypeId('ski');
        var mapSize = {
            width: $mapElement.width(),
            height: $mapElement.height()
        };
        var smallestEdge = Math.min(mapSize.width, mapSize.height);
        var maxTilesToRow = Math.floor(smallestEdge / tileSize);
        // var newZoom = 0;
        // if (maxTilesToRow > 1) {
        //     newZoom = Math.floor(Math.sqrt(maxTilesToRow));
        // }
        // map.setZoom(newZoom);
        // console.log(newZoom);

        google.maps.event.addListener(map, "rightclick", function(event) {

            var lat = event.latLng.lat();
            console.log(lat);
        });

        var topLat = $mapElement.attr("data-map-top");
        var bottomLat = $mapElement.attr("data-map-bottom");
        if (typeof topLat != "undefined" && typeof bottomLat != "undefined") {
            var top = {
                lat: parseFloat(topLat),
                lng: 0
            };
            var bottom = {
                lat: parseFloat(bottomLat),
                lng: 0
            };

            var lastValidCenter = map.getCenter();

            google.maps.event.addListener(map, "center_changed", function () {
                if (!$mapElement.is(".js-customCentered")) {
                    var bounds = map.getBounds();
                    var boundRightBottom = bounds.getSouthWest();
                    var boundLeftTop = bounds.getNorthEast();


                    var isHigher = isHigherThenViewport(top, bottom, map, $mapElement);
                    $("#higher").text(isHigher ? "ano": "ne");
                    var currentCenter = map.getCenter();
                    if (!isHigher && (boundLeftTop.lat() < top.lat || boundRightBottom.lat() > bottom.lat)) {
                        $mapElement.addClass("js-customCentered");
                        map.setCenter(new google.maps.LatLng(lastValidCenter.lat(), currentCenter.lng()));
                        $mapElement.removeClass("js-customCentered");
                    } else if (isHigher && (boundLeftTop.lat() > top.lat || boundRightBottom.lat() < bottom.lat)) {
                        $mapElement.addClass("js-customCentered");
                        map.setCenter(new google.maps.LatLng(lastValidCenter.lat(), currentCenter.lng()));
                        $mapElement.removeClass("js-customCentered");
                    } else {
                        lastValidCenter = map.getCenter();
                    }
                }
            });
        }
        $mapElement.addClass("js-mapInitialized");
    }
    global["initializeMapSki"] = initializeMapSki;

    /*
    var $mapElement = $(".js-skimap:not(.js-mapInitialized)");
    if (typeof google !== "undefined" && $mapElement.length) {
        $mapElement.each(function () {
            var $map = $(this);
            var $gallery = $map.closest(".js-gallery");
            if ($gallery.length) {
                $gallery.one("gallery-after-open", function () {
                    initializeMapSki($map);
                })
            } else if (!$map.is(".js-lazyLoad")) {
                initializeMapSki($map);
            }
        });
    }
    */

    $(document).on("gallery-after-open", ".js-gallery", function () {
        var $gallery = $(this);
        var $skimap = $gallery.find(".js-skimap:not(.js-mapInitialized)").first();
        if ($skimap.length) {
            initializeMapSki($skimap);
        }
    });

})(jQuery, globalWrapper.fshr);

/**
 * print
 * */
(function ($, global) {
    $(document).on("click", ".js-print", function () {
        window.print();
    });
})(jQuery, globalWrapper.fshr);



/**
 * fixed menu
 * */
(function ($, global) {
    var previousScrollTop = 0;
    $(window).on("scroll load resize content-change", function (event) {
        event.preventDefault();
        var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        var $window = $(this);
        var $fixedMap = $(".js-map--fixed");
        var $fixedMapParent = $(".js-fixedMap-parent");
        var scrollTop = $window.scrollTop();
        var $fixedMenu = $(".js-fixedMenu");
        var fixedMenuHeight = $fixedMenu.outerHeight();

        if ($fixedMapParent.length) {
            var fixedMapParentTopEdge = $fixedMapParent.offset().top;
            var $searchFiltersStillFixed = $(".js-searchFilters--stillFixed:not(.fshr-hidden)");
            var searchResultsFiltersHeight = $searchFiltersStillFixed.outerHeight();
            var $searchFiltersPartialyFixed = $(".js-searchFilters--partialyFixed:not(.fshr-hidden)");
            var searchFilterInfoHeight = $searchFiltersPartialyFixed.outerHeight();
            var $nextItem = $searchFiltersStillFixed.next();
            var topPosition = scrollTop - fixedMapParentTopEdge + fixedMenuHeight;
            var maximumScrollTop = fixedMapParentTopEdge + $fixedMapParent.outerHeight() - viewportHeight + searchFilterInfoHeight;
            var mainWidth = $(".fshr-searchResults").width();

            var stillFixedWidth = mainWidth - ($searchFiltersStillFixed.outerWidth() - $searchFiltersStillFixed.width());
            var partialyFixedWidth = mainWidth - ($searchFiltersPartialyFixed.outerWidth() - $searchFiltersPartialyFixed.width());

            var mainTop = scrollTop - fixedMapParentTopEdge + fixedMenuHeight;

            if (event.type == "resize") {
                $searchFiltersStillFixed.width(stillFixedWidth);
                $searchFiltersPartialyFixed.width(partialyFixedWidth);
            };

            if (scrollTop > previousScrollTop) {
                // scroll down
                if (scrollTop >= maximumScrollTop) {
                    $searchFiltersStillFixed.addClass("fshr-searchResultsFilters--absolute").removeClass("fshr-searchResultsFilters--fixed").css({
                        top: maximumScrollTop - fixedMapParentTopEdge + fixedMenuHeight
                    });
                    $searchFiltersPartialyFixed.addClass("fshr-searchSubFilter--absolute").removeClass("fshr-searchSubFilter--fixed").css({
                        top: maximumScrollTop - fixedMapParentTopEdge + fixedMenuHeight - $searchFiltersPartialyFixed.outerHeight()
                    });

                    $searchFiltersStillFixed.width(stillFixedWidth);
                    $searchFiltersPartialyFixed.width(partialyFixedWidth);
                } else {

                    if ($searchFiltersStillFixed.is(".fshr-searchResultsFilters--fixed") || $searchFiltersPartialyFixed.is(".fshr-searchSubFilter--fixed")) {
                        if ($searchFiltersPartialyFixed.length && $searchFiltersPartialyFixed.offset().top + $searchFiltersPartialyFixed.outerHeight() > (scrollTop + fixedMenuHeight)) {
                            $searchFiltersPartialyFixed.addClass("fshr-searchSubFilter--absolute").removeClass("fshr-searchSubFilter--fixed").css({
                                top: mainTop
                            });
                            $searchFiltersPartialyFixed.width(partialyFixedWidth);
                        }
                        if ($searchFiltersStillFixed.length && $searchFiltersStillFixed.offset().top > (scrollTop + fixedMenuHeight)) {
                            $searchFiltersStillFixed.addClass("fshr-searchResultsFilters--absolute").removeClass("fshr-searchResultsFilters--fixed").css({
                                top: mainTop + ($searchFiltersPartialyFixed.length ? $searchFiltersPartialyFixed.outerHeight() : 0)
                            });
                            $searchFiltersStillFixed.width(stillFixedWidth);
                        }
                    } else if ($searchFiltersPartialyFixed.length && ($searchFiltersPartialyFixed.offset().top + searchFilterInfoHeight < (scrollTop + fixedMenuHeight))) {
                        $searchFiltersStillFixed.addClass("fshr-searchResultsFilters--fixed").removeClass("fshr-searchResultsFilters--absolute").css({
                            top: fixedMenuHeight
                        });
                        $searchFiltersPartialyFixed.addClass("fshr-searchSubFilter--fixed").removeClass("fshr-searchSubFilter--absolute").css({
                            top: fixedMenuHeight - searchFilterInfoHeight
                        });
                        $(".fshr-searchResults-content").css({
                            paddingTop: searchFilterInfoHeight + searchResultsFiltersHeight
                        });
                        $searchFiltersStillFixed.width(stillFixedWidth);
                        $searchFiltersPartialyFixed.width(partialyFixedWidth);
                    }
                }
            } else {
                // scroll up
                if (scrollTop > fixedMapParentTopEdge - fixedMenuHeight) {
                    if ($searchFiltersPartialyFixed.is(".fshr-searchSubFilter--fixed")) {
                        if ($searchFiltersPartialyFixed.offset().top < (scrollTop + fixedMenuHeight)) {

                            $searchFiltersPartialyFixed.addClass("fshr-searchSubFilter--absolute").removeClass("fshr-searchSubFilter--fixed").css({
                               top: mainTop - $searchFiltersPartialyFixed.outerHeight()
                            });
                            $searchFiltersStillFixed.addClass("fshr-searchResultsFilters--absolute").removeClass("fshr-searchResultsFilters--fixed").css({
                                top: mainTop
                            });
                            $searchFiltersStillFixed.width(stillFixedWidth);
                            $searchFiltersPartialyFixed.width(partialyFixedWidth);
                        }
                    } else if ($searchFiltersPartialyFixed && $searchFiltersPartialyFixed.length && ($searchFiltersPartialyFixed.offset().top >= (scrollTop + fixedMenuHeight))) {
                        $searchFiltersPartialyFixed.addClass("fshr-searchSubFilter--fixed").removeClass("fshr-searchSubFilter--absolute").css({
                           top: fixedMenuHeight
                        });
                        $searchFiltersStillFixed.addClass("fshr-searchResultsFilters--fixed").removeClass("fshr-searchResultsFilters--absolute").css({
                            top: searchFilterInfoHeight + fixedMenuHeight
                        });
                        $searchFiltersStillFixed.width(stillFixedWidth);
                        $searchFiltersPartialyFixed.width(partialyFixedWidth);
                    }

                } else {
                    $searchFiltersStillFixed.removeClass("fshr-searchResultsFilters--fixed fshr-searchResultsFilters--absolute").css({
                        top: ""
                    });
                    $searchFiltersPartialyFixed.removeClass("fshr-searchSubFilter--fixed fshr-searchSubFilter--absolute").css({
                        top: ""
                    });
                    $(".fshr-searchResults-content").css({
                        paddingTop: ""
                    });
                    $searchFiltersStillFixed.css({width: ""});
                    $searchFiltersPartialyFixed.css({width: ""});
                }
            }


            /*
            if (scrollTop > previousScrollTop) {
                if (scrollTop >= maximumScrollTop) {
                    var maximumTopEdge = maximumScrollTop - fixedMapParentTopEdge;
                    $searchResultsFilters.addClass("fshr-searchResultsFilters--fixed").css({
                        top: maximumTopEdge + fixedMenuHeight
                    });
                    $searchFilterInfo.addClass("fshr-searchSubFilter--fixed").css({
                        top: maximumTopEdge + fixedMenuHeight - searchFilterInfoHeight
                    });
                } else if (scrollTop > fixedMapParentTopEdge + searchFilterInfoHeight - fixedMenuHeight) {
                    if (scrollTop >= $searchFilterInfo.offset().top + searchFilterInfoHeight - fixedMenuHeight) {
                        $searchResultsFilters.addClass("fshr-searchResultsFilters--fixed").css({
                            top: topPosition
                        });
                        $searchFilterInfo.addClass("fshr-searchSubFilter--fixed").css({
                            top: topPosition - searchFilterInfoHeight
                        });
                        $nextItem.css({
                            paddingTop: searchFilterInfoHeight + searchResultsFiltersHeight
                        });
                    }
                } else {
                    $searchResultsFilters.removeClass("fshr-searchResultsFilters--fixed").css({
                        top: "0"
                    });
                    $searchFilterInfo.removeClass("fshr-searchSubFilter--fixed").css({
                        top: "0"
                    });
                    $nextItem.css({
                        paddingTop: 0
                    });
                }
            } else {
                if (scrollTop > fixedMapParentTopEdge - fixedMenuHeight) {
                    if (scrollTop <= $searchFilterInfo.offset().top - fixedMenuHeight) {
                        $searchResultsFilters.addClass("fshr-searchResultsFilters--fixed").css({
                            top: topPosition + searchFilterInfoHeight
                        });
                        $searchFilterInfo.addClass("fshr-searchSubFilter--fixed").css({
                            top: topPosition
                        });
                    }
                } else {
                    $searchResultsFilters.removeClass("fshr-searchResultsFilters--fixed").css({
                        top: "0"
                    });
                    $searchFilterInfo.removeClass("fshr-searchSubFilter--fixed").css({
                        top: "0"
                    });
                    $nextItem.css({
                        paddingTop: 0
                    });
                }
            }
            */
        }

        var minimumScrollToShow = $fixedMenu.outerHeight(true);
        var defaultTop = parseInt($fixedMenu.attr("data-defaultTop"), 10);
        var currentTop = parseInt($fixedMenu.css("top"), 10);

        if (!defaultTop) {
            defaultTop = parseInt($fixedMenu.css("top"), 10);
            $fixedMenu.attr("data-defaultTop", defaultTop);
        }

        var setTop = defaultTop;
        if (scrollTop > minimumScrollToShow) {
            setTop = 0;
        }

        if (currentTop != setTop) {
            if ($fixedMap.length) {
                $fixedMenu.css({
                    top: setTop + "px"
                });
            }
            if (setTop < 0) {
                $fixedMenu.removeClass("fshr-layoutHeader-menuFixed--active");
            } else {
                $fixedMenu.addClass("fshr-layoutHeader-menuFixed--active");
            }
        }

        previousScrollTop = scrollTop;
    });
})(jQuery, globalWrapper.fshr);


/* TO DISABLE */
/**
 *  remote click handler
 *  */
(function ($, global) {
    function remoteClick (event) {
        event.preventDefault();
        var $this = $(this);
        var elementSelector = $this.attr("data-remote-selector") || $this.attr("href");
        var $elements = global.getElementsBySelector(elementSelector, $this);
        $elements.each(function () {
            var $element = $(this);
            if ($element.hasClass("js-remote-click")) {
                $element.removeClass("js-remote-click");
                $element.trigger("click");
                $element.addClass("js-remote-click");
            } else {
                $element.trigger("click");
            }
        });
    }
    $(document).on("click", ".js-remote-click", remoteClick);
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 *  remote change select
 *  */
(function ($, global) {
    function remoteChange (event) {
        var eventIsClick = event.type == "custom-click";
        if (eventIsClick) {
            event.preventDefault()
        }
        var $this = $(this);
        var elementSelector = $this.attr("data-remote-selector");
        var value = "";
        var isInput = $this.is("input");
        if (eventIsClick) {
            value = $this.attr("data-value");
        } else if (isInput) {
            value = $this.val();
        } else {
            var $options = $this.find("option");
        }
        var $elements = global.getElementsBySelector(elementSelector, $this);
        $elements.each(function () {
            var $element = $(this);
            if (isInput) {
                $element.val(value);
            } else {
                var $elementOptions = $element.find("option");
                $elementOptions.each(function (index) {
                    var $option = $(this);
                    if (eventIsClick) {
                        var optionValue = $option.attr("data-value") || $option.val();
                        $option.prop("selected", optionValue == value);
                    } else {
                        var $parentOption = $options.eq(index);
                        var parentIsSelected = $parentOption.prop("selected");
                        $option.prop("selected", parentIsSelected);
                    }
                });
            }
            $element.removeClass("js-remote-change");
            $element.trigger("change");
            $element.addClass("js-remote-change");
        });
    }
    $(document).on("change select-change custom-click", ".js-remote-change", remoteChange);
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 * google search results maps
 * */
(function ($, global) {
    var resultsMap = null;
    var statesInfoBoxes = [];
    //var bounds = new google.maps.LatLngBounds();
    var cssClassMapMaximized = "fshr-mapIsMaximized";
    var cssClassShrinked = "fshr-searchResults--shrinked";
    var $googleMap = $(".js-map--searchResults");

    function getInfoBoxStateContent (state, stateId) {
        var destinationsCount = state.count || state.places.length ;


        var hotelsText = global.getProperSuffix(destinationsCount, global.localization.hotels.join(","));

        var $destinationsLink = $("<p class='fshr-state-link js-state-link js-tooltip' title='" + state.title + "' data-state-id='" + stateId + "'><span class='fshr-link-text'>" + global.localization.show + " </span>" + destinationsCount  + "<span class='fshr-link-text'> " + hotelsText + "</span></p>");
        var flagHtml = "";
        if (state.flag) {
            flagHtml = "<div class='fshr-state-flag'><img src='" + state.flag + "' alt=''></div>";
        }
        var priceHtml = "";
        if (state.priceText) {
            priceHtml = "<p class='fshr-state-price'>" + state.priceText + "</p>";
        }
        var $title = $("<div class='fshr-state-header'>" + flagHtml + "<p class='fshr-title'>" + state.title + "</p>" + priceHtml + "</div>");
        var $html = $("<div></div>");
        $html.append($title);
        $html.append($destinationsLink);
        return $html[0];
    }

    function showStateOnMap (resultsMap, state) {
        var infoBoxStateOptions = {
            pixelOffset: new google.maps.Size(-20, 0),
            alignBottom: true,
            closeBoxURL: global.IMAGES_PATH + "map-infobox-close.gif",
            boxClass: "fshr-map-infobox fshr-map-infobox--state js-showState"
        };

        infoBoxStateOptions["content"] = state.title;

        var statePosition = new google.maps.LatLng(state.position.lat, state.position.lng);
        infoBoxStateOptions["position"] = statePosition;
        infoBoxStateOptions["content"] = getInfoBoxStateContent(state, state.id);
        var stateInfoBox = new InfoBox(infoBoxStateOptions);
        statesInfoBoxes.push(stateInfoBox);
        stateInfoBox.open(resultsMap);
        google.maps.event.addListener(stateInfoBox, "domready", function () {
            $(".fshr-map-infobox .js-tooltip").each(global.initializeQtip);
        });

        google.maps.event.addDomListener(stateInfoBox.content_, "click", function () {
            var $element = $(this);
            $(".qtip").hide();
            var $link = $element.find(".js-state-link");
            var stateId = $link.attr("data-state-id");
            var $customControl = $("<a href='#' class='js-map-showAllStates fshr-map-customControl'>Zobrazit všechny země</a>");

            resultsMap.controls[google.maps.ControlPosition.TOP_LEFT].push($customControl[0]);

            $.each(statesInfoBoxes, function () {
                var infobox = this;
                infobox.close();
            });
            // TODO: check map
            var places = searchResultData[stateId].places;
            var fitBounds = true;
            if (("places" in searchResultData[stateId]) && (!places.length)) {
                $.ajax({
                    url: global.ajax.url.map,
                    data: searchResultData[stateId].filter,
                    success: function (data) {
                        var places = data.data;
                        searchResultData[stateId].places = places;
                        global.mapsFcs.showHotelsOnMap(resultsMap, places, fitBounds);
                        var $wrapper = $(".fshr-searchResults-group-header[data-groupid='" + stateId + "'] + .fshr-searchResults-items");
                        $.each(places, function () {
                            $wrapper.append($(global.mapsFcs.getLeftPanelHotel(this)));
                        });
                    },
                    error: function (data) {
                        console.warn(data);
                    }
                });
            } else {
                global.mapsFcs.showHotelsOnMap(resultsMap, places, fitBounds);
            }
        });
        return bounds.extend(statePosition);
    }
    function removeAllHotels (map) {
        var mapId = $(map.getDiv()).attr("id");
        var mapClusters = global.commonMaps[mapId].mapClusters;
        var markers = global.commonMaps[mapId].markers;
        for (var markerIndex in markers) {
            if (markers.hasOwnProperty(markerIndex)) {
                var marker = markers[markerIndex];
                marker.setMap(null);
            }
        }
        if (mapClusters) {
            if ("clearMarkers" in mapClusters) {
                mapClusters.clearMarkers();
            }
            if ("setMap" in mapClusters) {
                mapClusters.setMap(null);
            }
        }
        global.commonMaps[mapId].markers = {};
        global.commonMaps[mapId].mapClusters = {};
        global.mapsFcs.closeAllInfoBoxes(global.commonMaps[mapId].infoBoxes);
        bounds = new google.maps.LatLngBounds();
    }
    function removeAllStates () {
        var infoBoxesCount = statesInfoBoxes.length;
        for (var index = 0; index < infoBoxesCount; index++) {
            var infoBox = statesInfoBoxes[index];
            infoBox.close();
        }
        statesInfoBoxes = [];
        bounds = new google.maps.LatLngBounds();
    }

    function handleInfoboxesBaseOnZoom (infoboxes, zoomLevel) {
        $.each(infoboxes, function () {
            var infobox = this;
            if (zoomLevel < 5) {
                infobox.setOptions({
                    boxClass: "fshr-map-infobox fshr-map-infobox--state js-showState fshr-map-infobox-searchResults--small"
                });
                $(".fshr-map-infobox-searchResults--small .js-tooltip:not([data-hasqtip])").each(global.initializeQtip);
            } else {
                infobox.setOptions({
                    boxClass: "fshr-map-infobox fshr-map-infobox--state js-showState"
                });
                $(".fshr-map-infobox:not(.fshr-map-infobox-searchResults--small) .js-tooltip").qtip('destroy', true);
            }
        });
    }
    var timeoutLazyLoad = 0;
    function updateMaxMinButton () {
        var $text = $(this);
        $text.css({
            marginLeft: 0
        });
        var textWidth = $text.outerWidth();
        $text.css({
            marginLeft: -textWidth
        });
    }

    function maximizeMap ($menuSearch, $searchResultFilters, $menuSearchContent, $body, $button, $buttonText, $searchResults) {
        $menuSearch.removeClass("js-searchMenu--active fshr-searchMenu-handler--active");
        $searchResultFilters.removeClass("fshr-searchResultFilters--active");
        $menuSearchContent.hide();
        //$searchResultFilters.hide();
        $menuSearch.closest(".grd-col").addClass("fshr-searchMenu-filters--slim");
        $body.addClass(cssClassMapMaximized);
        var $map = $(".js-map--searchResults");
        var mapId = $map.attr("id");
        /*
        if (!$map.is(".js-mapCouldBeShown")) {
            enableMapShow($map);
        }

         */
        if ("commonMaps" in global && global.commonMaps[mapId] && "map" in global.commonMaps[mapId]) {
            var resultsMap = global.commonMaps[mapId].map;
            /*
            resultsMap.set("streetViewControl", true);
            resultsMap.set("mapTypeControl", true);
            resultsMap.set("scrollwheel", true);

             */
            $body.removeClass("fshr-mapIsSticked fshr-mapIsBottom");
        }

        $searchResults.addClass(cssClassShrinked);
        $button.addClass("fshr-icon--caretRight");
        $button.removeClass("fshr-icon--caretLeft");
        var buttonText = $button.attr("data-text-smaller") || "skrýt <br>mapu";
        $buttonText.html(buttonText);
        clearTimeout(timeoutLazyLoad);
        timeoutLazyLoad = setTimeout(function () {
            $(".js-map--hotels").trigger("left-panel-changed");
        }, 1000);
    }
    function minimizeMap ($menuSearch, $searchResultFilters, $menuSearchContent, $body, $button, $buttonText, $searchResults) {
        if (global.widths.window >= global.widths.mobile) {
            $menuSearch.removeClass("js-searchMenu--active fshr-searchMenu-handler--active");
            $searchResultFilters.removeClass("fshr-searchResultFilters--active");
            //$menuSearchContent.hide();
            $menuSearch.closest(".grd-col").removeClass("fshr-searchMenu-filters--slim");
        }
        $body.removeClass(cssClassMapMaximized);
        var mapId = $(".js-map--searchResults").attr("id");
        /*
        if ("commonMaps" in global && global.commonMaps[mapId] && "map" in global.commonMaps[mapId]) {
            var resultsMap = global.commonMaps[mapId].map;
            resultsMap.set("streetViewControl", false);
            resultsMap.set("mapTypeControl", false);
            resultsMap.set("mapTypeId", google.maps.MapTypeId.ROADMAP);
            resultsMap.set("scrollwheel", false);
            resultsMap.getStreetView().setVisible(false);
        }

         */

        $searchResults.removeClass(cssClassShrinked);
        $button.removeClass("fshr-icon--caretRight");
        $button.addClass("fshr-icon--caretLeft");
        var buttonText = $button.attr("data-text-bigger") || "zobrazit <br>mapu";
        $buttonText.html(buttonText);

    }


    function stopAllPinsAnimation () {
        $(".js-mapActivePin[data-mappin-animated]").each(function () {
            $(this).removeAttr("data-mappin-animated");
            $(".marker-cluster.fshr-animation--pulsating").removeClass("fshr-animation--pulsating");
            $(".leaflet-marker-icon.fshr-animation--bounce").removeClass("fshr-animation--bounce");
        });
                    }

    function addControlPlaceholders(map) {
        var corners = map._controlCorners,
            l = 'leaflet-',
            container = map._controlContainer;

        function createCorner(vSide, hSide) {
            var className = l + vSide + ' ' + l + hSide;

            corners[vSide + hSide] = L.DomUtil.create('div', className, container);
                }

        createCorner('verticalcenter', 'left');
        createCorner('verticalcenter', 'right');
    }

    function resetMap () {
        var $map = $(".js-map--searchResults");
        if ($map.length) {
            var mapId = $map.attr("id");

            if (!$map.hasClass("js-mapPrepared")) {

                if (!mapId) {
                    mapId = "searchMap" + $map.index() + (new Date().getTime());
                    $map.attr("id", mapId);
                }

                resultsMap = new google.maps.Map($map[0], {
                    zoom: 3,
                    center: {lat: 49.7437500, lng: 15.3386300},
                    disableDefaultUI: true,
                    minZoom: 3,
                    maxZoom: 19,
                    scrollwheel: false,
                    panControl: false,
                    draggable: false,
                    disableDoubleClickZoom: true
                });

                global.commonMaps = global.commonMaps || {};
                global.commonMaps[mapId] = {};
                global.commonMaps[mapId].map = resultsMap;

                google.maps.event.addListener(resultsMap, 'idle', function () {
                    var $map = $(this.getDiv());
                    $map.removeClass("fshr-mapLoading");
                    if (!$map.is(".js-mapInitialized")) {
                        $map.addClass("js-mapInitialized");
                        if (typeof bounds !== "undefined" && typeof searchResultData !== "undefined" && searchResultData) {
                            this.fitBounds(bounds);
                        }
                    }
                });
                google.maps.event.addListener(resultsMap, 'zoom_changed', function () {
                    var map = this;
                    var zoomLevel = map.getZoom();
                    handleInfoboxesBaseOnZoom(statesInfoBoxes, zoomLevel);
                });
                var boundsTimeoutId = 0;
                google.maps.event.addListener(resultsMap, 'bounds_changed', function () {
                    var map = this;
                    clearTimeout(boundsTimeoutId);
                    boundsTimeoutId = setTimeout(function () {
                        var mapId = $(map.getDiv()).attr("id");
                        var newBounds = map.getBounds();
                        var markers = global.commonMaps[mapId].markers || [];
                        /*
                        var $hotels = $(".js-map--hotels .fshr-searchResults-item--shrinked");
                        $hotels.hide();
                        */
                        var markersOnMap = [];
                        $.each(markers, function () {
                            var marker = this;
                            if (newBounds.contains(marker.getPosition())) {
                                $.each(searchResultData, function(){
                                    var dataItem = this;
                                    if (marker.fshrMarkerId == dataItem.id) {
                                        markersOnMap.push(dataItem);
                                    }
                                });
                            }
                        });
                        global.visibleMarkers.data = markersOnMap;

                        if ($("body").hasClass("fshr-mapIsMaximized")) {
                            generateLeftPanel(global.visibleMarkers);
                        }
                        $map.trigger("bounds-changed");
                        //$hotels.trigger("left-panel-changed");
                    }, 500);
                });
                $map.addClass("js-mapPrepared");
            }

            resultsMap = global.commonMaps[mapId].map;
            $map.removeClass("js-mapInitialized");
            removeAllHotels(resultsMap);
            removeAllStates();
            resultsMap.set("zoom", 3);
            resultsMap.controls[google.maps.ControlPosition.TOP_LEFT].clear();
            google.maps.event.trigger(resultsMap, 'resize');
            initializeResultsMap(resultsMap);
            $map.removeClass("fshr-mapLoading");
        }
    }
    var mapLoaderTimeout = 0;
    function resetMapLEAFLET () {
        clearTimeout(mapLoaderTimeout);
        var $map = $(".js-map--searchResults");
        if ($map.length) {
            var mapId = $map.attr("id");
            if (!mapId) {
                mapId = "searchMap" + $map.index() + (new Date().getTime());
                $map.attr("id", mapId);
            }

            if (resultsMap) {
                resultsMap.remove();

                if (global.commonMaps[mapId]) {
                    global.commonMaps[mapId].markers = null;
                    global.commonMaps[mapId].mapClusters = null;
                }
            }

            //if (!resultsMap && (!global.commonMaps || !global.commonMaps[mapId])) {
                resultsMap = L.map($map[0], {
                    zoom: 3,
                    center: [49.7437500, 15.3386300],
                    minZoom: 3,
                    maxZoom: 18,
                    zoomControl: false,
                    scrollWheelZoom: false,
                    attributionControl: false
                });
                var gl = L.mapboxGL({
                    accessToken: "no-token",
                    style: global.mapSourceUrl,
                    maxZoom: 18
                }).addTo(resultsMap);

                addControlPlaceholders(resultsMap);
                L.control.zoom({
                    position:'verticalcenterright'
                }).addTo(resultsMap);

                $map.addClass("js-mapPrepared");
                global.commonMaps = global.commonMaps || {};
                global.commonMaps[mapId] = global.commonMaps[mapId] || {};
                global.commonMaps[mapId].map = resultsMap;
            //}


            //resultsMap = global.commonMaps[mapId].map;
            $map.removeClass("js-mapInitialized");
            //removeAllStates();
            resultsMap.setZoom(3);
            //google.maps.event.trigger(resultsMap, 'resize');
            initializeResultsMapLEAFLET(resultsMap);
            mapLoaderTimeout = setTimeout(function () {
                $map.removeClass("fshr-mapLoading");
            }, 2000);
        }
    }
    function generateLeftPanel (markers) {
        var data = markers.data;
        var dataType = markers.type;
        var $searchContent = $(".fshr-searchResults-content");

        var $parent = $(".js-map--hotels");
        var $wrapper = $parent.find(".fshr-searchResults-items");
        if (!$parent.length) {
            $parent = $("<div class='fshr-mapMaximizedHotels js-map--hotels'></div>");
            $wrapper = $("<div class='fshr-searchResults-items'></div>");
            $searchContent.append($parent.append($wrapper));
        }

        if (dataType == "group") {
            /*
            $wrapper = $("<div class='fshr-searchResults-groups'></div>");
            $.each(data, function () {
                $wrapper.append($(global.mapsFcs.getLeftPanelGroup(this)));
            });
            */
        } else {
            var sorterAlreadyExists = $searchContent.find(".js-mapHotelsSorter").length;
            if (!sorterAlreadyExists) {
                var $sorter = $(".js-searchResult-header--hotelView .fshr-searchResults-orderBy").first().clone();
                $sorter.removeClass("js-sorter").addClass("js-mapHotelsSorter");
                var $sorterParent = $("<div class='fshr-shrinkedHotelsHeader'></div>");
                $sorterParent.append($sorter);
                $searchContent.prepend($sorterParent);
            }
            var $newSorter = $(".js-mapHotelsSorter").find("select.js-sorter");
            var sortValue = $newSorter.val();
            var html = "";
            var hotelsCount = data.length;
            var maxHotelsCount = 50;
            var hotelsToShowCount = Math.min(maxHotelsCount, hotelsCount);
            switch (sortValue) {
                case "sortby=ByRecommedation&sortorder=0":
                    // doporučení
                    data = data.sort(function (a, b) {
                        return b.sortingData.dynamix - a.sortingData.dynamix;
                    });
                    data = data.sort(function (a, b) {
                        return b.sortingData.recommendation - a.sortingData.recommendation;
                    });
                break;
                case "sortby=PriceFrom&sortorder=0":
                    // od nejlevnějšího
                    data = data.sort(function (a, b) {
                        return a.sortingData.price - b.sortingData.price;
                    });
                break;
                case "sortby=PriceFrom&sortorder=1":
                    // od nejdražšího
                    data = data.sort(function (a, b) {
                        return b.sortingData.price - a.sortingData.price;
                    });
                break;
                case "sortby=Rating.TripAdvisor&sortorder=1":
                    // dle hodnocení
                    data = data.sort(function (a, b) {
                        return b.sortingData.ratings - a.sortingData.ratings;
                    });
                break;
            }
            for (var hotelIndex = 0; hotelIndex < hotelsToShowCount; hotelIndex++) {
                var hotel = data[hotelIndex];
                html = html + global.mapsFcs.getLeftPanelHotel(hotel).outerHTML;
            }

            var notShownHotelsCount = hotelsCount - hotelsToShowCount;
            if (notShownHotelsCount > 0) {
                html = html + "<p class='fshr-paragraph fshr-paragraph--centered'>A " + global.getProperSuffix(notShownHotelsCount, global.localization.next.join(",")) + " " + notShownHotelsCount + " " + global.getProperSuffix(notShownHotelsCount, global.localization.hotels.join(",")) + ".</p>";
            }
            $wrapper.html(html);
        }
        //$parent.trigger("generated");
    }
    function generatePriceCatcher (data) {
        var localization = global.localization.priceCatcher;
        var cheapest = data.cheapest;

        var $header = $(".js-searchResult-header--hotelView .js-destinationTemplate");
        var $wrapper = $("<div class='fshr-searchResults-featured'></div>");
        var $oldCatcher = $header.find(".fshr-searchResults-featured");
        if ($oldCatcher.length) {
            $wrapper = $oldCatcher.html("");
        } else {
            // TODO
            //$header.after($wrapper);
        }

        var $content = $("<div class='fshr-list fshr-list--featured'></div>");
        var contentHtml = "";
        var minTitleLength = 18;
        var maxTitleLength = 23;
        $.each(cheapest, function () {
            var hotel = this;
            var imageHtml = "";

            var imageSrc = hotel.content.imageSrc;
            var stars = hotel.content.stars;
            var title = hotel.content.title;
            if (maxTitleLength < title.length) {
                title = title.substr(0, minTitleLength) + "&hellip;";
            }
            var nights = hotel.content.nights;
            var meal = hotel.content.meal;
            var price = hotel.content.priceText;

            if (imageSrc) {
                imageHtml = "<div class='fshr-featuredHotel-image'><div class='fshr-featuredHotel-imageItem'><img src='" + hotel.content.imageSrc + "' alt=''></div></div>";
            }
            var hotelHtml = "<div class='fshr-featuredHotel-content'>";
            if (stars) {
                var $stars = $("<span class='fshr-stars' data-stars='" + stars + "'></span>").each(global.generateStars);
                hotelHtml = hotelHtml + "<p class='fshr-paragraph'>" + $stars[0].outerHTML + "</p>";
            }
            if (title) {
                hotelHtml = hotelHtml + "<p class='fshr-paragraph'><strong class='fshr-title--upper'>" + title + "</strong></p>";
            }
            if (nights || meal) {
                if (nights && meal) {
                    nights = nights + " " + global.getProperSuffix(parseInt(nights, 10), global.localization.nights.join(",")) + " ";
                }
                hotelHtml = hotelHtml + "<p class='fshr-paragraph fshr-text--lower'>" + nights + meal + "</p>";
            }
            if (price) {
                var $price = $("<div>" + price + "</div>");
                var priceValue = $price.find(".fshr-price").html();
                hotelHtml = hotelHtml + "<p class='fshr-paragraph'><strong class='fshr-price'>" + priceValue + "/os.</strong></p>";
            }
            hotelHtml = hotelHtml + "</div>";

            contentHtml = contentHtml + "<div class='fshr-list-item'><a class='fshr-featuredHotel' href='" + hotel.url + "'>" + imageHtml + hotelHtml + "</a></div>";
        });
        $content.html(contentHtml);
        var $footer = $("<p class='fshr-paragraph fshr-paragraph--centered'><a href='#' class='js-remote-click' data-remote-selector='closest(.js-searchResult-header--hotelView)->find(.js-sorter .js-select-item[data-value=\"sortby=PriceFrom&sortorder=0\"] .js-select-handler)'>" + global.localization.cheapestFooter + "</a></p>");

        // $wrapper.append($content).append($footer);
        // TODO - change html and uncomment line above
    }
    function initializeResultsMap (resultsMap) {
        var $map = $(resultsMap.getDiv());
        var $body = $("body");

        var searchResultDataType = "hotels";
        if (typeof searchResultData !== "undefined" && searchResultData && searchResultDataType) {

            resultsMap.set("panControl", true);
            resultsMap.set("draggable", true);
            resultsMap.set("disableDoubleClickZoom", false);
            resultsMap.set("zoomControl", true);
            resultsMap.set("zoomControlOptions", {position: google.maps.ControlPosition.RIGHT_CENTER});
            resultsMap.set("mapTypeControlOptions", {
                style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                position: google.maps.ControlPosition.TOP_CENTER
            });
            resultsMap.set("streetViewControlOptions", {position: google.maps.ControlPosition.RIGHT_TOP});


            var allPlaces = [];

            var showStates = false;

            if (searchResultDataType == "group") {
                $body.addClass("fshr-groupView").removeClass("fshr-mapIsMaximized");
                /*
                showStates = true;
                for (var stateId in searchResultData) {
                    if (searchResultData.hasOwnProperty(stateId)) {
                        var state = searchResultData[stateId];

                        if (showStates) {
                            showStateOnMap(resultsMap, state);
                        }
                    }
                }
                */
            } else if (searchResultDataType == "hotels") {
                $body.removeClass("fshr-groupView");
                allPlaces = searchResultData;
                bounds = global.mapsFcs.showHotelsOnMap(resultsMap, allPlaces);

                var sortedPlacesByPrice = allPlaces.sort(function (a, b) {
                    return a.sortingData.price - b.sortingData.price;
                });
                var pricePlacesCount = 3;
                var sortedPlacesByPriceReduced = sortedPlacesByPrice.slice(0, pricePlacesCount);
                generatePriceCatcher({
                    cheapest: sortedPlacesByPriceReduced,
                    bestRated: []
                });

                resultsMap.fitBounds(bounds);
            }
            global.visibleMarkers = {
                data: searchResultData,
                type: searchResultDataType
            };
            if ($body.hasClass("fshr-mapIsMaximized")) {
                generateLeftPanel(global.visibleMarkers);
            }
        }
    }
    function initializeResultsMapLEAFLET (resultsMap) {

        var $map = $(resultsMap.getContainer());
        var $body = $("body");
        var variableName = $(".js-viewTypeSelected").first().attr("data-mapvariablename");
        if (!variableName || !window[variableName]) {
            variableName = "searchResultData";
        }

        var mapData = window[variableName];

        var searchResultDataType = "hotels";

        if (typeof mapData !== "undefined" && mapData) {

            var showMapPinsId = $(".fshr-searchResults-itemsWrapper").attr("data-filtered-ids") || "id01";
            var newSearchResultsData = [];

            if (showMapPinsId) {
                var showMapPinsIdArray = showMapPinsId.split("|");
                $.each(showMapPinsIdArray, function (index, id) {
                    $.each(mapData, function (index, data) {
                        if (data.id == id) {
                            newSearchResultsData.push(data);
                            return false;
                        }
                    });
                })

                mapData = newSearchResultsData;
            }


            /*
            resultsMap.set("panControl", true);
            resultsMap.set("draggable", true);
            resultsMap.set("disableDoubleClickZoom", false);
            resultsMap.set("zoomControl", true);
            resultsMap.set("zoomControlOptions", {position: google.maps.ControlPosition.RIGHT_CENTER});
            resultsMap.set("mapTypeControlOptions", {
                style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                position: google.maps.ControlPosition.TOP_CENTER
            });

             */
            //resultsMap.set("streetViewControlOptions", {position: google.maps.ControlPosition.RIGHT_TOP});


            var allPlaces = [];

            var showStates = false;

            if (searchResultDataType == "group") {
                var $button = $(".js-maximizeMinimizeMap");
                var $searchResults = $button.closest(".fshr-searchResults");
                var $buttonText = $button.find(".fshr-searchResults-barHandler-text");
                var $menuSearch = $(".js-menuSearch");
                var $searchResultFilters = $(".js-searchResultFilters");
                var $menuSearchContent = $(".fshr-searchMenu-content");

                minimizeMap($menuSearch, $searchResultFilters, $menuSearchContent, $body, $button, $buttonText, $searchResults);
                /*
                showStates = true;
                for (var stateId in searchResultData) {
                    if (searchResultData.hasOwnProperty(stateId)) {
                        var state = searchResultData[stateId];

                        if (showStates) {
                            showStateOnMap(resultsMap, state);
                        }
                    }
                }
                */
            } else if (searchResultDataType == "hotels") {
                $body.removeClass("fshr-groupView");
                allPlaces = mapData;
                bounds = global.mapsFcs.showHotelsOnMapLEAFLET(resultsMap, allPlaces);

                /*var sortedPlacesByPrice = allPlaces.sort(function (a, b) {
                    return a.sortingData.price - b.sortingData.price;
                });
                var pricePlacesCount = 3;
                var sortedPlacesByPriceReduced = sortedPlacesByPrice.slice(0, pricePlacesCount);
                generatePriceCatcher({
                    cheapest: sortedPlacesByPriceReduced,
                    bestRated: []
                });
                */

                if(ObjectLength(bounds)>0){
                    resultsMap.fitBounds(bounds);
                }
            }
            global.visibleMarkers = {
                data: mapData,
                type: searchResultDataType
            };
            if ($body.hasClass("fshr-mapIsMaximized")) {
                generateLeftPanel(global.visibleMarkers);
            }
            resultsMap.on("zoomend", function () {
                setTimeout(function () {
                    resultsMap.panBy([1,1]);
                });
            });
            resultsMap.on('moveend', function () {
                var map = this;
                var $map = $(map.getContainer());
                clearTimeout(boundsTimeoutId);
                boundsTimeoutId = setTimeout(function () {
                    var mapId = $map.attr("id");
                    var newBounds = map.getBounds();
                    var markers = global.commonMaps[mapId].markers || [];
                    var markersOnMap = [];
                    $.each(markers, function () {
                        var marker = this;
                        if (newBounds.contains(marker.getLatLng())) {
                            $.each(mapData, function(){
                                var dataItem = this;
                                if (marker.options.fshrMarkerId == dataItem.id) {
                                    markersOnMap.push(dataItem);
                                }
                            });
                        }
                    });
                    global.visibleMarkers.data = markersOnMap;

                    if ($("body").hasClass("fshr-mapIsMaximized")) {
                        generateLeftPanel(global.visibleMarkers);
                    }
                    $map.trigger("bounds-changed");
                    //$hotels.trigger("left-panel-changed");
                }, 500);
            });

        }
    }

    $(document).on("click", ".js-map-showAllStates", function (event) {
        event.preventDefault();
        var $map = $(".js-map--searchResults");
        var mapId = $map.attr("id");
        var resultsMap = global.commonMaps[mapId].map;
        resultsMap.controls[google.maps.ControlPosition.TOP_LEFT].clear();
        removeAllHotels(resultsMap);
        removeAllStates(resultsMap);
        for (var stateId in searchResultData) {
            if (searchResultData.hasOwnProperty(stateId)) {
                var state = searchResultData[stateId];
                bounds = showStateOnMap(resultsMap, state);
            }
        }
        resultsMap.fitBounds(bounds);
    });
    global.resetSearchMap = resetMapLEAFLET;

    function enableMapShow ($map) {
        $map.addClass("js-mapCouldBeShown");
        $map.find(".fshr-map-placeholderInfo").remove();
        if ($map.is(".js-pinsLoaded")) {
            $map.each(resetMapLEAFLET);
        } else {
            $map.addClass("fshr-mapLoading");
        }
    }
    $(document).on("mappins-updated", ".js-map--searchResults", resetMapLEAFLET);
    $(".js-map--searchResults").each(function () {
        var $map = $(this);
        enableMapShow($map);
    });


    $(document).on("mappins-updated ajax-loaded", "body", function () {
        $(".js-maximizeMinimizeMap .fshr-searchResults-barHandler-text").each(updateMaxMinButton);
    });

    $(document).on("change", ".js-mapHotelsSorter select.js-sorter", function () {
        generateLeftPanel(global.visibleMarkers);
    });

    $(document).on("click", ".js-maximizeMinimizeMap", function (event) {
        event.preventDefault();
        var $button = $(this);
        var hashToMaximize = $button.attr("data-map-hashtomaximize") || "#/map-maximized";
        var hashToMinimize = $button.attr("data-map-hashtominimize") || "#/map-minimized";
        var defaultState = $button.attr("data-map-defaultstate") || "minimized";

        var $body = $("body");
        if ($body.hasClass(cssClassMapMaximized)) {
            if (defaultState == "minimized") {
                window.location.hash = "";
            } else {
                window.location.hash = hashToMinimize.replace("#", "");
            }
        } else {
            if (defaultState == "maximized") {
                window.location.hash = "";
            } else {
                window.location.hash = hashToMaximize.replace("#", "");
            }
        }
    });
    $(document).on("menu-height-changed", function () {
        if ($googleMap.length && typeof google !== 'undefined') {
            google.maps.event.trigger(resultsMap, 'resize');
        }
    });
    function showPinOnMap (resultsMap, pinId) {
        var mapId = $(resultsMap.getContainer()).attr("id");
        var map = global.commonMaps[mapId];
        if ("markers" in map) {
            var mapPin = map.markers[pinId];
            if (mapPin) {
                var pinPosition = mapPin.getLatLng();
                resultsMap.setView(pinPosition, 16); /* max zoom 21 - min zoom 0 */
                var infoBoxes = global.commonMaps[mapId].infoBoxes;
                global.mapsFcs.openInfoBoxLEAFLET(infoBoxes[pinId], mapPin, resultsMap);
            }
        }
    }
    $(document).on("click", ".js-showOnMap", function (event) {
        event.preventDefault();
        var $element = $(this);
        var pinId = $element.attr("data-mappinid");
        var $map = $(".js-map--searchResults");
        /*
        if (!resultsMap || !("_container" in resultsMap)) {
            enableMapShow($map);
            $map.one("bounds-changed", function () {
                showPinOnMap(resultsMap, pinId);
            });
            $(document).on("mappins-updated", ".js-map--searchResults.js-mapPrepared", resetMap);
        } else {

         */
            showPinOnMap(resultsMap, pinId);
        //}
    });
    if ($googleMap.length) {
        $(window).on("hashchange load", function (event) {
            var $body = $("body");
            var $button = $(".js-maximizeMinimizeMap");
            var hashToMaximize = $button.attr("data-map-hashtomaximize") || "#/map-maximized";
            var hashToMinimize = $button.attr("data-map-hashtominimize") || "#/map-minimized";
            var defaultState = $button.attr("data-map-defaultstate") || "minimized";
            var $searchResults = $button.closest(".fshr-searchResults");
            var $buttonText = $button.find(".fshr-searchResults-barHandler-text");
            var $menuSearch = $(".js-menuSearch");
            var $searchResultFilters = $(".js-searchResultFilters");
            var $menuSearchContent = $(".fshr-searchMenu-content");
            var hash = window.location.hash;

            if (hash == hashToMinimize || (!hash.replace("#", "") && defaultState == "minimized")) {
                minimizeMap($menuSearch, $searchResultFilters, $menuSearchContent, $body, $button, $buttonText, $searchResults);
            } else if (hash == hashToMaximize || (!hash.replace("#", "") && defaultState == "maximized")) {
                maximizeMap($menuSearch, $searchResultFilters, $menuSearchContent, $body, $button, $buttonText, $searchResults);
            }

            /*
            if ("getCenter" in resultsMap) {
                var mapCenter = resultsMap.getCenter();
            }
            google.maps.event.trigger(resultsMap, 'resize');
            if ("set" in resultsMap) {
                resultsMap.set("center", mapCenter);
            }
             */

            setTimeout(function () {
                if (resultsMap !== null && "options" in resultsMap) {
                    global.resizeRecenterMap(resultsMap);
                    $(document).trigger("mapsize-change");
                }
            }, 300);

            $buttonText.css({
                marginLeft: 0
            });
            var textWidth = $buttonText.outerWidth();
            $buttonText.css({
                marginLeft: -textWidth
            });
        });
        $(document).on("mouseenter", ".js-mapActivePin", function () {
            var $mapActivePin = $(this);
            //var isAnimated = $mapActivePin.attr("data-mappin-animated");
            //if (!isAnimated && $googleMap.is(":visible")) {
            var mapId = $googleMap.attr("id");
            if ($googleMap.is(":visible")) {
                    stopAllPinsAnimation();
                    $mapActivePin.attr("data-mappin-animated", "true");
                    var pinId = $mapActivePin.attr("data-mappinid");
                    if ("commonMaps" in global && global.commonMaps[mapId]) {
                        var map = global.commonMaps[mapId];
                        if ("markers" in map) {
                            var mapPin = map.markers[pinId];
                            if (mapPin) {
                            map.map.eachLayer(function (layer) {
                                if ("getAllChildMarkers" in layer) {
                                    var markers = layer.getAllChildMarkers();
                                    $.each(markers, function (index, marker) {
                                        if (pinId == marker.options.fshrMarkerId) {
                                            var $cluster = $(layer._icon);
                                            if (!$cluster.is(".fshr-animation--pulsating")) {
                                                $cluster.addClass("fshr-animation--pulsating");
                                            }
                                        }
                                    });
                                } else if (layer.options && layer.options.fshrMarkerId) {
                                    if (pinId == layer.options.fshrMarkerId) {
                                        var $marker = $(layer._icon);
                                        if ($marker.length && !$marker.is(".fshr-animation--bounce")) {
                                            $marker.addClass("fshr-animation--bounce");
                                        }
                                    }
                                }
                                });
                            }
                        }
                    }
                }
        });
        $(document).on("mouseleave", ".js-mapActivePin", function () {
            stopAllPinsAnimation();
        });
        var boundsTimeoutId = 0;

        /*
        $(document).on("mousemove", function (event) {
            var $element = $(event.target);
            var $mapActivePin = $element.closest(".js-mapActivePin");
            var isMapPinTrigger = $mapActivePin.length;
            var mapId = $googleMap.attr("id");
            if (isMapPinTrigger) {
            } else {
            }

        });

         */
    }

    $(".js-maximizeMinimizeMap .fshr-searchResults-barHandler-text").each(updateMaxMinButton);

})(jQuery, globalWrapper.fshr);




/* TO DISABLE */
/**
 * map fixed
 * */
(function ($, global) {
    var changeTimeoutId = 0;
    function handleMapFixing () {
        var $window = $(window);
        var viewportHeight = $window.outerHeight();
        var fixedWithMapHeight = 0;
        var fixedWithMapMaxHeight = 0;
        var $fixedWithMap = $(".js-fixedWithMap:visible");
        $fixedWithMap.each(function () {
            fixedWithMapHeight = fixedWithMapHeight + $(this).outerHeight();
        });

        var $exclude = $(".js-viewportHeightExclude:visible");
        var excludeHeight = 0;
        $exclude.each(function () {
            excludeHeight = excludeHeight + $(this).outerHeight(true);
        });

        var $map = $(this);
        var $mapParent = $map.closest(".js-fixedMap-parent");
        var viewportScrollTop = $window.scrollTop();
        var mapParentTopPosition = $mapParent.offset().top;
        var mapParentHeight = $mapParent.height();
        var $mapSizeHandler = $mapParent.find(".js-mapSizeHandler");
        var $body = $('body');
        if (mapParentHeight > viewportHeight) {
            var top = 0;
            if ((viewportScrollTop <= mapParentTopPosition - fixedWithMapHeight)) {
                // map is top
                $map.removeClass("fshr-searchResultsMap--sticked fshr-searchResultsMap--bottom");
                $body.removeClass("fshr-mapIsBottom fshr-mapIsSticked");
                $mapSizeHandler.css({
                    top: 0
                });
                $fixedWithMap.css({
                    top: ""
                });
                $map.css({
                    top: ""
                });
                $mapParent.css ({
                    top: ""
                });
            } else if ((viewportScrollTop + viewportHeight) >= (mapParentHeight + mapParentTopPosition)) {
                // map is bottom
                $map.removeClass("fshr-searchResultsMap--sticked");
                $map.addClass("fshr-searchResultsMap--bottom");
                $body.addClass("fshr-mapIsBottom");
                $body.removeClass("fshr-mapIsSticked");
                $mapSizeHandler.css({
                    top: "auto",
                    bottom: 0
                });
                $map.css({
                    top: ""
                });
                var fixedHeight = viewportHeight - $map.outerHeight();
                var $cookiesInformation = $("#cookies-information");
                var correction = 0;
                if ($cookiesInformation.length) {
                    correction = $cookiesInformation.outerHeight();
                }
                $fixedWithMap.each(function () {
                    var $element = $(this);
                    var initialOffsetTop = parseInt($element.attr("data-initial-offsettop"), 10) || 1;
                    if (initialOffsetTop > 1) {
                        initialOffsetTop = initialOffsetTop + correction;
                    }
                    $element.css("top", $map.offset().top - fixedHeight + top - initialOffsetTop);
                    top = top + $element.outerHeight() - 1;
                });
            } else {
                // map is sticked
                $map.addClass("fshr-searchResultsMap--sticked");
                $map.removeClass("fshr-searchResultsMap--bottom");
                $body.addClass("fshr-mapIsSticked");
                $body.removeClass("fshr-mapIsBottom");

                $map.css({
                    top: fixedWithMapHeight
                });
                $fixedWithMap.each(function () {
                    var $element = $(this);
                    $element.css("top", top);
                    top = top + $element.outerHeight();
                });
                $mapSizeHandler.css({
                    top: viewportScrollTop - mapParentTopPosition + top
                });
            }
        } else {
            $map.removeClass("fshr-searchResultsMap--sticked fshr-searchResultsMap--bottom");
            $body.removeClass("fshr-mapIsBottom fshr-mapIsSticked");
            $map.css({
                top: ""
            });
            $fixedWithMap.css({
                top: ""
            });
            $mapSizeHandler.css({
                top: 0
            });
        }
    }
    $(window).on("scroll resize content-change gtm-domChange", function (event) {
        event.preventDefault();
        $(".js-map--fixed").each(handleMapFixing);
    });

    $(".js-menuSearch-content").each(function () {
        var $element = $(this);
        var initialOffsetTop = $element.parent().offset().top;
        $element.attr("data-initial-offsettop", initialOffsetTop);
    });
    $(".js-map--fixed").each(handleMapFixing);
})(jQuery, globalWrapper.fshr);



/**
 * carousel initializer
 * */
(function ($, global) {
    function handleLazyLoad (slick, slideIndex) {
        var $slides = slick.$slides;

            var slidesCount = $slides.length;
            var windowWidth = window.outerWidth;
            var edgeIndex = 0;
            var isEdgeIndex = (slideIndex == 0) || (slideIndex == slidesCount - 1);
            if (slideIndex == slidesCount - 1) {
                edgeIndex = slidesCount - 1;
            }
            var items = [];
            items.push($slides.eq(slideIndex));
            if (isEdgeIndex) {
                items.push($slides.eq(edgeIndex));
            }
            $.each(items, function (index, item) {
                var $item = $(item);
                var $lazyLoad = $item.find(".js-lazyCarouselLoad");
                $lazyLoad.each(function () {
                    global.handleLazyLoad($(this));
                });
            });

    }
    function initializeCarousel () {
        var $this = $(this);
        var slidesToShow = $this.attr("data-carousel-toshow") || 1;
        var $children = $this.children();

        var responsiveArray = [];
        var forceInitialize = false;

        if($(this).is(".js-carousel-photogallery")){
            responsiveArray = [{
                breakpoint: 900,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1
                }
            }];
        }

        if ($this.is(".fshr-carousel--benefits")) {
            responsiveArray = [{
                breakpoint: 900,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1
                }
            }];
        }

        $this.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
            handleLazyLoad(slick, nextSlide);
        });
        if (true || ($children.length > slidesToShow || forceInitialize)) {
            var showDots = $this.is("[data-carousel-showdots]");
            var slidesToScroll = $this.attr("data-carousel-toscroll") || 1;
            var autoScroll = $this.is("[data-carousel-autoscroll]");
            var autoScrollSpeed = parseInt($this.attr("data-carousel-autoscroll"), 10) || 500;
            var customPagingVar = $this.attr("data-custom-paging") || undefined;
            var navConainerClass = $this.attr("data-nav-container-class") || "";
            customPagingVar = window[customPagingVar];

            $this.slick({
                slidesToShow: slidesToShow,
                slidesToScroll: slidesToScroll,
                adaptiveHeight: true,
                dots: showDots,
                useCSS: false,
                autoplay: autoScroll,
                autoplaySpeed: autoScrollSpeed,
                prevArrow: '<span class="slick-prev fshr-icon fshr-icon--caretLeft"></span>',
                nextArrow: '<span class="slick-next fshr-icon fshr-icon--caretRight"></span>',
                responsive: responsiveArray,
                customPaging: customPagingVar,
                dotsClass: navConainerClass
            });
        }
    }

    var $carousels = $(".js-carousel");
    $carousels.on("refilter", function (event) {
        var $carousel = $(this);
        $carousel.slick("slickUnfilter");
        $carousel.slick("slickFilter", ":not(.fshr-hidden)");
        setTimeout(function () {
            var slick = $carousel.slick("getSlick");
            var currentSlideIndex = $carousel.slick("slickCurrentSlide");
            handleLazyLoad(slick, currentSlideIndex);
        });
    });

    $("body").on("init", ".js-carousel", function (event, slick) {
        handleLazyLoad(slick, 0);
        var $carousel = $(this);
        setTimeout(function () {
            $carousel.trigger("refilter");
        });
    });

    $carousels.each(initializeCarousel);


    $("body").on("initialize-carousel", ".js-carousel", initializeCarousel);

    var carouselTimeoutId = 0;
    $(window).on("resize", function () {
        clearTimeout(carouselTimeoutId);
        carouselTimeoutId = setTimeout(function () {
            $(".slick-initialized").slick('slickGoTo', 0, true);
        }, 5);
    });
})(jQuery, globalWrapper.fshr);



/**
 * tooltip
 * */
(function ($, global) {
    $(".js-tooltip").each(global.initializeQtip);
})(jQuery, globalWrapper.fshr);



/* TO DISABLE */
/**
 * same checkboxes
 * */
(function ($, global) {
    $(document).on("change remote-change", ".js-sameCheckboxes input[type=checkbox]", function (event) {
        var $checkbox = $(this);
        var isCascade = $checkbox.closest(".js-cascadeCheckboxes").length;
        if (!isCascade) {
            var $checkboxes = global.checkSameCheckbox($checkbox);
            $checkboxes.trigger("custom-change");
        }
    });
})(jQuery, globalWrapper.fshr);




/**
 * tags
 * */
(function ($, global) {
    function showTag ($checkbox) {
        var value = $checkbox.attr("data-tag-value") || $checkbox.closest("label").text();
        var id = $checkbox.attr("data-tag-id");
        var $tagsPool = $checkbox.closest(".js-tags").find(".js-tags-pool");
        var $tag = $tagsPool.find(".js-tag[data-tag-id=" + id + "]");
        if ($tag.length) {
            $tag.removeClass("fshr-hidden");
        } else {
            $tag = $("<span class='fshr-searchHelper-tag js-tag' data-tag-id='" + id + "'>" + value + "</span>");
            $tagsPool.append($tag);
        }
    }
    function handleTags ($tags) {
        var $tagsPool = $tags.find(".js-tags-pool");
        var $tagsToRemove = $tagsPool.find(".js-tag:not(.fshr-hidden)");
        $tagsToRemove.addClass("fshr-hidden");
        var $checkboxes = $tags.find(".js-search-item input[type=checkbox]:checked");
        var $parentsChecked = $checkboxes.filter("[data-checkbox-id]");
        $checkboxes.each(function () {
            var $checkbox = $(this);
            var itemId = $checkbox.attr("data-item-id");
            if (!itemId) {
                itemId = $checkbox.attr("data-tag-id");
                if (!itemId) {
                    itemId = "id" + (new Date().getTime());
                    var $closestElement = $checkbox.parent().parent();
                    if ($closestElement.is("li")) {
                        itemId = itemId + "li";
                    }
                    itemId = itemId + $closestElement.index();
                }
            }
            $checkbox.attr("data-tag-id", itemId);
            var show = $checkbox.prop("checked");
            var parentId = $checkbox.attr("data-parentcheckbox-id");
            if (parentId) {
                var $parentCheckbox = $parentsChecked.filter("[data-checkbox-id=" + parentId + "]");
                show = !$parentCheckbox.length;
            }
            if (show) {
                showTag($checkbox);
            }
        });
        $tags.trigger("tags-change-finished");
    }
    var eventTimeoutId = 0;
    $(document).on("cascade-change-finished", ".js-tags", function () {
        var $tags = $(this);
        clearTimeout(eventTimeoutId);
        eventTimeoutId = setTimeout(function () {
            handleTags($tags);
        }, 100);
    });
    $(document).on("click", ".js-tag", function (event) {
        event.preventDefault();
        var $tag = $(this);
        var id = $tag.attr("data-tag-id");
        var $tagsParent = $tag.closest(".js-tags");
        var $checkboxes = $tagsParent.find(".js-search-item input[type=checkbox][data-tag-id=" + id + "]");
        $checkboxes.prop("checked", false);
        $checkboxes.trigger("change");
    });
    $(document).on("tags-change-finished", ".js-tags", function () {
        var $tags = $(this);

        var $tagsPool = $tags.find(".js-tags-pool");
        var $activeTags = $tagsPool.find(".js-tag:not(.fshr-hidden)");
        var activeTagsCount = $activeTags.length;
        if (activeTagsCount) {
            if (!$tags.is(".fshr-tags--shown")) {
                $activeTags.addClass("fshr-hidden");
                var tagsTimeoutId = setTimeout(function () {
                    $activeTags.removeClass("fshr-hidden");
                }, 200);
                $tags.attr("data-tagstimeoutid", tagsTimeoutId);
            }
            $tags.addClass("fshr-tags--shown");
        } else {
            $tags.removeClass("fshr-tags--shown");
            clearTimeout(parseInt($tags.attr("data-tagstimeoutid"), 10));
        }
    });
    $(".js-tags").each(function () {
        var $tags = $(this);
        handleTags($tags);
    });
})(jQuery, globalWrapper.fshr);


/* TO DISABLE */
/**
 * cols creator
 * */
(function ($, global) {

    var createCol = function (){
        var $colsParent = $(this);
        var colsCount = parseInt($colsParent.attr("data-cols-count"), 10) || 3;
        var itemsSelector = $colsParent.attr("data-cols-selector") || "find(label)";
        var $colItems = global.getElementsBySelector(itemsSelector, $colsParent);
        var itemsCount = $colItems.length;

        var itemsPerCol = Math.ceil(itemsCount / colsCount);

        var columnsHtml = "<div class='grd-col grd-col--4 grd-col--md-6'>";

        var itemsInCol = 0;
        var subItemStarted = false;
        var stateStarted = false;

        $colItems.each(function () {
            var $colItem = $(this);
            itemsInCol = itemsInCol + 1;

            var isState = $colItem.parent().is(".fshr-list-item");


            if (isState) {
                if (itemsInCol != itemsPerCol) {
                    if (stateStarted) {
                        columnsHtml = columnsHtml + "</div><!-- .fshr-list-item -->";
                    }

                    if (subItemStarted) {
                        columnsHtml = columnsHtml + "</ul>";
                        subItemStarted = false;
                    }

                    columnsHtml = columnsHtml + "<div class='fshr-list-item'>";
                    columnsHtml = columnsHtml + $colItem[0].outerHTML;
                    stateStarted = true;
                }
            } else {
                // is destination

                if (!stateStarted) {
                    columnsHtml = columnsHtml + "<div class='fshr-list-item'>";
                    stateStarted = true;
                }
                if (!subItemStarted) {
                    columnsHtml = columnsHtml + "<ul>";
                    subItemStarted = true;
                }
                columnsHtml = columnsHtml + "<li>" + $colItem[0].outerHTML + "</li>";


            }

            if (itemsInCol == itemsPerCol && itemsInCol < (itemsCount - 1)) {
                if (subItemStarted) {
                    columnsHtml = columnsHtml + "</ul>";
                }
                if (stateStarted) {
                    columnsHtml = columnsHtml + "</div><!-- .fshr-list-item -->";
                }
                columnsHtml = columnsHtml + "</div><div class='grd-col grd-col--4 grd-col--md-6'>";
                subItemStarted = false;
                stateStarted = false;
                if (isState) {
                    columnsHtml = columnsHtml + "<div class='fshr-list-item'>";
                    columnsHtml = columnsHtml + $colItem[0].outerHTML;
                    stateStarted = true;
                }
                itemsInCol = 0;
            }
        });


        if (subItemStarted) {
            columnsHtml = columnsHtml + "</ul>";
        }
        columnsHtml = columnsHtml + "</div></div>";
        $colsParent.html(columnsHtml);
    };

    $("body").on("create-col", ".js-createCols", function () {
        createCol.apply(this);
    });

    $(".js-createCols").each(function () {
        createCol.apply(this);
    });
})(jQuery, globalWrapper.fshr);


/* TO DISABLE */
/**
 * Fit viewport height
 */
(function ($, global) {
    var $window = $(window);
    var viewportHeight = $window.outerHeight();

    function fitViewportHeight () {
        var $element = $(this);
        var excludeFromHeightSelector = $element.attr("data-viewportheight-exclude-selector") || ".js-viewportHeightExclude:visible";
        var $excludeElements = global.getElementsBySelector(excludeFromHeightSelector, $element);
        var excludedHeight = 0;
        $excludeElements.each(function () {
            excludedHeight = excludedHeight + $(this).outerHeight();
        });
        var setAs = $element.attr("data-viewportheight-setas") || "height";
        if (setAs == "min-height") {
            //excludedHeight = 0;
        }
        $element.css(setAs, viewportHeight - excludedHeight);
    }

    $(".js-fitViewportHeight").each(fitViewportHeight);
    $window.on("resize content-change menu-height-changed gtm-domChange", function () {
        viewportHeight = $window.outerHeight();
        $(".js-fitViewportHeight").each(fitViewportHeight);
    });
})(jQuery, globalWrapper.fshr);


/**
 * open gallery filter after open
 * */
(function ($, global) {
    var filterSelector = "";
    var itemIndex = 0;
    function afterGalleryOpen () {
        var $gallery = $(this);
        var $filter = $gallery.find(filterSelector);
        $filter.trigger("click");
        $gallery.find(".js-gallery-thumbnail-wrapper:visible").eq(itemIndex).find(".js-gallery-thumbnail").trigger("click");
        $gallery.off("gallery-after-open", afterGalleryOpen);
    }

    $(".js-openGalleryFilter").on("click", function (event) {
        event.preventDefault();
        var $this = $(this);
        filterSelector = $this.attr("data-opengalleryfilter-selector") || ".js-gallery-filter-item[data-gallery-default]";
        itemIndex = $this.attr("data-gallery-thumbnailindex") || 0;
        var $triggerElement = global.getElementsBySelector($this.attr("data-gallery-triggerselector") || $this.attr("href"), $this);
        if ($triggerElement) {
            var $galleryElement = $($triggerElement.attr("data-gallery-selector") || $triggerElement.attr("href"));

            if ($galleryElement) {
                $galleryElement.off("gallery-after-open", afterGalleryOpen);
                $galleryElement.on("gallery-after-open", afterGalleryOpen);
                $triggerElement.trigger("click");
            }
        }

    });
})(jQuery, globalWrapper.fshr);


/**
 * open gallery after close
 * */
(function ($, global) {
    $(".js-gallery").on("gallery-close gallery-after-open", function (event) {
        var $body = $("body");
        if (event.type == "gallery-close") {
            $body.removeClass("fshr-galleryOpen");
        } else {
            $body.addClass("fshr-galleryOpen");
        }
    });
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 * sticky element
 * */
(function ($, global) {
    $(window).on("scroll load resize", function (event) {
        var $window = $(this);
        var viewportTopEdge = $window.scrollTop();
        var viewportWidth = $window.outerWidth();
        var $excludeTop = $(".js-fixedMenu");
        var excludeHeight = parseInt($excludeTop.outerHeight(), 10) || 0;

        $(".js-sticky").each(function () {
            var $stickyElement = $(this);
            var $stickyParent = $stickyElement.closest(".js-stickyParent");
            var parentWidth = $stickyParent.outerWidth();
            var stickyHeight = $stickyElement.outerHeight();

            if (event.type == "load" || event.type == "resize") {
                $stickyElement.removeClass("fshr-sticky");
                $stickyElement.css({
                    width: ""
                });
                var stickyWidth = $stickyElement.outerWidth() - 1;
                $stickyElement.css({
                    width: stickyWidth
                });
            }
            var parentPaddingTop = parseInt($stickyParent.css("padding-top"), 10);
            var parentTopEdge = $stickyParent.offset().top + parentPaddingTop - excludeHeight;
            var parentHeight = $stickyParent.height();
            var stickyRight = $stickyParent.offset().left + parseInt($stickyParent.css("padding-right"), 10);
            var parentBottomEdge = parentTopEdge + parentHeight - stickyHeight;


            if (viewportTopEdge >= parentTopEdge && viewportTopEdge <= parentBottomEdge) {
                $stickyElement.addClass("fshr-sticky");
                $stickyElement.removeClass("fshr-bottom");
                $stickyElement.css({
                    right: stickyRight,
                    top: parentPaddingTop + excludeHeight
                })
            } else if (viewportTopEdge > parentBottomEdge) {
                $stickyElement.removeClass("fshr-sticky");
                $stickyElement.addClass("fshr-bottom");
                $stickyElement.css({
                    right: "",
                    top: ""
                })
            } else {
                $stickyElement.removeClass("fshr-sticky fshr-bottom");
            }
        });
    });
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 * handle wysiwyg output
 * */
(function ($, global) {
    $(".htmlText img.js-titled").each(function () {
        var $image = $(this);
        var title = $image.attr("title");
        if (title.length) {
            var imageClasses = $image.attr("class");
            $image.removeAttr("class");

            var $titledImage = $("<div class='" + imageClasses + " titledImage'></div>");
            $titledImage.append($image.clone());
            $titledImage.append("<span class='titledImage-title'>" + title + "</span>");
            $image.replaceWith($titledImage);
        }
    });
})(jQuery, globalWrapper.fshr);


/**
 * handle responsive menu
 * */
(function ($, global) {
    var responsiveMenuWidth = 900;
    var mobileMenuWidth = 584;

    $(document).on("click", ".js-mainMenu-responsive", function (event) {
        var $menu = $(this);
        var viewportWidth = $(window).outerWidth();
        if (viewportWidth <= responsiveMenuWidth) {
            var $target = $(event.target);
            var isTopMenu = !$target.closest(".fshr-mainMenu-menu-item").length;
            var isSubMenu = $target.is(".js-mainMenu-responsive-openSubMenu");

            if (isTopMenu) {
                if ($target.hasClass("fshr-mainMenu--active")) {
                    $("body").removeClass("fshr-menuIsOpened");
                    $target.removeClass("fshr-mainMenu--active");
                } else {
                    $("body").addClass("fshr-menuIsOpened");
                    $target.addClass("fshr-mainMenu--active");
                }
            } else if (isSubMenu) {
                event.preventDefault();
                var $parent = $target.closest(".fshr-mainMenu-menu-item");
                if ($parent.hasClass("fshr-mainMenu-subMenu--active")) {
                    $parent.removeClass("fshr-mainMenu-subMenu--active");
                } else {
                    if (viewportWidth > mobileMenuWidth) {
                        $menu.find(".fshr-mainMenu-subMenu--active").removeClass("fshr-mainMenu-subMenu--active");
                    }
                    $parent.addClass("fshr-mainMenu-subMenu--active");
                }
            }
        }
        $menu.trigger("menu-height-changed");
    });
    $(document).on("click", ".fshr-menuIsOpened .fshr-mainMenu", function (event) {
        if (global.widths.window <= global.widths.mobile) {
            var $body = $("body");
            var closeMarkSize = 50;
            var mousePosition = {
                x: (event.originalEvent && event.originalEvent.touches && event.originalEvent.touches[0]) ? event.originalEvent.touches[0].pageX : event.pageX,
                y: (event.originalEvent && event.originalEvent.touches && event.originalEvent.touches[0]) ? event.originalEvent.touches[0].pageY : event.pageY
            };
            var cursorIsInCloseMark = {
                horizontal: (mousePosition.x <= global.widths.window) && (mousePosition.x >= (global.widths.window - closeMarkSize)),
                vertical: (mousePosition.y <= closeMarkSize) && (mousePosition.y >= 0)
            };

            if (cursorIsInCloseMark.horizontal && cursorIsInCloseMark.vertical && $body.is(".fshr-menuIsOpened")) {
                $body.removeClass("fshr-menuIsOpened");
                $(".js-mainMenu-responsive.fshr-mainMenu--active").removeClass("fshr-mainMenu--active");
            }
        }
    });
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 * mobile tabs menu
 * */
(function ($, global) {
    var $mobileTab = $(".js-tabsNavigation-mobile");
    if ($mobileTab.length) {
        var $parent = $mobileTab.closest(".js-tabParent");
        var menuTopEdge = $mobileTab.offset().top;
        var menuBottomEdge = menuTopEdge + $mobileTab.outerHeight();
        var $menuHandler = $(".js-tabsNavigation-menuHandler");

        $(window).on("load resize scroll tab-change", function () {
            var $window = $(this);
            var parentBottom = $parent.offset().top + $parent.outerHeight();
            var topEdge = $window.scrollTop();
            var bottomEdge = topEdge + $window.outerHeight();

            if (bottomEdge > parentBottom) {
                $menuHandler.removeClass("fshr-showMenuHandler");
            } else if (topEdge > menuBottomEdge) {
                $menuHandler.addClass("fshr-showMenuHandler");
            } else {
                $menuHandler.removeClass("fshr-showMenuHandler");
            }
        });
    }
})(jQuery, globalWrapper.fshr);


/**
 * responsive subMenu
 * */
(function ($, global) {
    var $responsiveSubMenus = $(".js-responsiveSubMenu");
    $responsiveSubMenus.each(function () {
        var $subMenu = $(this);
        var $menuWrapper = $("<div></div>", {
            "class": "fshr-responsiveSubMenu-wrapper"
        });
        var $menuHeader = $("<div></div>", {
            "class": "fshr-responsiveSubMenu-header"
        });
        var $closeButton = $("<a href='#' class='fshr-popupWindow-close js-responsiveSubMenu--close'>×</a>");
        var titleText = $subMenu.attr("data-responsivetitle");
        if (titleText) {
            var $title = $("<p class='fshr-responsiveSubMenu-title'>" + titleText + "</p>");
            $menuHeader.append($title);
        }
        $menuHeader.append($closeButton);
        var $menuContent = $("<div></div>", {
            "class": "fshr-responsiveSubMenu-content"
        });
        var $opener = $("<div class='fshr-responsiveSubMenu-opener js-responsiveSubMenu--open'></div>");
        $subMenu.wrap($menuWrapper).wrap($menuContent);
        $subMenu.before($menuHeader);
        $subMenu.after($opener);
    });
    $(document).on("click", ".js-responsiveSubMenu--open", function (event) {
        event.preventDefault();
        $("body").addClass("fshr-responsiveSubMenu--opened");
    });
    $(document).on("click", ".js-responsiveSubMenu--close", function (event) {
        event.preventDefault();
        $("body").removeClass("fshr-responsiveSubMenu--opened");
    });


    if ($responsiveSubMenus.length) {
        var $parent = $(".js-responsiveSubMenu-parent");
        var $menuHandler = $(".js-responsiveSubMenu--open");
        var parentHeight = $parent.outerHeight();
        var menuHandlerHeight = $menuHandler.outerHeight();

        if ($parent.length) {
            $(window).on("load resize scroll menu-height-changed", function () {
                var $window = $(window);
                var parentTop = $parent.offset().top;
                var parentBottom = parentTop + parentHeight;
                var menuHandlerBottom = parentTop + menuHandlerHeight + 40;
                var topEdge = $window.scrollTop();
                var bottomEdge = topEdge + $window.outerHeight();
                var centerEdge = topEdge + ($window.outerHeight() / 2);

                if (centerEdge > parentBottom) {
                    // menu is hidden
                    $menuHandler.addClass("fshr-responsiveSubMenu--hidden");
                } else if (centerEdge > menuHandlerBottom) {
                    // menu is sticky
                    $menuHandler.addClass("fshr-responsiveSubMenu--fixed");
                    $menuHandler.removeClass("fshr-responsiveSubMenu--hidden");
                } else {
                    // menu is absolute positioned on top
                    $menuHandler.removeClass("fshr-responsiveSubMenu--fixed fshr-responsiveSubMenu--hidden");
                }
            });
        }
    }
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 * handle mobile scroll
 * */
(function ($, global) {
    var scrollTimeoutId = 0;
    var touchTimeoutId = 0;
    $(document).on({
        scroll: function () {
            $("body").addClass("fshr-pageScrolled");
            clearTimeout(scrollTimeoutId);
            scrollTimeoutId = setTimeout(function () {
                $("body").removeClass("fshr-pageScrolled");
            }, 500);
        },
        touchstart: function (event) {
            var $target = $(event.target);
            clearTimeout(scrollTimeoutId);
            clearTimeout(touchTimeoutId);
            if (!$target.closest(".fshr-searchResults-barHandler").length) {
                $("body").addClass("fshr-touchStarted");
            } else {
                $("body").removeClass("fshr-touchStarted");
            }
        },
        touchend: function () {
            touchTimeoutId = setTimeout(function () {
                $("body").removeClass("fshr-touchStarted");
            }, 300);
        }
    });
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 * DOM filter
 * */
(function ($, global) {
    var timeoutId = 0;
    var filterDelay = 500;

    function createFilterSelect (dataForSelect, placeholderSelector) {
        if (!placeholderSelector) {
            placeholderSelector = ".js-filterSelectPlaceholder";
        }
        var $placeholder = $(placeholderSelector);
        var $select = $("<select multiple data-filter-attribute='data-flight-airlines' class='js-selectCustom js-select-with-default fshr-centeredWithSliders'></select>");
        $select.append("<option data-select-default data-change-detection-default data-value>Nerozhoduje</option>");
        if (dataForSelect && dataForSelect.length) {
            $.each(dataForSelect, function (index, value) {
                var id = value.id;
                var title = value.title;
                $select.append("<option data-value='" + id + "'>" + title + "</option>");
            });
        }
        $placeholder.replaceWith($select);
        $select.each(global.selectToHtml);
    }
    global.createFilterSelect = createFilterSelect;

    $(document).on("change-detected cascade-change-finished change", ".js-domFilter", function () {
        var $filterContent = $(this);
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () {
            var filteredSelector = $filterContent.attr("data-filteredcontent-selector") || "closest(.js-popupWindow)->find(.js-filteredContent)";
            var $filteredContent = global.getElementsBySelector(filteredSelector, $filterContent);
            var $nothingFoundText = $filterContent.parent().find(".js-filter-nothingFound");
            var $filteredItems = $filteredContent.find(".js-filtered-item");
            var $selects = $filterContent.find("select");
            var values = {};

            $selects.each(function () {
                var $select = $(this);
                var forAttribute = $select.attr("data-filter-attribute");
                if (forAttribute) {
                    values[forAttribute] = values[forAttribute] || [];

                    var $selectedOptions = $select.find("option:selected");
                    $selectedOptions.each(function () {
                        var $option = $(this);
                        var value = $option.attr("data-value");
                        values[forAttribute].push(value);
                    });
                }
            });

            var $itemsToHide = $filteredItems.filter(function () {
                var $item = $(this);
                var departureTimeValue = parseInt($item.attr("data-flight-departuretime"), 10);
                var returnTimeValue = parseInt($item.attr("data-flight-returntime"), 10);
                var airlinesValue = $item.attr("data-flight-airlines");

                var departureFilterData = values["data-flight-departuretime"];
                var returnFilterData = values["data-flight-returntime"];
                var airlinesFilterData = values["data-flight-airlines"];

                var returnValue = true;

                var departureSet = (parseInt(departureFilterData[0], 10) <= departureTimeValue && departureTimeValue <= parseInt(departureFilterData[1], 10));
                var returnSet = (parseInt(returnFilterData[0], 10) <= returnTimeValue && returnTimeValue <= parseInt(returnFilterData[1], 10));
                var airlinesSet = false;
                if (airlinesFilterData.length) {
                    $.each(airlinesFilterData, function (index, value) {
                        var expression = new RegExp(value, "ig");
                        if (expression.test(airlinesValue)) {
                            airlinesSet = true;
                            return false;
                        }
                    });
                } else {
                    airlinesSet = true;
                }

                if (departureSet && returnSet && airlinesSet) {
                    returnValue = false;
                }

                return returnValue;
            });

            if ($filteredItems.length != $itemsToHide.length) {
                $nothingFoundText.hide();
                $filteredContent.show();
                $filteredItems.show();
                $itemsToHide.hide();
            } else {
                $nothingFoundText.show();
                $filteredContent.hide();
            }

        }, filterDelay);
    })
})(jQuery, globalWrapper.fshr);



/**
 *  set same height
 *  */
(function ($, global) {
    function getMaximumHeight ($items) {
        var maximumHeight = 0;
        $items.each(function () {
            var $this = $(this);
            $this.css({
                height: "",
                paddingTop: "",
                paddingBottom: ""
            });
            var height = $this.height();
            if (height > maximumHeight) {
                maximumHeight = height;
            }
        });
        return maximumHeight;
    }
    function getSetDefaultPadding ($item) {
        var padding = {
            top: 0,
            bottom: 0
        };

        var paddingTopDataAttr = "data-default-paddingtop";
        padding.top = $item.attr(paddingTopDataAttr);
        if (typeof padding.top === "undefined") {
            padding.top = $item.css("padding-top");
            $item.attr(paddingTopDataAttr, parseInt(padding.top, 10));
        }

        var paddingBottomDataAttr = "data-default-paddingbottom";
        padding.bottom = $item.attr(paddingBottomDataAttr);
        if (typeof padding.bottom === "undefined") {
            padding.bottom = $item.css("padding-bottom");
            $item.attr(paddingBottomDataAttr, parseInt(padding.bottom, 10));
        }

        return padding;
    }
    function setSameHeight () {
        var $this = $(this);
        var selectorsSource = $this.attr("data-sameheight-selector") || ".js-sameHeight-item";
        var isContentCentering = $this.is("[data-sameheight-centered]");
        var selectors = selectorsSource.split(";");
        var selectorsCount = selectors.length;
        for (var index = 0; index < selectorsCount; index++) {
            var selector = selectors[index];
            var $items = $this.find(selector);
            var maximumHeight = getMaximumHeight($items);

            $items.each(function () {
                var $item = $(this);
                var itemHeight = $item.height();
                if (itemHeight < maximumHeight) {
                    if (!isContentCentering && !$item.attr("data-sameheight-centered")) {
                        $item.height(maximumHeight);
                    } else {
                        var padding = getSetDefaultPadding($item);
                        var heightDifference = (maximumHeight + parseInt(padding.top, 10) + parseInt(padding.bottom, 10)) - $item.outerHeight();
                        var paddingRaiseBy = heightDifference / 2;
                        $item.css({
                            paddingTop: parseInt(padding.top, 10) + paddingRaiseBy,
                            paddingBottom: parseInt(padding.bottom, 10) + paddingRaiseBy
                        });
                    }
                }
            });
        }
        global.invalidateMaps();
    }
    $(window).on("load", function () {
        $(".js-sameHeight:visible").each(setSameHeight);
    });
    setTimeout(function () {
        $(".js-sameHeight:visible").each(setSameHeight);
    }, 0);
    $(document).on("set-same-height", ".js-sameHeight:visible", function () {
        $(this).each(setSameHeight);
    });
    var timeout = 0;
    $(window).on("resize",  function () {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            $(".js-sameHeight:visible").each(setSameHeight);
        }, 100);
    });
})(jQuery, globalWrapper.fshr);



/**
 * lazy load
 * */
(function ($, global) {
    $(document).on("need-to-load", ".js-lazyLoad", function (event, scrollTop, viewportHeight) {

        var scrollTreshold = 150; // in px
        if (isNaN(scrollTop)) {
            scrollTop = $(window).scrollTop();
        }
        if (isNaN(viewportHeight)) {
            viewportHeight = $(window).outerHeight();
        }
        scrollTop = scrollTop - scrollTreshold;

        var viewportBottom = scrollTop + viewportHeight + scrollTreshold;

        var $lazyLoadItem = $(this);
        if($lazyLoadItem.is(":visible")){
            var isLazyLoadItemImage = $lazyLoadItem.is("img");
            var $lazyLoadReferenceItem = isLazyLoadItemImage ? $lazyLoadItem.parent() : $lazyLoadItem;
            var offsetTop = $lazyLoadReferenceItem.offset().top;
            var height = $lazyLoadReferenceItem.outerHeight();
            var offsetBottom = offsetTop + height;

            if (offsetTop <= viewportBottom && offsetBottom >= scrollTop) {
                global.handleLazyLoad($lazyLoadItem);
            }
        }
    });
    $(document).on("force-load", ".js-lazyLoad", function (event) {
        global.handleLazyLoad($(this));
    });
    $(window).on("scroll load", function () {
        var $window = $(window);
        var scrollTop = $window.scrollTop();
        var viewportHeight = $window.outerHeight();
        $(":not(.js-map--hotels) .js-lazyLoad:not(.js-paralaxImage)").trigger("need-to-load", [scrollTop, viewportHeight]);
    });
    $(document).on("generated", ".js-map--hotels", function () {
        var $mapHotels = $(".js-map--hotels");
        var $content = $mapHotels.find(".fshr-searchResults-items");
        var scrollTop = $mapHotels.offset().top - $content.offset().top;
        var viewportHeight = $mapHotels.outerHeight();
        $mapHotels.find(".js-lazyLoad:not(.js-paralaxImage):visible").trigger("need-to-load", [scrollTop, viewportHeight]);

        $mapHotels.on("scroll left-panel-changed", function () {
            var $scrolledElement = $(this);
            var $content = $scrolledElement.find(".fshr-searchResults-items");
            var scrollTop = $scrolledElement.offset().top - $content.offset().top;
            var viewportHeight = $scrolledElement.outerHeight();
            $scrolledElement.find(".js-lazyLoad:not(.js-paralaxImage):visible").trigger("need-to-load", [scrollTop, viewportHeight + 300]);
        });
    });
})(jQuery, globalWrapper.fshr);


/* TO DISABLE */
/**
 * generate calendar
 * */
(function ($, global) {
    function generateCalendar (calendarTimeMonth, calendarTimeYear, startDateTimestamp, endDateTimestamp) {
        var calendarTexts = global.localization.calendar;
        var monthNames = calendarTexts.monthNames;
        var dayNames = calendarTexts.dayNamesShort;
        var calendarHeaderMonth = '<th colspan="7" class="fshr-calendar-title--month">' + monthNames[calendarTimeMonth] + '</th>';
        var calendarHeaderDays = '<th>' + dayNames[1] + '</th><th>' + dayNames[2] + '</th><th>' + dayNames[3] + '</th><th>' + dayNames[4] + '</th><th>' + dayNames[5] + '</th><th>' + dayNames[6] + '</th><th>' + dayNames[0] + '</th>';
        var calendar = "<table class='fshr-calendar'><thead><tr>" + calendarHeaderMonth + "</tr><tr>" + calendarHeaderDays + "</tr></thead><tbody><tr>";

        var day = 1;
        var daysInWeek = 7;

        var calendarStartDate = new Date(calendarTimeYear, calendarTimeMonth, day, 0, 0, 0);
        var dayInMonth = calendarStartDate.getDay();
        var gapsBeforeStartDate = daysInWeek - 1;

        if (dayInMonth > 0) {
            gapsBeforeStartDate = dayInMonth - 1;
        }

        while (gapsBeforeStartDate) {
            gapsBeforeStartDate = gapsBeforeStartDate - 1;
            calendar = calendar + '<td></td>';
        }

        var newLineStart = false;
        var lastDayInMonth = 1;
        var timeOffset = 0;
        var timeOffsetMilisec = timeOffset * 60 * 1000;

        do {
            if (newLineStart) {
                calendar = calendar + "<tr>";
            }
            lastDayInMonth = calendarStartDate.getDay();
            var currentDayTimestamp = calendarStartDate.getTime();
            var classes = ["fshr-calendar-item"];
            if ((startDateTimestamp + timeOffsetMilisec) <= currentDayTimestamp && currentDayTimestamp <= (endDateTimestamp + timeOffsetMilisec)) {
                classes.push("fshr-calendar-item--selected");
            }
            if (lastDayInMonth == 0 || lastDayInMonth == 6) {
                classes.push("fshr-calendar-item--holiday");
            }

            var cssClass = classes.length ? " class='" + classes.join(" ") + "'" : "";
            calendar = calendar + '<td' + cssClass + '><span class="fshr-calendar-item-day">' + day + '</span></td>';

            day = day + 1;
            calendarStartDate.setDate(day);
            if (calendarStartDate.getDay() == 1 && (calendarStartDate.getMonth() == calendarTimeMonth)) {
                calendar = calendar + "</tr>";
                newLineStart = true;
            } else {
                newLineStart = false;
            }
        } while (calendarStartDate.getMonth() == calendarTimeMonth);

        if (!newLineStart) {
            var gapsAfterStartDate = 0;
            calendarStartDate = new Date(calendarTimeYear, calendarTimeMonth, 1);
            calendarStartDate.setDate(day - 1);
            if (lastDayInMonth > 0) {
                gapsAfterStartDate = daysInWeek - lastDayInMonth;
            }
            while (gapsAfterStartDate) {
                gapsAfterStartDate = gapsAfterStartDate - 1;
                calendar = calendar + '<td></td>';
            }
            calendar = calendar + '</tr>';
        }

        calendar = calendar + "</tbody></table>";
        return calendar;
    }
    function generateCalendars (startDate, endDate) {
        var startDateTimestamp = startDate.getTime();
        var endDateTimestamp = endDate.getTime();

        var startTimeMonth = startDate.getMonth();
        var startTimeYear = startDate.getFullYear();

        var endTimeMonth = endDate.getMonth();
        var endTimeYear = endDate.getFullYear();

        var monthsCount = Math.abs((startTimeMonth - endTimeMonth)) + 1;
        if (endTimeYear != startTimeYear) {
            monthsCount = Math.abs((endTimeYear - startTimeYear)) * 12 - (startTimeMonth + 1) + (endTimeMonth + 1) + 1;
        }

        var calendar = "";
        for (var month = 1; month <= monthsCount; month++) {
            startTimeYear = startDate.getFullYear();
            startTimeMonth = startDate.getMonth();
            calendar = calendar + "<div class='fshr-calendar-wrapper'>" + generateCalendar(startTimeMonth, startTimeYear, startDateTimestamp, endDateTimestamp) + "</div>";
            startDate.setMonth(startTimeMonth + 1);
        }

        return calendar;
    }

    $(document).on("ready ajax-loaded", function () {
        $(".js-generateCalendar:not(.js-calendarGenerated)").each(function () {
            var $this = $(this);
            var todayDate = new Date();
            var todayYear = todayDate.getFullYear();
            var todayMonth = todayDate.getMonth() + 1;
            var todayDay = todayDate.getDate();
            var todayDateFormated = todayYear + "-" + todayMonth + "-" + todayDay;

            var startDate = ($this.attr("data-calendar-startdate") || todayDateFormated).split("-");
            var endDate = ($this.attr("data-calendar-enddate") || todayDateFormated).split("-");

            var startDateObject = new Date(startDate[0], startDate[1]-1, startDate[2], 0, 0, 0);
            var endDateObject = new Date(endDate[0], endDate[1]-1, endDate[2], 0, 0, 0);

            var calendars = generateCalendars(startDateObject, endDateObject);
            $this.html(calendars);
            $this.addClass("js-calendarGenerated");
        });
    });
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 * calendar bar
 * */
(function ($, global) {
    var maxNights = 31;
    var minNights = 1;
    var elementCursorPosition = {
        x: 0,
        y: 0,
        fromElementEdge: 0
    };
    var moveCursorPosition = {
        x: 0
    };
    var $mouseDownDay = $();

    var flightsAvailable = {};
    var IS_UNDEFINED = 0;
    var IS_DRAGER = 1;
    var IS_RANGE = 2;
    var dayType = IS_UNDEFINED;
    var dayWidth = 23;

    var freeDaysBeforeStartDate = 4;
    var monthAdditionalWidth = 0;

    var updateFilterTimeoutId = 0;
    var timeoutIdFilterChangeId = 0;
    var draggingTimeoutId = 0;

    var LEFT = 1;
    var RIGHT = 2;

    function getDateString (date) {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();

        var monthString = ("0" + month).slice(-2);
        var dayString = ("0" + day).slice(-2);

        return {
            int: parseInt((year + monthString + dayString), 10),
            string: year + "-" + monthString + "-" + dayString
        }
    }
    global.getDateString = getDateString;

    function createDateIntFromString (string) {
        var int = 0;

        var stringArray = string.split("-");
        int = stringArray[0] + stringArray[1] + stringArray[2];

        return parseInt(int, 10);
    }

    function createDateFromString (string) {
        var array = string.split("-");
        var normalizedString = array[0] + "-" + array[1] + "-" + array[2];

        return new Date(normalizedString);
    }

    function getCalendarDay (generateFromDate) {
        var minDate = global.dates.minimum;
        var maxDate = global.dates.maximum;

        var $day = $('<div class="fshr-calendarBar-day" data-calendarbar-day-date="' + getDateString(generateFromDate).string + '"><div class="fshr-calendarBar-day-content"><span class="fshr-calendarBar-day-number">' + generateFromDate.getDate() + '</span><span class="fshr-calendarBar-day-name">' + global.localization.calendar.dayNamesShort[generateFromDate.getDay()] + '</span><span class="fshr-calendarBar-day-flight"></span></div></div>');
        var dayInWeek = generateFromDate.getDay();
        if (dayInWeek == 0 || dayInWeek == 6) {
            $day.addClass("fshr-calendarBar-day--holiday");
        }
        if (getDateString(generateFromDate).int <= getDateString(minDate).int) {
            $day.addClass("fshr-calendarBar-day--disabled");
        }
        if (getDateString(generateFromDate).int >= getDateString(maxDate).int) {
            $day.addClass("fshr-calendarBar-day--disabled");
        }

        return $day;
    }

    function loadFlightsByDates (newDates, $calendar) {
        var ajaxFilter = global.getFormsData($(".js-filter--detail").closest(".js-filter-form"));

        $.extend(ajaxFilter, newDates);

        $.ajax({
            method: "get",
            data: ajaxFilter,
            contentType: "application/json; charset=utf-8",
            url: location.protocol + '//' + location.host + location.pathname + "/terminyAjax",
            cache: true,
            success: function (data) {
                //data = ["07.07.2018", "14.07.2018", "21.07.2018", "28.07.2018", "31.07.2018", "04.08.2018", "11.08.2018", "18.08.2018", "25.08.2018", "01.09.2018", "08.09.2018", "15.09.2018", "22.09.2018"];
                var dates = data;
                if (dates.length) {
                    $.each(dates, function (index, date) {
                        var parsedDate = date.split("-");
                        var monthYear = parsedDate[1] + "-" + parsedDate[0];
                        if (flightsAvailable[monthYear]) {
                            var actualDates = flightsAvailable[monthYear];
                            if (actualDates.indexOf(date) == -1) {
                                flightsAvailable[monthYear].push(date);
                            }
                        } else {
                            flightsAvailable[monthYear] = [date];
                        }
                    });
                    $calendar.trigger("flights-updated");
                }
            }
        });
    }

    function storeFlightsDates (generateFromDate, $calendar) {

        var sendRequestForMonthsCount = 3;

        var month = generateFromDate.getMonth();
        var year = generateFromDate.getFullYear();


        var startMonthDate = new Date(year, month, 1);
        var lastMonthDate = new Date(year, month + sendRequestForMonthsCount, 0);

        var flightsAlreadyStored = true;
        for (var index = 1; index <= sendRequestForMonthsCount; index ++) {
            var monthYear = ("0" + (month + index)).substr(-2) + "." + year;
            if (!(monthYear in flightsAvailable)) {
                flightsAlreadyStored = false;
                flightsAvailable[monthYear] = [];
            }
        }

        if (!flightsAlreadyStored) {

            var firstDayString = getDateString(startMonthDate).string;
            var lastDayString = getDateString(lastMonthDate).string;

            var newDates = {TerminOd: firstDayString, TerminDo: lastDayString};

            loadFlightsByDates(newDates, $calendar);

        } else {
            $calendar.trigger("flights-updated");
        }

    }

    function getMonth (generateFromDate) {
        var month = generateFromDate.getMonth();
        var year = generateFromDate.getFullYear();
        var $month = $('<div class="fshr-calendarBar-month" data-month-date="' + year + '-' + ("0" + (month + 1)).slice(-2) + '-01"></div>');
        var $monthTitle = $('<div class="fshr-calendarBar-month-title"><div class="fshr-calendarBar-month-bumpers"><span class="fshr-calendarBar-month-text">' + global.localization.calendar.monthNames[month] + ' ' + year + '</span></div></div>');
        var $monthDays = $('<div class="fshr-calendarBar-month-days"></div>');

        $month.append($monthTitle).append($monthDays);

        return $month;
    }
    function handleMonthTitle ($calendar) {
        var $months = $calendar.find(".fshr-calendarBar-month");
        var cssClassHideText = "fshr-calendarBar-month-text--hide";
        $months.each(function () {
            var $month = $(this);
            var $days = $month.find(".fshr-calendarBar-day");
            var daysCount = $days.length;
            var $monthText = $month.find(".fshr-calendarBar-month-text");
            if (daysCount < 4) {
                $monthText.addClass(cssClassHideText);
            } else {
                $monthText.removeClass(cssClassHideText);
            }
        });
    }

    function moveCalendar ($calendar, direction) {

        var $days = $calendar.find(".fshr-calendarBar-day");
        var $day = $();
        var $oppositeDay = $();
        var addOrSubtractDay = 0;
        var prepend = false;

        switch (direction) {
            case LEFT:
                $day = $days.last();
                $oppositeDay = $days.first();
                addOrSubtractDay = 1;
                prepend = false;
            break;
            case RIGHT:
                $day = $days.first();
                $oppositeDay = $days.last();
                addOrSubtractDay = -1;
                prepend = true;
            break;
        }

        var generateFromDate = createDateFromString($day.attr("data-calendarbar-day-date"));

        var dayMonth = generateFromDate.getMonth();

        generateFromDate.setDate(generateFromDate.getDate() + addOrSubtractDay);

        var $dayToAdd = getCalendarDay(generateFromDate);

        if (dayMonth == generateFromDate.getMonth()) {
            // add day only to end/start of month
            var $dayMonth = $day.closest(".fshr-calendarBar-month-days");
            if (prepend) {
                $dayMonth.prepend($dayToAdd);
            } else {
                $dayMonth.append($dayToAdd);
            }
        } else {
            // generate month
            var $month = getMonth(generateFromDate);
            storeFlightsDates(generateFromDate, $calendar);

            var $daysWrapper = $month.find(".fshr-calendarBar-month-days");
            if (prepend) {
                $daysWrapper.prepend($dayToAdd);
                $calendar.prepend($month);
            } else {
                $daysWrapper.append($dayToAdd);
                $calendar.append($month);
            }
        }

        var $oppositeDayMonth = $oppositeDay.closest(".fshr-calendarBar-month");
        var daysInOpositeMonth = $oppositeDayMonth.find(".fshr-calendarBar-day").length;
        if (daysInOpositeMonth > 1) {
            $oppositeDay.remove();
        } else {
            $oppositeDayMonth.remove();
        }
    }

    function generateBar ($calendar, parentWidth) {
        if (typeof parentWidth === "undefined") {
            parentWidth = 948 + monthAdditionalWidth;
        }

        flightsAvailable = {};

        var isHandleAble = !$calendar.is("[data-datebar-nohandleable]");
        if (isHandleAble) {
            $calendar.addClass("js-calendarBar--handleAble");
        }
        $calendar.html("");
        var startDateSelected = $calendar.attr("data-datebar-start-selected");
        var startDateInt = 0;
        if (startDateSelected) {
            startDateInt = createDateIntFromString(startDateSelected);
        }
        var endDateSelected = $calendar.attr("data-datebar-end-selected");
        var endDateInt = 0;
        if (endDateSelected) {
            endDateInt = createDateIntFromString(endDateSelected);
        }

        var dayBeforeStartDefault = createDateFromString(startDateSelected);
        var dayBeforeStart = getDateString(new Date(dayBeforeStartDefault.setDate(dayBeforeStartDefault.getDate() - 1)));
        var dayAfterEndDefault = createDateFromString(endDateSelected);
        var dayAfterEnd = getDateString(new Date(dayAfterEndDefault.setDate(dayAfterEndDefault.getDate() + 1)));

        var daysSelectedCount = global.getDaysCountAndMiliseconds(dayBeforeStartDefault, dayAfterEndDefault).daysCount;
        var maximumDaysCount = $calendar.attr("data-datebar-maxrange");
        if (maximumDaysCount) {
            if ((daysSelectedCount - 1) > maximumDaysCount) {
                $calendar.hide();
            } else {
                $calendar.show();
            }
        }
        var freeDaysBeforeFirstSelected = freeDaysBeforeStartDate;
        if (!isHandleAble) {
            var daysCount = Math.ceil(parentWidth / dayWidth);
            freeDaysBeforeFirstSelected = Math.floor((daysCount - daysSelectedCount) / 2);
        }
        var generateFromDate = new Date(startDateSelected ? (createDateFromString(startDateSelected).setDate(createDateFromString(startDateSelected).getDate() - freeDaysBeforeFirstSelected)) : (new Date().setDate(new Date().getDate() - freeDaysBeforeFirstSelected)));
        var previousDate = generateFromDate;
        var $month = $();
        var $monthDays = $();

        var calendarWidth = 0;
        var firstDay = true;

        storeFlightsDates(generateFromDate, $calendar);

        while (calendarWidth < parentWidth) {

            if (previousDate.getMonth() != generateFromDate.getMonth() || getDateString(previousDate).int == getDateString(generateFromDate).int) {
                $month = getMonth(generateFromDate);
                $monthDays = $month.find(".fshr-calendarBar-month-days");
                $calendar.append($month);
                calendarWidth = calendarWidth + monthAdditionalWidth;
            }

            var generatedTimeInt = getDateString(generateFromDate).int;
            var $day = getCalendarDay(generateFromDate);
            if ((startDateInt <= generatedTimeInt) && (endDateInt >= generatedTimeInt)) {
                $day.addClass("fshr-calendarBar-day--selected");
            }
            if (isHandleAble && ((dayAfterEnd.int == generatedTimeInt) || (dayBeforeStart.int == generatedTimeInt))) {
                $day.addClass("fshr-calendarBar-day--dragger js-calendarDragger");
            }

            if (firstDay) {
                $day.addClass("js-calendar-firstDay");
            }


            $monthDays.append($day);
            calendarWidth = calendarWidth + dayWidth;

            previousDate = new Date(generateFromDate);
            generateFromDate.setDate(generateFromDate.getDate() + 1);
            firstDay = false;
        }
        $day.addClass("js-calendar-lastDay");
        handleMonthTitle($calendar);
        $calendar.attr("data-datebar-start-change", startDateSelected);
        $calendar.attr("data-datebar-end-change", endDateSelected);
        var $parent = $calendar.parent();
        $parent.find(".fshr-button").removeAttr("style");

        $calendar.trigger("flights-updated");
    }

    function updateMainFilter ($dragger) {
        var $dateBar = $dragger.closest(".fshr-calendarBar-wrapper").find(".js-calendarBar");

        var dateBarStartDate = $dateBar.attr("data-datebar-start-change");
        var dateBarEndDate = $dateBar.attr("data-datebar-end-change");

        $dateBar.attr("data-datebar-start-selected", dateBarStartDate);
        $dateBar.attr("data-datebar-end-selected", dateBarEndDate);

        var $departureDate = $("#filter-departure-date-detail");
        var $returnDate = $("#filter-return-date-detail");

        $departureDate.val(dateBarStartDate).trigger("change");
        $returnDate.val(dateBarEndDate).trigger("change");

        $returnDate.parent().find(".js-calendars").trigger("set-calendar-byurl");
        //global.daysCountRestrictions($returnDate);

    }

    function getDayElementByPosition (position) {
        return $(document.elementFromPoint(position.x, position.y)).closest(".fshr-calendarBar-day");
    }
    function getFirstAndLastDisabledDayIndex ($days) {
        var $previousDay = $();
        var firstDisabledIndex = -1;
        var lastDisabledIndex = -1;
        $days.each(function (index) {
            var $day = $(this);
            if ($day.is(".fshr-calendarBar-day--disabled") && $previousDay.is(".fshr-calendarBar-day:not(.fshr-calendarBar-day--disabled)")) {
                lastDisabledIndex = index;
                return false;
            }
            if ($day.is(".fshr-calendarBar-day:not(.fshr-calendarBar-day--disabled)") && $previousDay.is(".fshr-calendarBar-day--disabled")) {
                firstDisabledIndex = index - 1;
                return false;
            }
            $previousDay = $day;
        });
        return {
            first: firstDisabledIndex,
            last: lastDisabledIndex
        }
    }

    function handleDragging (event) {
        if (dayType != IS_UNDEFINED) {
            clearTimeout(draggingTimeoutId);
            if (typeof event !== "undefined") {
                moveCursorPosition = {
                    x: event.clientX
                };
            }

            var moveCursorBy = moveCursorPosition.x - elementCursorPosition.x;

            var hitDisabled = false;

            if (moveCursorBy != 0) {
                var elementOffsetX = $mouseDownDay.offset().left;
                var moveByDays = Math.ceil((moveCursorBy - elementOffsetX - dayWidth + elementCursorPosition.x) / dayWidth);

                if (moveByDays > 2) {
                    moveByDays = 2;
                }
                if (moveByDays < -2) {
                    moveByDays = -2;
                }

                if (moveByDays != 0) {
                    var $calendar = $mouseDownDay.closest(".js-calendarBar--handleAble");
                    var $daysInCalendar = $calendar.find(".fshr-calendarBar-day");
                    var mouseDownDayIndex = $daysInCalendar.index($mouseDownDay);
                    var maxSelectedRange = $calendar.attr("data-datebar-maxrange");

                    var moveToDayIndex = mouseDownDayIndex + moveByDays;
                    var $daysSelected = $daysInCalendar.filter(".fshr-calendarBar-day--selected");
                    var daysSelectedLength = $daysSelected.length;

                    var disabledDayIndex = getFirstAndLastDisabledDayIndex($daysInCalendar);
                    var firstDisabledIndex = disabledDayIndex.first;
                    var lastDisabledIndex = disabledDayIndex.last;
                    var calendarMoveDirection = 0;
                    var newFirstSelectedIndex = 0;
                    var newLastSelectedIndex = 0;


                    switch (dayType) {
                        case IS_DRAGER:
                            var $draggers = $daysInCalendar.filter(".js-calendarDragger");
                            var $firstDragger = $draggers.eq(0);
                            var $lastDragger = $draggers.eq($draggers.length - 1);
                            var movableIsFirstDragger = $firstDragger.is(".js-calendarDragger--movable");

                            var opositeDraggerIndex = movableIsFirstDragger ? $daysInCalendar.index($lastDragger) : $daysInCalendar.index($firstDragger);


                            var selectedNightsBetweenDraggers = opositeDraggerIndex - moveToDayIndex;
                            if (maxSelectedRange) {
                                maxSelectedRange = parseInt(maxSelectedRange, 10) + 1;
                                if (Math.abs(selectedNightsBetweenDraggers) > maxSelectedRange) {
                                    if (selectedNightsBetweenDraggers < 0) {
                                        selectedNightsBetweenDraggers = -maxSelectedRange;
                                    } else {
                                        selectedNightsBetweenDraggers = maxSelectedRange;
                                    }
                                }
                            }
                            var selectedNightsCount = Math.abs(selectedNightsBetweenDraggers) - 2;

                            movableIsFirstDragger = !(selectedNightsBetweenDraggers < 0);

                            var moveToDisabledIndex = moveToDayIndex + (movableIsFirstDragger ? 1 : -1);
                            if (moveToDisabledIndex < 0) {
                                moveToDisabledIndex = 0;
                            }
                            if (moveToDisabledIndex > $daysInCalendar.length - 1) {
                                moveToDisabledIndex = $daysInCalendar.length - 1;
                            }
                            if (selectedNightsCount >= minNights && !$daysInCalendar.eq(moveToDisabledIndex).is(".fshr-calendarBar-day--disabled")) {

                                if (movableIsFirstDragger) {
                                    daysSelectedLength = daysSelectedLength - moveByDays;
                                    newFirstSelectedIndex = moveToDayIndex + 1;
                                    opositeDraggerIndex = moveToDayIndex + selectedNightsCount + 2;
                                } else {
                                    daysSelectedLength = daysSelectedLength + moveByDays;
                                    newLastSelectedIndex = moveToDayIndex - 1;
                                    opositeDraggerIndex = moveToDayIndex - selectedNightsCount - 2;
                                }

                                // check if left days are disabled
                                if (movableIsFirstDragger && firstDisabledIndex != - 1 && newFirstSelectedIndex <= firstDisabledIndex) {
                                    moveToDayIndex = firstDisabledIndex;
                                    hitDisabled = true;
                                }
                                // check if right days are disabled
                                if (!movableIsFirstDragger && lastDisabledIndex != - 1 && newLastSelectedIndex >= lastDisabledIndex) {
                                    moveToDayIndex = lastDisabledIndex;
                                    hitDisabled = true;
                                }



                                if (daysSelectedLength > maxNights + 1) {
                                    if (movableIsFirstDragger) {
                                        opositeDraggerIndex = moveToDayIndex + maxNights + 2;
                                    } else {
                                        opositeDraggerIndex = moveToDayIndex - maxNights - 2;
                                    }
                                }

                                $daysInCalendar.removeClass("fshr-calendarBar-day--dragger js-calendarDragger--movable js-calendarDragger fshr-calendarBar-day--selected");

                                $daysInCalendar.eq(moveToDayIndex).addClass("fshr-calendarBar-day--dragger js-calendarDragger js-calendarDragger--movable");
                                $daysInCalendar.eq(opositeDraggerIndex).addClass("fshr-calendarBar-day--dragger js-calendarDragger");

                                var isBetweenDraggers = false;

                                $daysInCalendar.each(function (index) {
                                    var $day = $(this);

                                    if (isBetweenDraggers) {
                                        $day.addClass("fshr-calendarBar-day--selected");
                                    }

                                    var isDragger = $day.is(".js-calendarDragger");
                                    if (isDragger && !isBetweenDraggers) {
                                        isBetweenDraggers = true;
                                    } else if (isDragger && isBetweenDraggers) {
                                        isBetweenDraggers = false;
                                    }

                                    if (!isBetweenDraggers) {
                                        $day.removeClass("fshr-calendarBar-day--selected");
                                    }
                                });
                            } else {
                                hitDisabled = true;
                            }
                            if (!hitDisabled && moveToDayIndex < freeDaysBeforeStartDate) {
                                calendarMoveDirection = RIGHT;
                            }
                            if (!hitDisabled && moveToDayIndex >= $daysInCalendar.length - freeDaysBeforeStartDate) {
                                calendarMoveDirection = LEFT;
                            }

                        break;
                        case IS_RANGE:
                            var firstSelectedIndex = $daysInCalendar.index($daysSelected.first());
                            var lastSelectedIndex = $daysInCalendar.index($daysSelected.last());

                            newFirstSelectedIndex = firstSelectedIndex + moveByDays;
                            newLastSelectedIndex = lastSelectedIndex + moveByDays;

                            // check if left days are disabled
                            if (firstDisabledIndex != - 1 && newFirstSelectedIndex <= firstDisabledIndex) {
                                newFirstSelectedIndex = firstDisabledIndex + 1;
                                newLastSelectedIndex = newFirstSelectedIndex + daysSelectedLength - 1;
                                moveToDayIndex = newFirstSelectedIndex;
                                hitDisabled = true;
                            }
                            // check if right days are disabled
                            if (lastDisabledIndex != - 1 && newLastSelectedIndex >= lastDisabledIndex) {
                                newLastSelectedIndex = lastDisabledIndex - 1;
                                newFirstSelectedIndex = newLastSelectedIndex - daysSelectedLength + 1;
                                moveToDayIndex = newLastSelectedIndex;
                                hitDisabled = true;
                            }

                            var firstDraggerIndex = newFirstSelectedIndex - 1;
                            var lastDraggerIndex = newLastSelectedIndex + 1;

                            // check and set minimum not selected days count on left
                            if (firstDraggerIndex < freeDaysBeforeStartDate) {
                                calendarMoveDirection = RIGHT;
                            }
                            // check and set minimum not selected days count on right
                            if (lastDraggerIndex >= $daysInCalendar.length - freeDaysBeforeStartDate) {
                                calendarMoveDirection = LEFT;
                            }

                            $daysInCalendar.removeClass("fshr-calendarBar-day--selected js-calendarDragger fshr-calendarBar-day--dragger js-calendarDragger--movable");
                            $daysInCalendar.each(function (index) {
                                var $day = $(this);

                                // set selected days
                                if (newFirstSelectedIndex <= index && index <= newLastSelectedIndex) {
                                    $day.addClass("fshr-calendarBar-day--selected");
                                }

                                // set draggers
                                if (index == firstDraggerIndex || index == lastDraggerIndex) {
                                    $day.addClass("fshr-calendarBar-day--dragger js-calendarDragger js-calendarDragger--movable");
                                }
                            });

                        break;
                    }

                    // set new $mouseDownDays
                    if (moveToDayIndex < 0) {
                        moveToDayIndex = 0;
                    }
                    if (moveToDayIndex > $daysInCalendar.length - 1) {
                        moveToDayIndex = $daysInCalendar.length - 1;
                    }
                    $mouseDownDay = $daysInCalendar.eq(moveToDayIndex);

                    $daysSelected = $calendar.find(".fshr-calendarBar-day--selected");
                    $calendar.attr("data-datebar-start-change", $daysSelected.eq(0).attr("data-calendarbar-day-date"));
                    $calendar.attr("data-datebar-end-change", $daysSelected.eq($daysSelected.length - 1).attr("data-calendarbar-day-date"));

                    updateMainFilter($calendar);

                    elementCursorPosition.x = elementCursorPosition.x + (moveByDays * dayWidth);

                    if (calendarMoveDirection) {
                        for (var index = 0; index < Math.abs(moveByDays); index++) {
                            moveCalendar($calendar, calendarMoveDirection);
                        }
                    } else {
                        hitDisabled = true;
                    }

                    $calendar.trigger("flights-updated");
                } else {
                    hitDisabled = true;
                }
            }
            if (!hitDisabled) {
                draggingTimeoutId = setTimeout(function () {
                    handleDragging();
                }, 100);
            } else {
                clearTimeout(draggingTimeoutId);
            }
        }

    }
    function makeDaysSelected ($days, startDate, endDate) {

        var isBetweenDates = false;
        $days.each(function (index) {
            var $day = $(this);
            var dayDate = $day.attr("data-calendarbar-day-date");

            if (dayDate == startDate) {
                $days.eq(index-1).addClass("fshr-calendarBar-day--terminBeforeFirst");
                isBetweenDates = true;
            }
            if (isBetweenDates) {
                $day.addClass("fshr-calendarBar-day--termin");
            }
            if (dayDate == endDate) {
                $day.addClass("fshr-calendarBar-day--terminLast");
                isBetweenDates = false;
            }
        });
    }

    function generateBarIfTabIsActive () {
        if ($("#termins.fshr-tabContent--active").length || $(".fshr-hotelDetailSection--termins").length > 0) {
            $(".js-calendarBar:not([data-datebar-nohandleable])").each(function () {
                generateBar($(this));
            });
        }
    }

    $(document).on("mousedown", ".js-calendarBar--handleAble", function (event) {
        elementCursorPosition.x = event.clientX;
        elementCursorPosition.y = event.clientY;

        $mouseDownDay = getDayElementByPosition(elementCursorPosition);
        if ($mouseDownDay.is(".js-calendarDragger")) {
            $mouseDownDay.addClass("js-calendarDragger--movable");
            dayType = IS_DRAGER;
        } else if ($mouseDownDay.is(".fshr-calendarBar-day--selected")) {
            dayType = IS_RANGE;
        } else {
            dayType = IS_UNDEFINED;
        }


        $(document).on("mousemove", handleDragging);
    });
    $(document).on("mouseup", function () {
        dayType = IS_UNDEFINED;
        $(document).off("mousemove", handleDragging);
        var $movableDragger = $(".js-calendarDragger--movable");
        if ($movableDragger.length) {
            $movableDragger.removeClass("js-calendarDragger--movable");
            updateFilterTimeoutId = setTimeout(function () {
                $(".js-filter--detail.fshr-filter--termins").trigger("filter-changed-remotely");
            }, 200);
        }
        $movableDragger.removeClass("js-calendarDragger--movable");
        clearTimeout(draggingTimeoutId);
    });

    $(document).on("fshr-regenerate", ".js-calendarBar--handleAble", function () {
        generateBar($(this));
    });

    $(document).on("change date-change", ".js-filter--detail .js-search-termins .js-calendar-value", function () {

        clearTimeout(timeoutIdFilterChangeId);
        var $calendarValue = $(this);
        timeoutIdFilterChangeId = setTimeout(function () {
            clearTimeout(updateFilterTimeoutId);
            var $calendarBar = $(".js-calendarBar:not([data-datebar-nohandleable])");
            if (!$calendarBar.find(".js-calendarDragger--movable").length) {
                var $parent = $calendarValue.parent();
                var startDate = $parent.find(".js-selector-departureDate").val();
                var endDate = $parent.find(".js-selector-returnDate").val();

                $calendarBar.attr("data-datebar-start-selected", startDate).attr("data-datebar-end-selected", endDate).trigger("fshr-regenerate");
            }
        });
    });

    $(document).on("regenerate-flights", ".js-calendarBar--handleAble", function () {
        flightsAvailable = {};
        var $calendar = $(this);
        var $month = $calendar.find(".fshr-calendarBar-month:first-child");
        var dateString = $month.attr("data-month-date");
        var date = new Date(dateString);
        storeFlightsDates(date, $calendar);
        $calendar.trigger("flights-updated");

    });
    $(document).on("flights-updated", ".js-calendarBar--handleAble", function () {
        var $calendar = $(this);
        var $days = $calendar.find(".fshr-calendarBar-day");
        $days.each(function () {
            var $day = $(this);
            var dateString = $day.attr("data-calendarbar-day-date");
            var dateParts = dateString.split("-");
            var monthYear = dateParts[1] + "-" + dateParts[0];

            if (monthYear in flightsAvailable) {
                var datesArray = flightsAvailable[monthYear];
                if ($.inArray(dateString, datesArray) > -1) {
                    $day.addClass("fshr-calendarBar-day--flight");
                } else {
                    $day.removeClass("fshr-calendarBar-day--flight");
                }
            } else {
                $day.removeClass("fshr-calendarBar-day--flight");
            }

        });
    });

    $(document).on("mouseenter", ".fshr-termins-table-item", function () {
        var $termin = $(this);
        var startDate = $termin.attr("data-departure") || "";
        startDate = startDate.split("T")[0];
        var endDate = $termin.attr("data-return") || "";
        endDate = endDate.split("T")[0];

        var $days = $(".js-calendarBar--handleAble .fshr-calendarBar-day");
        makeDaysSelected($days, startDate, endDate);
    });
    $(document).on("mouseleave", ".fshr-termins-table-item", function () {
        $(".js-calendarBar--handleAble .fshr-calendarBar-day").removeClass("fshr-calendarBar-day--termin fshr-calendarBar-day--terminBeforeFirst fshr-calendarBar-day--terminLast");
    });

    generateBarIfTabIsActive();
    $(window).on("tab-change", function () {
        generateBarIfTabIsActive();
    });

    $(document).on("click", ".js-detailFilter .js-toggleSlide:not(.js-calendarBar-generated)", function () {
        var $trigger = $(this);
        var $detailFilter = $trigger.closest(".js-detailFilter");
        var $toPrependCalendar = $detailFilter.find(".fshr-termins-table-item-content");

        var startDate = $detailFilter.attr("data-departure").split("T")[0];
        var endDate = $detailFilter.attr("data-return").split("T")[0];

        var $calendarWrapper = $('<div class="fshr-calendarBar-wrapper"></div>');
        var $calendarPlaceholder = $('<div class="fshr-calendarBar js-calendarBar" data-datebar-nohandleable data-datebar-start-selected="' + startDate + '" data-datebar-end-selected="' + endDate + '"></div>');
        $calendarWrapper.append($calendarPlaceholder);
        $toPrependCalendar.prepend($calendarWrapper);
        generateBar($calendarPlaceholder, 946);
        var $days = $calendarPlaceholder.find(".fshr-calendarBar-day");
        makeDaysSelected($days, startDate, endDate);
        var $firstSelectedDay = $calendarPlaceholder.find(".fshr-calendarBar-day--selected").first();
        $firstSelectedDay.addClass("fshr-calendarBar-day--flight");
        $trigger.addClass("js-calendarBar-generated");
    });

})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 * open/close menu base on data attributes
 * */
(function ($, global) {
    function openMenu ($menuTrigger, $menuContent) {
        $menuContent.show();
        $menuContent.addClass("fshr-searchMenu-content--active");
        $menuTrigger.closest(".fshr-searchMenu-seasons").addClass("fshr-searchMenu-seasons--open");
    }
    function closeMenu ($menuTrigger, $menuContent) {
        $menuContent.hide();
        $menuContent.removeClass("fshr-searchMenu-content--active");
        $menuTrigger.closest(".fshr-searchMenu-seasons").removeClass("fshr-searchMenu-seasons--open");
    }
    $(document).ready(function () {
        var $menuTrigger = $(".js-menuSearch.fshr-searchMenu--selected");
        var $menuContent = $(".js-menuSearch-content.fshr-searchMenu--selected");
        var mobileTabletOpenIsDefined = "mobileTabletMenuIsOpen" in window;
        if (mobileTabletOpenIsDefined) {
            var mobileTabletIsOpen = window["mobileTabletMenuIsOpen"];

            if (global.widths.window <= global.widths.tablet) {
                if (mobileTabletIsOpen) {
                    openMenu($menuTrigger, $menuContent);
                } else {
                    closeMenu($menuTrigger, $menuContent);
                }
                $("body").trigger("menu-height-changed");
                $("body").trigger("menu-height-changed-finish");
            }
        }
    });
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 *  mobile tap event call
 *  */
(function ($, global) {
    var startX = 0;
    var startY = 0;
    var tapOnGo = false;
    var toleration = 5;
    var $target = $();

    $(document).on("touchstart", function (event) {
        var touch = event.originalEvent.touches[0];
        $target = $(touch.target);
        if ($target.closest(".js-tooltip")) {
            startX = touch.pageX;
            startY = touch.pageY;
            tapOnGo = true;
        } else {
            startX = 0;
            startY = 0;
            tapOnGo = false;
        }
    });
    $(document).on("touchend", function (event) {
        var touch = event.originalEvent.changedTouches[0];
        if (tapOnGo) {
            var endX = touch.pageX;
            var endY = touch.pageY;

            var xDifference = Math.abs(startX - endX);
            var yDifference = Math.abs(startY - endY);

            if (xDifference <= toleration && yDifference <= toleration) {
                $target.trigger("tap");
            }

        }
        startX = 0;
        startY = 0;
        tapOnGo = false;
        $target = $();
    });
    $(document).on("touchcancel", function () {
        startX = 0;
        startY = 0;
        tapOnGo = false;
        $target = $();
    });

})(jQuery, globalWrapper.fshr);



/**
 *  mobile main menu
 *  */
(function ($, global) {

    function closeMobileMenu (event) {
        if (event) {
            event.preventDefault();
        }
        var $menuBumper = $(".fshr-mobileMenu-bumper");
        var $stickyHotelInfo = $(".fshr-detail-content-shrinked .fshr-detail-summary:not(.fshr-detail-summary--noHeader)");


        $menuBumper.animate({
            right: 0
        }, {
            complete: function () {
                $(".fshr-mobileMenu-bumper").removeAttr("style");
            }
        });

        var $mobileMainMenu = $(".fshr-mobileMenu");
        $mobileMainMenu.animate({
            right: -($mobileMainMenu.outerWidth())
        }, {
            complete: function () {
                $("body").removeClass("fshr-mobileMenu-opened");
                $(this).hide();
            }
        });

        $stickyHotelInfo.animate({
            left: 0,
            right: 0
        }, {
            complete: function () {
                $(this).css({
                    width: ""
                })
            }
        });
    }
    // sub menu
    $(document).on("click", ".js-mobileMenu-submenu", function (event) {
        event.preventDefault();
        var $trigger = $(this);
        var $listItem = $trigger.closest("li");
        var cssClassActive = "fshr-mobileMenu-submenu--active";
        var $ul = $trigger.next("ul");
        if ($listItem.hasClass(cssClassActive)) {
            $listItem.removeClass(cssClassActive);
            $trigger.next("ul").slideUp();
        } else {
            $listItem.addClass(cssClassActive);
            $trigger.next("ul").slideDown();
        }
    });

    // close
    $(document).on("click", ".js-mobileMenu-close", closeMobileMenu);
    $(document).on("click", ".fshr-mobileMenu-opened .fshr-mobileMenu-bumper", closeMobileMenu);


    // open
    $(document).on("click", ".js-mainMenuTrigger", function (event) {
        event.preventDefault();
        var $mobileMainMenu = $(".fshr-mobileMenu");
        $("body").addClass("fshr-mobileMenu-opened");

        $mobileMainMenu.css({
            display: "block",
            right: -(global.widths.window)
        });
        var mobileMenuOuterWidth = $mobileMainMenu.outerWidth();
        $mobileMainMenu.css({
            right: -mobileMenuOuterWidth
        });

        var $menuBumper = $(".fshr-mobileMenu-bumper");
        var $stickyHotelInfo = $(".fshr-detail-content-shrinked .fshr-detail-summary:not(.fshr-detail-summary--noHeader)");
        $menuBumper.css({
            position: "relative"
        });
        if ($stickyHotelInfo.length) {
            $stickyHotelInfo.css({
                width: $stickyHotelInfo.outerWidth(),
            });
            $stickyHotelInfo.animate({
                left: -mobileMenuOuterWidth,
                right: mobileMenuOuterWidth
            });
        }
        $menuBumper.animate({
            right: mobileMenuOuterWidth
        });
        $mobileMainMenu.animate({
            right: 0
        });
    });

})(jQuery, globalWrapper.fshr);


/**
 * quick search
 * */
(function ($, global) {
    function openQuickSearch ($input) {
        var $form = $input.closest("form");
        $form.addClass("fshr-formCompact--showResults");
    }
    function quickSearch ($input) {
        var value = $input.val();
        if (value && value.length > 2) {
            openQuickSearch($input);
            var $resultsWrapper = $input.parent().find(".fshr-formCompact-results");
            var showLimit = $input.attr("data-pagesize") || 5;
            $resultsWrapper.addClass("fshr-formCompact-results--loading");
            var dataToSend = [];
            dataToSend.push($input.attr("name") + "=" + value);
            dataToSend.push("PageSize=" + showLimit);
            var options = {
                success: function (data) {
                    $resultsWrapper.html(data);
                    $resultsWrapper.removeClass("fshr-formCompact-results--loading");
                },
                error: function (result) {
                    $resultsWrapper.removeClass("fshr-formCompact-results--loading");
                }
            };
            global.ajax.functions.send(global.ajax.url.quickSearch, dataToSend.join("&"), options, "quickSearch");
        }
    }

    var keyPressTimeoutId = 0;
    $(document).on("keyup", ".js-quickSearch", function () {
        var $item = $(this);
        clearTimeout(keyPressTimeoutId);

        keyPressTimeoutId = setTimeout(function () {
            quickSearch($item);
        }, 200);
    });

    $(document).on("click", function (event) {
        var $target = $(event.target);
        if ($target.is(".js-close")) {
            event.preventDefault();
            $(".fshr-formCompact").removeClass("fshr-formCompact--showResults");
        } else if (!$target.closest(".fshr-formCompact").length) {
            $(".fshr-formCompact").removeClass("fshr-formCompact--showResults");
        }
    });
    $(document).on("keyup", function (event) {
        var keyCode = event.keyCode;
        if (keyCode == 27) {
            $(".fshr-formCompact").removeClass("fshr-formCompact--showResults");
        }
    });
})(jQuery, globalWrapper.fshr);


/**
 * flex gallery
 * */
(function ($, global) {
    $(".js-flexGallery:not(.js-initialized):visible").flexImages();
    $(window).on("tab-change", function () {
        $(".js-flexGallery:not(.js-initialized):visible").flexImages();
    })
    $(document).on("flexImagesGenerated", ".js-flexGallery", function () {
        var $lazyLoad = $(this).find(".js-lazyLoad");
        var $window = $(window);
        var scrollTop = $window.scrollTop();
        var viewportHeight = $window.outerHeight();
        $lazyLoad.trigger("need-to-load", [scrollTop, viewportHeight]);
    });
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 * update result and pagination based pagination changes
 * */
(function ($, global) {
    function generatePagination ($pagination, itemsCount, perPage) {
        perPage = parseInt(perPage, 10) || 20;

        var pagesCount = Math.ceil(itemsCount / perPage);

        var $button = $pagination.find(".js-paginationButton");
        var $next = $pagination.find(".js-paginationNext");
        var $prev = $pagination.find(".js-paginationPrevious");
        var $perPage = $pagination.find(".js-pagination-nextPageCount");

        $perPage.text(perPage);

        if (pagesCount > 1) {
            $pagination.removeClass("fshr-hidden");
            var $pageItemTemplate = $pagination.find(".js-paginationPages-item").first();
            $pageItemTemplate.find("a").removeClass("fshr-pagination-anchor--active");
            var pagesHtml = "";

            if ($pageItemTemplate.length) {
                for (var page = 0; page < pagesCount; page++) {
                    var $page = $pageItemTemplate.clone();
                    var $anchor = $page.find(".js-paginationPages-anchor");
                    $anchor.text(page+1);
                    if (page == 0) {
                        $anchor.addClass("fshr-pagination-anchor--active");
                    }
                    pagesHtml = pagesHtml + $page[0].outerHTML;
                }
                $pagination.find(".js-paginationPages")[0].innerHTML = pagesHtml;
                updatePaginationGaps($pagination);
            }


            $prev.hide();
            $button.show();
            $next.show();
        } else {
            $pagination.addClass("fshr-hidden");
            $prev.show();
            $button.show();
            $next.show();
        }
    }
    global.generatePagination = generatePagination;
    function updatePaginationGaps ($pagination) {
        var $pages = $pagination.find(".js-paginationPages-item");
        $pages.show();
        $pagination.find(".js-paginationGaps").remove();
        var firstIndex = 0;
        var lastIndex = $pages.length;
        var toEachSide = 2;
        var $activeItems = $pages.find(".fshr-pagination-anchor--active");
        var $firstItem = $pages.first();
        var $lastItem = $pages.last();
        var firstActiveIndex = $activeItems.first().parent().index();
        var lastActiveIndex = $activeItems.last().parent().index();

        var firstNoGap = (firstActiveIndex - toEachSide) < 2;
        var lastNoGap = (lastActiveIndex + toEachSide) > (lastIndex - 2);

        var gapFrom = 0;
        var gapTo = 0;
        if (!firstNoGap) {
            gapTo = firstActiveIndex - toEachSide;
            if (gapFrom < gapTo) {
                $pages.filter(function (index) {
                    var $toReturn = $();
                    if (index > gapFrom && index < gapTo) {
                        $toReturn = $(this).hide();
                    } else {
                        $toReturn = $(this);
                    }
                    return $toReturn
                });
                $firstItem.after("<li class='fshr-pagination-page js-paginationGaps'>&hellip;</li>");
            }
        }
        if (!lastNoGap) {
            gapFrom = lastActiveIndex + toEachSide;
            gapTo = lastIndex;
            if (gapFrom < gapTo) {
                $pages.filter(function (index) {
                    var $toReturn = $();
                    if (index > gapFrom && index < gapTo) {
                        $toReturn = $(this).hide();
                    } else {
                        $toReturn = $(this);
                    }
                    return $toReturn
                });
                $lastItem.before("<li class='fshr-pagination-page js-paginationGaps'>&hellip;</li>");
            }
        }
    }

    var $ajaxForm = $(".js-ajaxForm");
    $ajaxForm.each(function () {
        var $this = $(this);
        var $ajaxFormResult = $this.find(".js-ajaxForm-result");
        var itemsCount = $ajaxFormResult.attr("data-ajaxform-itemscount") || 0;
        var $paginationPlaceholder = $this.find(".js-paginationPlaceholder");
        generatePagination($paginationPlaceholder, itemsCount, $ajaxFormResult.attr("data-pagination-itemsperpage"));
    });

    global.getPaginationFilterData = function ($pagination, paginationWillBeChanged) {
        var data = [];

        var $paginationActivePages = $pagination.find(".js-paginationPages-anchor.fshr-pagination-anchor--active");
        var pageFrom = 1;
        var pageTo = 1;

        if (!paginationWillBeChanged) {
            pageFrom = $paginationActivePages.first().text();
            pageTo = $paginationActivePages.last().text();
        }
        data.push("stranka=" + (parseInt(pageFrom, 10)-1));
        data.push("strankaDo=" + (parseInt(pageTo, 10)-1));

        return data;
    };
    function updateResult ($element, loadMore) {
        var $ajaxForm = $element.closest(".js-ajaxForm");
        var $pagination = $ajaxForm.find(".js-paginationPlaceholder");
        var $ajaxFormContent = $ajaxForm.find(".js-ajaxForm-content");
        var $ajaxFormOverlay = $ajaxForm.find(".js-ajaxForm-overlay");

        if (!loadMore) {
            $ajaxFormOverlay.addClass("fshr-dataLoading");
        }

        var paginationWillBeChanged = $element.is(".js-changePagination");

        var data = global.getPaginationFilterData($pagination, paginationWillBeChanged);
        $ajaxForm.find("input, select").each(function () {
            var $this = $(this);
            var name = $this.attr("name");
            var value = $this.val();
            data.push(name + "=" + value);
        });


        var formUrl = $ajaxForm.attr("data-form-url-json") || $ajaxForm.attr("data-form-url");
        var formMethod = $ajaxForm.attr("data-form-method") || "get";
        var formAjaxUrl = $ajaxForm.attr("data-form-url-json");

        var options = {
            method: formMethod,
            success: function (data) {

                if(formAjaxUrl){
                    data = JSON.parse(data);
                    $ajaxFormContent.html(data.pageHtml);
                    dataLayer.push(JSON.parse(data.dataLayerData));
                }else {
                    $ajaxFormContent.html(data);
                }

                $ajaxFormContent.find(".js-stars").each(global.generateStars);
                $ajaxFormContent.find(".js-tooltip").each(global.initializeQtip);
                if (paginationWillBeChanged) {
                    var $ajaxFormResult = $ajaxFormContent.find(".js-ajaxForm-result");
                    generatePagination($pagination, $ajaxFormResult.attr("data-ajaxform-itemscount"), $ajaxFormResult.attr("data-pagination-itemsperpage"));
                }
                $ajaxFormOverlay.removeClass("fshr-dataLoading");
                $pagination.removeClass("fshr-ajax--loading");
                $ajaxFormContent.trigger("ajax-loaded");
            },
            error: function (result) {
                $ajaxFormOverlay.removeClass("fshr-dataLoading");
                $pagination.removeClass("fshr-ajax--loading");
            }
        };

        global.ajax.functions.send(formUrl, data.join("&"), options, "ajaxform");
    }
    $(document).on("change", ".js-send-bychange", function () {
        if($(this).find(".js-send-bychange").length == 0){
            updateResult($(this), false);
        }
    });
    $(document).on("click custom-click", ".js-paginationPages-anchor", function (event) {
        event.preventDefault();
        var eventType = event.type;
        var $page = $(this);
        var isLast = !$page.parent().next().length;
        var isFirst = !$page.parent().prev().length;
        var $paginationParent = $page.closest(".js-paginationPlaceholder");
        $paginationParent.find(".js-paginationGaps").remove();
        $paginationParent.addClass("fshr-ajax--loading");
        var $button = $paginationParent.find(".js-paginationButton");
        var $next = $paginationParent.find(".js-paginationNext");
        var $prev = $paginationParent.find(".js-paginationPrevious");

        var clickToNextPages = false;
        if (eventType == "custom-click") {
            clickToNextPages = true;
        }

        if (isLast) {
            $next.hide();
            $button.hide();
        } else {
            $button.show();
            $next.show();
        }

        if (isFirst) {
            $prev.hide();
        } else {
            $prev.show();
        }

        var $allPages = $paginationParent.find(".js-paginationPages-item .js-paginationPages-anchor");
        if (eventType == "click") {
            $allPages.removeClass("fshr-pagination-anchor--active");
        }
        $page.addClass("fshr-pagination-anchor--active");


        updatePaginationGaps($paginationParent);
        $paginationParent.trigger("page-change", [$page, clickToNextPages]);
    });
    $(document).on("click", ".js-paginationButton", function (event) {
        event.preventDefault();
        var $trigger = $(this);
        var $placeholder = $trigger.closest(".js-paginationPlaceholder");
        var $lastActive = $placeholder.find(".fshr-pagination-anchor--active").last().closest(".js-paginationPages-item");
        var $nextPage = $lastActive.next().find("a");
        if ($nextPage.length) {
            $nextPage.trigger("custom-click");
        }

    });
    $(document).on("click", ".js-paginationNext, .js-paginationPrevious", function (event) {
        event.preventDefault();
        var $trigger = $(this);
        var $paginationPlaceholder = $trigger.closest(".js-paginationPlaceholder");
        var $activeItems = $paginationPlaceholder.find(".fshr-pagination-anchor--active");
        var $firstActiveItem = $activeItems.first().parent();
        var $lastActiveItem = $activeItems.last().parent();

        if ($trigger.is(".js-paginationNext")) {
            $lastActiveItem.next().find("a").trigger("click");
        } else {
            $firstActiveItem.prev().find("a").trigger("click");
        }
    });
    $(document).on("page-change", "body:not(.fshr-page-search) .js-paginationPlaceholder", function (event, $page, clickToNextPages) {
        updateResult($page, clickToNextPages);
    });


})(jQuery, globalWrapper.fshr);

(function ($, global) {
    $(document).on("change", ".js-filter", function () {
        var $filtration = $(this);
        var $filterFormItems = $filtration.find("select.js-filterFormItem, input.js-filterFormItem");
        var filter = {};
        $filterFormItems.each(function () {
            var $item = $(this);
            var name = $item.attr("name");
            var value = $item.val();
            if (value) {
                if (name in filter) {
                    filter[name].push(value);
                } else {
                    filter[name] = [value];
                }
            }
        });

        var $filteredItems = $filtration.find(".js-filteredItem");
        $filteredItems.each(function () {
            var $filteredItem = $(this);
            var showFilteredItem = true;
            $.each(filter, function (name, values) {
                var dataValues = $filteredItem.attr("data-filter-" + name);
                if (dataValues) {
                    var dataValue = dataValues.split("|");
                    var allDataIncluded = true;
                    $.each(values, function(index, value) {
                        if (dataValue.indexOf(value) == -1) {
                            allDataIncluded = false;
                            return false;
                        }
                    });
                    showFilteredItem = allDataIncluded;
                }
                if (!showFilteredItem) {
                    return false;
                }
            });
            if (showFilteredItem) {
               $filteredItem.show();
            } else {
                $filteredItem.hide();
            }
        });
    });
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 * main search filter
 * */
(function ($, global) {
    var mainFilterData = getMainFilterData();

    var changeDetectionDelay = 200;

    var FILTER_TYPES = {
        ADDITIONAL: 1,
        DESTINATIONS: 2,
        SORTING: 3,
        PAGINATION: 4,
        VIEW_TYPE: 5
    };
    var VIEW_TYPES = {
        HOTEL: 1,
        TERM: 2,
        CENTER: 3
    };

    function generateDownhillGraph ($graphs) {
        $graphs.each(function () {
            var $graph = $(this);
            var graphMaxLength = parseFloat($graph.attr("data-downhill-maxgraphlength") || 300);
            var totalLength = parseFloat($graph.attr("data-downhill-length"));
            var $tracks = $graph.find(".js-downhillgraph-item");
            var ratio = 1;
            if (totalLength > graphMaxLength) {
                ratio = graphMaxLength / totalLength;
                $graph.addClass("fshr-downhillGraph--tooLong");
            }

            $tracks.each(function () {
                var $track = $(this);
                var trackLength = parseFloat($track.attr("data-downhill-length"));
                var snowed = parseFloat($track.attr("data-downhill-snow"));

                var trackLengthPercentage = 100 / graphMaxLength * (trackLength * ratio);
                $track.css({
                    width: trackLengthPercentage + "%"
                });

                /*
                var barHtml = "<div class='fshr-downhillGraph-itemBar' style='width: " + snowed + "%'></div>";
                $track.html(barHtml);
                */
            });
            $graph.addClass(".js-downhillgraph--generated");
        });
    }

    function serializeData (data) {
        var dataArray = [];
        for (var index in data) {
            var value = data[index];
            if (Array.isArray(value)) {
                value = '["' + value.join('","') + '"]';
            }
            dataArray.push(index + "=" + value);
        }
        return dataArray.join("&");
    }

    function getMainFilterData () {
        if (mainFilterData) {
            return $.extend({}, mainFilterData);
        } else {
            var $forms = $(".fshr-page-search .js-menuSearch-content--searchBy");
            return global.getFormsData($forms);
        }
    }

    function getAdvancedFilterData () {
        var $forms = $(".fshr-page-search .js-searchResultFilters");
        return global.getFormsData($forms);
    }

    function getDestinationFilterData () {
        var $forms = $(".fshr-page-search .js-destinationTemplate");
        return global.getFormsData($forms);
    }

    function getOccupancyFilterData () {
        var $forms = $(".fshr-searchMenu--selected .fshr-filter--availability:not(.js-filter--detail)");
        if($forms.length > 0){
            return global.getFormsData($forms);
        }else{
            $forms = $(".js-menuSearch-content .fshr-filter--availability:not(.js-filter--detail)").eq(0);
            return global.getFormsData($forms);
        }
    }

    function getSortFilterString () {
        var $sorterActive = $(".fshr-page-search .fshr-searchResults-sorting .fshr-searchResults-sorting-item--active");
        return $sorterActive.attr("href");
    }

    function getViewTypeFilterString () {
        var $viewTypeActive = $(".fshr-page-search .js-viewTypeSelected");
        return $viewTypeActive.attr("data-href");
    }
    function getViewType () {
        var $viewTypeActive = $(".fshr-page-search .js-viewTypeSelected");
        return $viewTypeActive.attr("data-href");
    }

    function updateTitle ($title) {
        $(".fshr-searchResults .fshr-title.fshr-title--results").html($title.html());
    }
    function updateDestinations (destinationsHtml) {
        $(".fshr-searchResults .js-destinationTemplate").html(destinationsHtml);
    }
    function updateContent ($content) {
        var $pageContent = $(".fshr-searchResults .fshr-searchResults-itemsWrapper");
        var dataFilteredIds = $content.attr("data-filtered-ids");
        $pageContent.html($content.html()).attr("data-filtered-ids", dataFilteredIds);
        var $qtips = $pageContent.find(".js-tooltip");
        var $stars = $pageContent.find(".js-stars");
        var $graphs = $pageContent.find(".js-downhillgraph:not(.js-downhillgraph--generated)");
        $qtips.each(global.initializeQtip);
        $stars.each(global.generateStars);
        generateDownhillGraph($graphs);
        $pageContent.trigger("ajax-loaded");
    }
    function updatePagination (paginationData) {
        global.generatePagination($(".fshr-searchResults .js-paginationPlaceholder"), paginationData.itemscount, paginationData.itemsperpage);
    }
    function updateMap () {
        $(".js-map--searchResults").trigger("mappins-updated");
    }
    function updateFiltersCount (filterNumbers) {
        if (filterNumbers) {
            $.each(filterNumbers, function (filterId, value) {
                $("." + filterId).html(value);
            });
        }
    }

    function handleFilterAndUpdateUrl (dataString, filterType) {
        if (filterType == FILTER_TYPES.ADDITIONAL || filterType == FILTER_TYPES.VIEW_TYPE) {
            $(".fshr-searchResults .fshr-searchResults-content").addClass("fshr-dataLoading");
        }
        if (filterType == FILTER_TYPES.ADDITIONAL || filterType == FILTER_TYPES.DESTINATIONS || filterType == FILTER_TYPES.VIEW_TYPE) {
            $(".js-map--searchResults").addClass("fshr-mapLoading");
        }
        if (filterType == FILTER_TYPES.DESTINATIONS || filterType == FILTER_TYPES.SORTING) {
            $(".fshr-searchResults .fshr-searchResults-header").addClass("fshr-ajax--loading");
        }
        if (filterType == FILTER_TYPES.PAGINATION) {
            $(".fshr-searchResults .js-paginationPlaceholder").addClass("fshr-ajax--loading");
        }
        var url = window.location.href.split("?")[0]; //: "http://v2.nev-dama.cz/zima/vysledek-hledani";
        var options = {
            method: "get",
            dataType: "json",
            success: function (data) {
                updateContent($(data.pageHtml));
                updateFiltersCount(data.filterNumbers);

                if (filterType == FILTER_TYPES.DESTINATIONS || filterType == FILTER_TYPES.ADDITIONAL || filterType == FILTER_TYPES.VIEW_TYPE) {
                    updatePagination(data.pagination);
                    updateMap();
                }

                if (filterType == FILTER_TYPES.ADDITIONAL || filterType == FILTER_TYPES.VIEW_TYPE) {
                    updateTitle($(data.titleHtml));
                    updateDestinations(data.destinationsFilterHtml);
                }

                $(".fshr-searchResults .fshr-searchResults-content").removeClass("fshr-dataLoading");
                $(".fshr-searchResults .fshr-searchResults-header,.fshr-searchResults .js-paginationPlaceholder").removeClass("fshr-ajax--loading");
                if (filterType == FILTER_TYPES.PAGINATION) {
                    var scrollToElementIndex = ((data.pagination.strankaDo - data.pagination.stranka) * data.pagination.itemsperpage);
                    if (scrollToElementIndex < 0) {
                        scrollToElementIndex = 0;
                    }

                    var $scrollToElement = $(".fshr-searchResults .fshr-searchResults-itemsWrapper .fshr-searchResults-item:eq(" + scrollToElementIndex + ")");
                    if ($scrollToElement.length) {
                        var scrollTo = Math.ceil($scrollToElement.offset().top);
                        scrollTo = scrollTo - $(".js-fixedMenu").first().outerHeight();
                        scrollTo = scrollTo - $(".js-fixedMap-parent .js-searchFilters--partialyFixed:not(.fshr-hidden)").outerHeight();
                        scrollTo = scrollTo - $(".js-fixedMap-parent .js-searchFilters--stillFixed:not(.fshr-hidden)").outerHeight();

                        $("body, html").animate({
                            scrollTop: scrollTo
                        }, 200);
                    }

                    // scrolování
                }

                // Black friday sleva
                $("body").trigger("initializeCounters");
            },
            error: function (result) {
                $(".fshr-searchResults .fshr-searchResults-content").removeClass("fshr-dataLoading");
                $(".fshr-searchResults .fshr-searchResults-header,.fshr-searchResults .js-paginationPlaceholder").removeClass("fshr-ajax--loading");
            }
        };
        global.ajax.functions.send(url, dataString + "&X-Requested-With=XMLHttpRequest", options, filterType);
        global.updateUrlParameters(dataString);
    }

    // hlavní filtrace
    $(document).on("click", "form button[type='submit']", function () {
        var $button = $(this);
        var $form = $button.closest("form");
        $form.find("button[type='submit']").removeClass("js-form-include");
        $button.addClass("js-form-include");
    });
    /*$(document).on("submit", "div:not(#daktela-web) form", function (event) {
        var $form = $(this);
        if (($form.attr("method") && $form.attr("method").toLowerCase() == "get") || !$form.attr("method")) {
            event.preventDefault();
            var formData = global.getFormsData($form);
            var url = $form.attr("action") || window.location.href.split("?")[0];
            var dataToUrl = serializeData(formData);
            window.location.href = url + "?" + dataToUrl;
        }
    });*/

    // upřesňující filtry
    var advancedFilterTimeoutId = 0;
    $(document).on("change change-detected", ".fshr-page-search .js-searchResultFilters", function () {
        clearTimeout(advancedFilterTimeoutId);
        advancedFilterTimeoutId = setTimeout(function () {
            var filterData = getMainFilterData();
            var advancedFilterData = getAdvancedFilterData();
            var viewTypeDataString = getViewTypeFilterString();
            $.extend(filterData, advancedFilterData);

            var filterDataString = serializeData(filterData) + "&" + viewTypeDataString;

            handleFilterAndUpdateUrl(filterDataString, FILTER_TYPES.ADDITIONAL);
        }, changeDetectionDelay);
    });

    // filtrace dle destinací
    var destinationFilterTimeoutId = 0;
    $(document).on("change data-reseted", ".fshr-page-search .js-destinationTemplate", function () {
        clearTimeout(destinationFilterTimeoutId);
        destinationFilterTimeoutId = setTimeout(function () {
            var filterData = getMainFilterData();
            var advancedFilterData = getAdvancedFilterData();
            var destinationData = getDestinationFilterData();
            var viewTypeDataString = getViewTypeFilterString();

            $.extend(filterData, advancedFilterData, destinationData);

            var filterDataString = serializeData(filterData) + "&" + viewTypeDataString;
            handleFilterAndUpdateUrl(filterDataString, FILTER_TYPES.DESTINATIONS);

        }, changeDetectionDelay);
    });

    // řazení
    $(document).on("click", ".fshr-page-search .js-sorter", function (event) {
        event.preventDefault();
        var $sorter = $(this);
        if (!$sorter.hasClass("fshr-searchResults-sorting-item--active")) {
            var $parent = $sorter.closest(".fshr-searchResults-sorting");
            $parent.find(".js-sorter").removeClass("fshr-searchResults-sorting-item--active");
            $sorter.addClass("fshr-searchResults-sorting-item--active");
            var sortDataString = $sorter.attr("href");

            var filterData = getMainFilterData();
            var advancedFilterData = getAdvancedFilterData();
            var destinationData = getDestinationFilterData();
            var viewTypeDataString = getViewTypeFilterString();
            $.extend(filterData, advancedFilterData, destinationData);

            var filterDataString = serializeData(filterData) + "&" + sortDataString + "&" + viewTypeDataString;

            handleFilterAndUpdateUrl(filterDataString, FILTER_TYPES.SORTING);
        }
    });

    // stránkování
    $(document).on("page-change", ".fshr-page-search .js-paginationPlaceholder", function () {
        var filterData = getMainFilterData();
        var advancedFilterData = getAdvancedFilterData();
        var destinationData = getDestinationFilterData();
        var sortDataString = getSortFilterString();
        var viewTypeDataString = getViewTypeFilterString();
        var $pagination = $(this);

        var paginationData = global.getPaginationFilterData($pagination, false);

        $.extend(filterData, advancedFilterData, destinationData);

        var filterDataString = serializeData(filterData) + "&" + sortDataString + "&" + viewTypeDataString + "&" + paginationData.join("&");

        handleFilterAndUpdateUrl(filterDataString, FILTER_TYPES.PAGINATION);
    });


    // typ zobrazení
    $(document).on("click", ".fshr-page-search .js-viewType", function (event) {
        event.preventDefault();
        var $viewType = $(this);
        var $listToHide = $viewType.closest(".fshr-searchResultsFilters-itemContent");
        var $selectedViewType = $viewType.closest(".js-viewTypeSelect").find(".js-viewTypeSelected");

        var defaultHref = $viewType.attr("href");
        var defaultDataType = $viewType.attr("data-type");
        var defaultShowFilterSelector = $viewType.attr("data-showfilter-selector");
        var defaultMapVariableName = $viewType.attr("data-mapvariablename");
        var defaultText = $viewType.text();

        if (defaultDataType == 3) {
            $(".js-maximizeMinimizeMap").addClass("fshr-hidden");
        } else {
            $(".js-maximizeMinimizeMap").removeClass("fshr-hidden");
        }

        $viewType.attr("href", $selectedViewType.attr("data-href"));
        $viewType.attr("data-type", $selectedViewType.attr("data-type"));
        $viewType.attr("data-showfilter-selector", $selectedViewType.attr("data-showfilter-selector"));
        $viewType.attr("data-mapvariablename", $selectedViewType.attr("data-mapvariablename"));
        $viewType.text($selectedViewType.text());

        $selectedViewType.attr("data-href", defaultHref);
        $selectedViewType.attr("data-type", defaultDataType);
        $selectedViewType.attr("data-showfilter-selector", defaultShowFilterSelector);
        $selectedViewType.attr("data-mapvariablename", defaultMapVariableName);
        $selectedViewType.text(defaultText);

        var filterData = getMainFilterData();
        var advancedFilterData = getAdvancedFilterData();
        var destinationData = getDestinationFilterData();
        var sortDataString = getSortFilterString();
        var viewTypeDataString = getViewTypeFilterString();

        $.extend(filterData, advancedFilterData, destinationData);

        var filterDataString = serializeData(filterData) + "&" + sortDataString + "&" + viewTypeDataString;

        handleFilterAndUpdateUrl(filterDataString, FILTER_TYPES.VIEW_TYPE);

        $(".js-searchResultFilters--bar").addClass("fshr-hidden");
        var $showFilter = global.getElementsBySelector(defaultShowFilterSelector, $viewType);
        $showFilter.removeClass("fshr-hidden");

        $listToHide.hide();
        setTimeout(function () {
            $listToHide.removeAttr("style");
        });
    });

    // filtry na detailu
    var timeoutId = 0;
    $(document).on("filter-close popup-close data-reseted filter-changed-remotely sorting-call", ".js-filter--detail", function (event) {
        var $element = $(this);
        clearTimeout(timeoutId);

        timeoutId = setTimeout (function () {
            var $form = $element.closest(".js-filter-form");
            var $pageContent = $(".js-ajaxPlaceholder--detailFilters");
            var $activeSorting = $pageContent.find(".js-ajaxSort.fshr-sorted");
            var formData = global.getFormsData($form);
            var url = $form.attr("action") || window.location.href.split("?")[0];
            var dataToUrl = serializeData(formData);
            if ($activeSorting.length && $activeSorting.attr("data-sortby")) {
                dataToUrl = dataToUrl + "&" + $activeSorting.attr("data-sortby");
            }

            $pageContent.addClass("fshr-dataLoading");
            var options = {
                method: "get",
                dataType: "html",
                success: function (data) {
                    $pageContent.html(data);
                    var $qtips = $pageContent.find(".js-tooltip");
                    var $stars = $pageContent.find(".js-stars");
                    $qtips.each(global.initializeQtip);
                    $stars.each(global.generateStars);
                    $pageContent.trigger("initializeCounters");

                    $pageContent.removeClass("fshr-dataLoading");
                },
                error: function (result) {
                    $(".js-ajaxPlaceholder--detailFilters").removeClass("fshr-dataLoading");
                }
            };
            global.ajax.functions.abortAll(url, "detail-filter");
            global.ajax.functions.send(url, dataToUrl + "&X-Requested-With=XMLHttpRequest", options, "detail-filter");
            global.updateUrlParameters(dataToUrl);

            $(".js-calendarBar").trigger("regenerate-flights");

        }, 200);
    });
    $(document).on("change", ".js-filter-checkbox--detail", function () {
        $(".js-filter--detail").trigger("filter-changed-remotely");
    });
    // stránkování na detailu

    $(document).on("click", ".js-ajaxPlaceholder--detailFilters .js-ajaxSort", function (event) {
        event.preventDefault();
        var $element = $(this);
        var $placeholder = $element.closest(".js-ajaxPlaceholder--detailFilters");
        $placeholder.find(".js-ajaxSort.fshr-sorted").removeClass("fshr-sorted");
        $element.addClass("fshr-sorted");
        $element.attr("data-sortby", $element.attr("data-sortto"));
        $(".js-filter--detail").trigger("sorting-call");
    });

    generateDownhillGraph($(".js-downhillgraph:not(.js-downhillgraph--generated)"));


    function getGlobalOccupancyFromMainFilter () {
        var $mainFilter = $(".js-menuSearch-content.fshr-searchMenu--selected .js-filter.fshr-filter--availability:not(.js-filter--detail)");

        var tabActiveIndex = $mainFilter.find(".fshr-tab-anchor--active").parent().index();
        var groupCount = $mainFilter.find("input.js-availabilityCount-input-filter").val();
        var userGroupId = $mainFilter.find("select.js-availability-group").val();

        var rooms = [];
        var $rooms = $mainFilter.find(".fshr-cloned-template");
        $rooms.each(function () {
            var $room = $(this);
            var adultsCount = $room.find("select.js-old").val();
            var childrenCount = $room.find("select.js-young").val();
            var childrenAges = [];

            if (childrenCount) {
                var $childrenAge = $room.find(".js-children .grd-col:not(.fshr-hidden) select");
                $childrenAge.each(function () {
                    var $childAge = $(this);
                    childrenAges.push($childAge.val());
                });
            }
            rooms.push({
                adults: adultsCount,
                children: childrenCount,
                ages: childrenAges
            });
        });

        return {
            tabActiveIndex: tabActiveIndex,
            rooms: rooms,
            groupCount: groupCount,
            userGroupId: userGroupId
        };
    }
    function setDetailOccupancyFromMainFilter (data) {
        var $detailOccupancyFilter = $(".js-filter.fshr-filter--availability.js-filter--detail");

        var tabActiveItems = data.tabActiveIndex;
        var groupCount = data.groupCount;
        var userGroupId = data.userGroupId;

        var $activeTab = $detailOccupancyFilter.find(".fshr-tabsNavigation-item:eq(" + tabActiveItems + ") .js-tabControl");
        $activeTab.trigger("click");

        var $group = $detailOccupancyFilter.find(".js-availabilityCount-input-detailFilter");
        $group.val(groupCount).trigger("change");

        var $userGroup = $detailOccupancyFilter.find("select.js-availability-group");
        if ($userGroup.length) {
            $userGroup.val(userGroupId);
            $userGroup.trigger("change");
        }

        var rooms = data.rooms;
        var $cloneParent = $detailOccupancyFilter.find(".js-clone-parent");
        var $allRooms = $detailOccupancyFilter.find(".fshr-cloned-template");
        $allRooms.remove();
        var $addRoom = $detailOccupancyFilter.find("#add-new-room-detail");

        $cloneParent.one("dom-change", function () {
            var $parent = $(this);
            $.each(rooms, function (index, data) {
                var room = this;
                var $room = $parent.children(".fshr-cloned-template[data-clone-index='" + (index + 1)  + "']");
                var $oldSelect = $room.find("select.js-old");
                $oldSelect.val(room.adults);
                var $childrenSelect = $room.find("select.js-young");
                $childrenSelect.val(room.children);

                var $childrenAges = $room.find(".js-children select");
                var ages = data.ages;
                $.each(ages, function (ageIndex, age) {
                    $childrenAges.eq(ageIndex).val(age);
                });

                $room.find("select").trigger("change");
            });
        });

        $addRoom.trigger("click", {count: rooms.length});
    }
    // globální obsazenost
    $(document).on("filter-close popup-close", ".js-menuSearch-content .js-filter.fshr-filter--availability:not(.js-filter--detail), #popup-availability", function (event) {
        var formData = getOccupancyFilterData();
        //var url = window.location.href.split("?")[0]; //: "http://v2.nev-dama.cz/zima/vysledek-hledani";
        var url = "/common/ulozSkupinu";
        var $detailFilter = $(".js-filter--detail");
        var isDetail = $detailFilter.length;
        if (isDetail) {
            url = window.location.href.split("#")[0];
            url = url.split("?")[0] + "/sedivka";
            var $detailSummary = $(".fshr-detail-summary.js-detail");
            var additionalData = $detailSummary.attr("data-additionalajaxdata") || "";
            $detailSummary.addClass("fshr-ajaxLoading");

            var occupancyData = getGlobalOccupancyFromMainFilter();
            setDetailOccupancyFromMainFilter(occupancyData);
            $(".js-tabControl[href='#termins']").attr("data-globaloccupancy-set", "true");
            $detailFilter.trigger("filter-changed-remotely");
        }
        var options = {
            dataType: "json",
            method: "get",
            success: function (data) {
                if (isDetail) {
                    $detailSummary.html(data.pageHtml);
                    $detailSummary.removeClass("fshr-ajaxLoading");
                    $detailSummary.find(".js-tooltip").each(global.initializeQtip);
                }
            }
        };
        var dataArray = [];
        dataArray.push($.param(formData));
        if (additionalData) {
            dataArray.push(additionalData);
        }
        global.ajax.functions.send(url, dataArray.join("&"), options);
    })

})(jQuery, globalWrapper.fshr);


/**
 *  countdown
 *  */
(function ($, global) {
    function countDown () {
        var $countDowns = $(".js-countDown");

        $countDowns.each(function () {
            var $countDown = $(this);
            var countDownTill = parseInt($countDown.attr("data-countdown-till"), 10) || 0;

            var secondsTill = Math.floor(countDownTill / 1000);

            var hours = Math.floor(secondsTill / 60 / 60);
            var hoursSeconds = hours * 60 * 60;
            var minutes = Math.floor((secondsTill - hoursSeconds) / 60);
            var minutesSeconds = minutes * 60;
            var seconds = Math.floor(secondsTill - hoursSeconds - minutesSeconds);

            $countDown.text(("00" + hours).substr(-3) + ":" + ("0" + minutes).substr(-2) + ":" + ("0" + seconds).substr(-2));

            if (!secondsTill) {
                if (!$countDown.is("[data-countdown-reloadpage]")) {
                    var $wrapper = $countDown.closest(".fshr-flashsale-item");
                    $countDown.closest(".fshr-paragraph").html("<b>Platnost této nabídky již vypršela</b>");
                    $countDown.remove();
                    var aHtml = $wrapper.html();
                    var aClass = $wrapper.attr("class");
                    $wrapper.replaceWith("<div class='" + aClass + " fshr-flashsale-item--disabled'>" + aHtml + "</div>");
                } else {
                    window.location.reload();
                }
            } else {
                secondsTill = secondsTill - 1;
                var newCountDownTill = secondsTill * 1000;
                $countDown.attr("data-countdown-till", newCountDownTill);
            }
        });

        setTimeout(function () {
            if ($countDowns.length) {
                countDown();
            }
        }, 1000);
    }
    countDown();
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 *  rooms
 *  */
(function ($, global) {

    $(document).on("click", ".js-room:not(.fshr-disabled)", function (event) {
        event.preventDefault();

        var $room = $(this);
        var $rooms = $room.closest(".js-rooms");
        var roomsData = $rooms.attr("data-rooms");
        var roomsJson = "";
        try {
            roomsJson = JSON.parse(roomsData);
        } catch (e) {
            console.warn("No data for those rooms");
        }

        if (roomsJson) {
            var $roomsSelected = $rooms.find(".js-rooms-selected");

            var $roomWrapper = $room.closest(".js-room-wrapper");
            var $allRooms = $rooms.find(".js-room");
            var $relatedRooms = $roomWrapper.find(".js-room");
            $relatedRooms.removeClass("fshr-active");
            $room.addClass("fshr-active");

            var $activeRooms = $allRooms.filter(".fshr-active");
            var roomsCount = {};
            $activeRooms.each(function () {
                var $activeRoom = $(this);
                var value = $activeRoom.text();
                var id = $activeRoom.attr("data-room-id");
                if (roomsCount[id]) {
                    roomsCount[id].count = (roomsCount[id].count || 0) + 1;
                    roomsCount[id].title = value;
                } else {
                    roomsCount[id] = {
                        count: 1,
                        title: value
                    }
                }
            });

            var roomsSelectedArray = [];
            $.each(roomsCount, function (id, object) {
                var count = object.count;
                var title = object.title;
                if (count == 1) {
                    roomsSelectedArray.push(title);
                } else {
                    roomsSelectedArray.push(count + "&times; " + title );
                }
                if (roomsJson[id]) {
                    if (count == roomsJson[id]) {
                        $allRooms.filter("[data-room-id='" + id + "']:not(.fshr-active)").addClass("fshr-disabled");
                    } else {
                        $allRooms.filter("[data-room-id='" + id + "']").removeClass("fshr-disabled");
                    }
                }
            });
            $roomsSelected.html(roomsSelectedArray.join(", "));
        }



    });

})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 *  seasons differences
 *  */
(function ($, global) {
    $(document).on("click", ".js-season", function (event) {
        event.preventDefault();
        var $this = $(this);
        var seasonType = $this.attr("data-season-type");

        $(".js-season-related").each(function () {
            var $item = $(this);
            var itemSeasonType = $item.attr("data-season-only");
            if (itemSeasonType == seasonType) {
                $item.removeClass("fshr-hidden");
            } else {
                $item.addClass("fshr-hidden");
                if ($item.is(".js-select-item.fshr-select-option--selected")) {
                    $item.closest(".fshr-select-options").find(".js-select-item[data-change-detection-default] .js-select-handler").click();
                }
            }
        })
    })
})(jQuery, globalWrapper.fshr);


/**
 * load content by ajax
 * */
(function ($, global) {
    function getWebCamsHtml (camData) {
        var camHtml = '';
        camHtml = camHtml + '<div class="grd-col grd-col--4 grd-col--smd-6 grd-col--sm-12">';
        camHtml = camHtml + '   <div class="fshr-textImage">';
        camHtml = camHtml + '       <p class="fshr-textImage-title fshr-textImage-title--cuddleTop" title="' + camData.title.long + '">';
        camHtml = camHtml +             camData.title.short;
        camHtml = camHtml + '       </p>';
        camHtml = camHtml + '       <a href="' + camData.href + '" class="fshr-textImage-anchor" target="_blank">';
        camHtml = camHtml + '           <img src="' + camData.img + '" alt="" class="fshr-textImage-image">';
        camHtml = camHtml + '       </a>';
        camHtml = camHtml + '   </div>';
        camHtml = camHtml + '</div>';
        return camHtml;
    }
    function loadAjaxContent () {
        var $element = $(this);
        var ajaxUrl = $element.attr("data-ajax-url");
        var ajaxType = $element.attr("data-ajax-type");
        if (ajaxUrl) {
            var returnDataType = "html";
            var method = "get";
            switch (ajaxType) {
                case "rooms":
                    returnDataType = "json";
                break;
                case "webcams":
                    returnDataType = "html";
                break;
            }
            var customOptions = {
                dataType: returnDataType,
                method: method,
                success: function (data) {
                    switch (ajaxType) {
                        case "rooms":
                            $element.html(data.pageHtml);
                            var $jsRooms = $element.closest(".js-rooms");
                            if ($jsRooms.length) {
                                $jsRooms.attr("data-rooms", rooms.roomsFree);
                            }
                        break;
                        case "webcams":
                            var visibleCamsCount = 3;
                            html = "<p class='fshr-paragraph fshr-paragraph--center'><b>" + $element.attr("data-ajax-noresulttext") + "</b></p>";
                            if (global.isJSON(data) && data.length) {
                                data = JSON.parse(data);
                                var html = '<div class="grd-container"><div class="grd-row">';
                                var totalCamsCount = data.length;
                                for (var index = 0; index < visibleCamsCount; index++) {
                                    var camData = data[index];
                                    html = html + getWebCamsHtml(camData);
                                }
                                html = html + '</div>';
                                if (totalCamsCount > visibleCamsCount) {
                                    html = html + '<div class="grd-row fshr-hidden js-camerasContent">';
                                    for (var index = visibleCamsCount-1; index < totalCamsCount; index++) {
                                        var camData = data[index];
                                        html = html + getWebCamsHtml(camData);
                                    }
                                    html = html + '</div>';
                                }
                                html = html + '</div>';
                                if (totalCamsCount > visibleCamsCount) {
                                    html = html + '<div class="fshr-contentBox-footer">';
                                    html = html + '    <a href="#" class="fshr-contentBox-footer-anchor js-toggleSlide" data-toggleslide-selector="closest(.js-loadContentByAjax)->find(.js-camerasContent)" data-toggleslide-showtext="Zobrazit další webkamery" data-toggleslide-hidetext="Skrýt webkamery">Zobrazit další webkamery</a>';
                                    html = html + '</div>';
                                }
                            }
                            $element.html(html);
                        break;
                        case "searchMenu" :
                            $element.html(data);
                            $element.trigger('start-all-functions', [$element]);
                        break;
                        default:
                            $element.html(data);
                            $element.trigger('start-menu-functions', [$element]);
                    }
                    var removeDisabledSelector = $element.attr("data-ajax-removedisabled-selector");
                    if (removeDisabledSelector) {
                        setTimeout(function () {
                            var $removeDisabled = global.getElementsBySelector(removeDisabledSelector, $element);
                            if ($removeDisabled.length) {
                                var $disabledElements = $removeDisabled.find("[disabled], .js-select--disabled");
                                $disabledElements.removeAttr("disabled").removeClass("js-select--disabled");
                            }
                        });
                    }
                    $element.removeClass("fshr-ajax-loading").addClass("js-loadContentByAjax--loaded");
                }
            };
            $element.addClass("fshr-ajax-loading");
            global.ajax.functions.send(ajaxUrl, "", customOptions);
        }
    }
    $(document).on("load-content", ".js-loadContentByAjax:not(.js-loadContentByAjax--loaded,.fshr-ajax-loading)", loadAjaxContent);
    $(".js-loadContentByAjax:not(.js-loadContentByAjax--loaded,.fshr-ajax-loading)[data-ajax-loadimmediately]").trigger("load-content");
})(jQuery, globalWrapper.fshr);


/**
 * add and remove to favorite
 * */
(function ($, global) {
    $(document).on("click", ".js-addToFavorite", function (event) {
        event.preventDefault();
        var $main = $(this);
        var removeTitle = $main.attr("data-remove-title");
        var addTitle = $main.attr("data-add-title");
        var $element = $(this);
        var id = $element.attr("data-favorite-id");
        var url = global.isLocalhost() ? "http://v2.nevdama.cz/nohit/member/PrepniOblibene" : "/nohit/member/PrepniOblibene";



        if($element.hasClass("fshr-icon")){
            var removeFromFavorite = $element.hasClass("fshr-active");
        }else{
            var removeFromFavorite = $element.find(".fshr-icon").is(".fshr-active");
        }

        var options = {
            dataType: "json",
            method: "post",
            success: function (data) {
                if (data.status != "E") {

                    if (removeFromFavorite) {
                        if(!$element.hasClass("fshr-icon")){
                            $element = $element.find(".fshr-icon");
                        }
                        $element.removeClass("fshr-icon--heart");
                        $element.addClass("fshr-icon--heartOutlined");
                        $element.removeClass("fshr-active");
                        $main.attr("title", addTitle);
                        global.initializeQtip($main);
                    } else {
                        if(!$element.hasClass("fshr-icon")){
                            $element = $element.find(".fshr-icon");
                        }
                        $element.removeClass("fshr-icon--heartOutlined");
                        $element.addClass("fshr-icon--heart");
                        $element.addClass("fshr-active");
                        $main.attr("title", removeTitle);
                        global.initializeQtip($main);
                    }

                    var $favoriteCount = $(".js-compareAnimationDestination .fshr-menuFavorite, .js-menuFavorite");
                    $favoriteCount.each(function(index, val){
                        var favoriteCount = parseInt($(this).text(), 10);
                        var newCount = removeFromFavorite ? (favoriteCount - 1) : (favoriteCount + 1);
                        $(this).html(newCount);
                    });


                }
            }
        };
        global.ajax.functions.send(url, "id=" + id, options);
    });
})(jQuery, globalWrapper.fshr);


/**
 * form validation
 * */
(function ($, global) {
    function validateInput ($input) {
        var inputType = $input.attr("data-input-type") || $input.attr("type");

        if(inputType == "date-group"){
            inputValue = {
                'day': $input.find(".js-date").val(),
                'month' : $input.find(".js-month").val(),
                'year' : $input.find(".js-year").val()
            }
            var dateCondition = $input.attr("data-date-condition") || "full";
        }else{
            var inputValue = $input.val();
        }

        var selectOne = false;
        var valueIsEmpty = (inputValue.length === 0);
        if(inputType == "date-group"){

            if(inputValue.day.length > 0 && inputValue.month.length > 0 && inputValue.year.length > 0){
                valueIsEmpty = false;
            }else{
                valueIsEmpty = true;
            }
        }
        if (inputType === "checkbox") {
            valueIsEmpty = true;
            var $checkboxGroup = $input.closest(".form-field-checkboxgroup");

            if($checkboxGroup.length > 0){

                var allCheckboxes = $checkboxGroup.find("input");
                allCheckboxes.each(function(){
                    if($(this).is(":checked")){
                        valueIsEmpty = false;
                    }
                });
                selectOne = true;
            }else{
                valueIsEmpty = !$input.is(":checked");
            }
        }
        if (inputType === "radio") {
            var inputName = $input.attr("name");
            var $form = $input.closest(".js-form");
            var $allRadios = $form.find("input[name='" + inputName + "']");

            valueIsEmpty = true;
            $allRadios.each(function () {
                if ($(this).is(":checked")) {
                    valueIsEmpty = false;
                    return false;
                }
            });
            selectOne = true;
        }
        var valueIsValid = false;
        if(typeof inputValue == "string"){
            var inputValueNoSpaces = inputValue.replace(/ /g,'');
        }

        var greaterThan = $input.attr("data-greater-than") || false;
        var smallerThan = $input.attr("data-smaller-than") || false;

        if (!valueIsEmpty) {
            switch (inputType) {
                case "date-group":

                    var day = inputValue.day;
                    var month = inputValue.month;
                    var year = inputValue.year;
                    var joined = year + "-" + month + "-" + day;

                    var dateInput = Date.parse(joined);
                    var today = new Date();
                    if(!isNaN(dateInput)){
                        if(dateCondition == "past"){
                            if(dateInput > today.getTime()){
                                valueIsValid = false;
                            }else{
                                valueIsValid = true;
                            }
                        }
                    }else{
                        valueIsValid = false;
                    }
                    break;
                case "email":
                    var emailPattern = /^(?=[A-Z0-9][A-Z0-9@._%+-]{5,253}$)[A-Z0-9._%+-]{1,64}@(?:(?=[A-Z0-9-]{1,63}\.)[A-Z0-9]+(?:-[A-Z0-9]+)*\.){1,8}[A-Z]{2,63}$/gi;
                    valueIsValid = emailPattern.test(inputValue);
                break;
                case "tel":
                    var phonePattern = /^((00|\+)?[0-9]{2,3})?[0-9]{5,9}$/;
                    valueIsValid = phonePattern.test(inputValueNoSpaces);
                break;
                case "zip":
                    var zipPattern = /^[0-9]{5}$/;
                    valueIsValid = zipPattern.test(inputValueNoSpaces);
                break;
                case "zip-pl":
                    var zipPattern = /^\d{2}-{0,1}\d{3}$/;
                    valueIsValid = zipPattern.test(inputValueNoSpaces);
                break;
                case "password":
                    var passwordPattern = /^.{5,}$/;
                    valueIsValid = passwordPattern.test(inputValueNoSpaces);
                break;
                case "year":
                    var maximumAge = 200;
                    var todayYear = new Date().getFullYear();
                    var isYear = inputValueNoSpaces.length === 4;
                    var inputYear = parseInt(inputValueNoSpaces, 10);
                    var isBeforeToday = inputYear <= todayYear;
                    var isTillMaximumAge = inputYear >= (todayYear - maximumAge);
                    valueIsValid = isYear && isBeforeToday && isTillMaximumAge;
                break;
                case "number":
                    var numberPattern = /[0-9]+[\.,]?[0-9]?/;
                    valueIsValid = numberPattern.test(inputValueNoSpaces);
                    if (valueIsValid) {
                        var min = $input.attr("min");
                        var max = $input.attr("max");
                        inputValue = parseFloat(inputValue);
                        if ((typeof min !== "undefined" && min > inputValue) || (typeof max !== "undefined" && inputValue > max)) {
                            valueIsValid = false;
                        }
                        if(greaterThan){
                            var greaterThanElement = $(greaterThan);
                            var elementValue = parseInt(greaterThanElement.val());
                            if(!isNaN(elementValue)){
                                if(inputValue >= elementValue){
                                    valueIsValid = true;
                                    break;
                                }else{
                                    valueIsValid = false;
                                    break;
                                }
                            }
                        }
                        if(smallerThan){
                            var smallerThanElement = $(smallerThan);
                            var elementValue = parseInt(smallerThanElement.val());
                            if(!isNaN(elementValue)){
                                if(inputValue <= elementValue){
                                    valueIsValid = true;
                                    break;
                                }else{
                                    valueIsValid = false;
                                    break;
                                }
                            }
                        }
                    }
                break;
                case "date":
                    if(greaterThan){
                        var greaterThanElement = $(greaterThan);
                        if(greaterThanElement.val().length>0){
                            inputValue = inputValue.split(" ")[0];
                            inputValue = inputValue.split(".");
                            inputValue = inputValue[2] + "-" + inputValue[1] + "-" + inputValue[0];
                            elementValue = greaterThanElement.val().split(" ")[0];
                            elementValue = elementValue.split(".");
                            elementValue = elementValue[2] + "-" + elementValue[1] + "-" + elementValue[0];

                            var inputValueDate = Date.parse(inputValue);
                            var elementValueDate = Date.parse(elementValue);

                            if(inputValueDate && elementValueDate){
                                if(inputValueDate >= elementValueDate){
                                    valueIsValid = true;
                                    break;
                                }else{
                                    valueIsValid = false;
                                    break;
                                }
                            }else{
                                valueIsValid = false;
                                break;
                            }
                        }
                    }
                    if(smallerThan){
                        var smallerThanElement = $(smallerThan);
                        if(smallerThanElement.val().length>0){
                            inputValue = inputValue.split(" ")[0];
                            inputValue = inputValue.split(".");
                            inputValue = inputValue[2] + "-" + inputValue[1] + "-" + inputValue[0];
                            elementValue = smallerThanElement.val().split(" ")[0];
                            elementValue = elementValue.split(".");
                            elementValue = elementValue[2] + "-" + elementValue[1] + "-" + elementValue[0];

                            var inputValueDate = Date.parse(inputValue);
                            var elementValueDate = Date.parse(elementValue);

                            if(inputValueDate && elementValueDate){
                                if(inputValueDate <= elementValueDate){
                                    valueIsValid = true;
                                    break;
                                }else{
                                    valueIsValid = false;
                                    break;
                                }
                            }else{
                                valueIsValid = false;
                                break;
                            }
                        }
                    }
                default:
                    valueIsValid = true;
            }
        }

        return {
            empty: valueIsEmpty,
            valid: valueIsValid,
            selectOne: selectOne
        };
    }
    /*function getRecaptchaValidity ($recaptcha) {
        var recaptchaId = parseInt($recaptcha.attr("data-captcha-id"), 10);
        var recaptchaResponse = grecaptcha.getResponse(recaptchaId);
        return recaptchaResponse.length != 0;
    }*/
    function removeValidationMessages () {
        var $messages = $(".js-validationMessage");
        $messages.removeClass("fshr-validationMessage--show");
        setTimeout(function () {
            $messages.remove();
        }, 200);
    }
    function placeValidationMessage (invalidInputInfo) {

        var $invalidInput = invalidInputInfo.element;

        var invalidInputValidationResult = invalidInputInfo.validateResult;


        var validateMessageText = "";
        var emptyText = $invalidInput.attr("data-validitytext-empty") || global.localization.formValidation.empty || "Položka je povinná.<br>Prosíme, vyplňte ji.";
        var invalidText = $invalidInput.attr("data-validitytext-invalid") || global.localization.formValidation.invalid || "Položka má špatný formát.<br>Prosíme, opravte ji.";
        var selectOneText = $invalidInput.attr("data-validitytext-selectone") || global.localization.formValidation.selectone || "Prosíme, vyberte jednu z možností.";

        if (invalidInputValidationResult.empty) {
            validateMessageText = emptyText;
        } else {
            validateMessageText = invalidText;
        }

        if (invalidInputValidationResult.selectOne) {
            validateMessageText = selectOneText;
            $invalidInput = $invalidInput.closest(".js-messageWrapper");
        }else if($invalidInput.attr("type") === 'checkbox'){
            $invalidInput = $invalidInput.closest(".form-field");
        }



        /*if($invalidInput.css("display") == "none" || $invalidInput.length == 0){
            $invalidInput = invalidInputInfo.element.closest(".form-field");
        }*/

        var $validateMessage = $("<div class='fshr-validationMessage fshr-validationMessage--error js-validationMessage'>" + validateMessageText + "</div>");
        var inputOffset = $invalidInput.offset();
        var inputPosition = $invalidInput.position();
        var inputHeight = $invalidInput.outerHeight();
        var inputWidth = $invalidInput.outerWidth();

        if ($invalidInput.is(".js-selectCustom")) {
            var $fakeSelect = $invalidInput.closest(".js-select-wrapper");
            inputOffset = $fakeSelect.offset();
            inputPosition = $fakeSelect.position();
            inputHeight = $fakeSelect.outerHeight();
            inputWidth = $fakeSelect.outerWidth();
        }


        var $toAppend = $invalidInput.closest(".fshr-contentBox");
        var toAppendOffset = $toAppend.offset();
        var left = inputPosition.left;
        var top = inputPosition.top;

        if (!$toAppend.length) {
            $toAppend = $invalidInput.closest(".js-popupWindow");
            if($toAppend.hasClass("js-apendMessagesToInputs")){
                $toAppend = $invalidInput.closest(".form-field");
            }
            if ($toAppend.length) {
                toAppendOffset = $toAppend.offset();
                top = inputOffset.top - toAppendOffset.top;
            }
        }
        if (!$toAppend.length) {
            $toAppend = $("body");
            left = $invalidInput.offset().left;
            top = $invalidInput.offset().top;
        }
        if ($toAppend.css("overflow") === "auto") {
            top = toAppendOffset.top - $(window).scrollTop + $invalidInput.position().top;
        }
        $toAppend.append($validateMessage);
        var verticalCenterDifference = 0;
        var messageMinWidth = parseInt($validateMessage.css("min-width"), 10);
        if (inputWidth < messageMinWidth) {
            verticalCenterDifference = (messageMinWidth - inputWidth) / 2;
            left = left - verticalCenterDifference;
        }
        var messageMaxWidth = parseInt($validateMessage.css("max-width"), 10);
        if (inputWidth > messageMaxWidth) {
            verticalCenterDifference = (messageMaxWidth - inputWidth) / 2;
            left = left - verticalCenterDifference;
        }

        $validateMessage.css({
            left: left + "px",
            top: (top + inputHeight) + "px",
            width: inputWidth
        });

        if ($invalidInput.is("input, textarea, select:not(.js-selectCustom)")) {
            $invalidInput.focus();
        }
        setTimeout(function () {
            $validateMessage.addClass("fshr-validationMessage--show");
        }, 0);
    }

    window.validateForm = function (button) {
        var $triggerButton = $(button);
        var $pseudoForm = $triggerButton.closest(".js-form");

        var $requiredInputs =  $pseudoForm.find("input[data-form-required], textarea[data-form-required], select[data-form-required], .js-date-group");
        var inputsAreValid = true;
        var invalidInputs = [];
        $requiredInputs.removeClass("fshr-validation-noValid");
        $requiredInputs.closest(".form-field.form-field-enhanced").removeClass("fshr-validation-noValid");

        $requiredInputs.each(function () {
            var $input = $(this);
            var validateResult = validateInput($input);
            if (validateResult.empty || !validateResult.valid) {
                inputsAreValid = false;
                var inputSelector = $input.attr("data-fakeinput-selector");
                if (inputSelector) {
                    $input = global.getElementsBySelector(inputSelector, $input);
                }

                if($input.closest(".form-field-radiogroup").length === 0){
                    $input.addClass("fshr-validation-noValid");
                    $input.closest(".form-field.form-field-enhanced").addClass("fshr-validation-noValid");
                    $input.closest(".js-select-wrapper").find(".js-select-value").addClass("fshr-validation-noValid");
                }

                var inputInfo = {
                    element: $input,
                    validateResult: validateResult
                };
                invalidInputs.push(inputInfo);
            }
        });

        if (!inputsAreValid) {
            var firstInvalidInputInfo = invalidInputs[0];
            setTimeout(function () {
                placeValidationMessage(firstInvalidInputInfo);
            }, 0);
            $pseudoForm.addClass("js-formIsInvalid");
            $triggerButton.removeClass("fshr-isWorking");
        } else {
            $pseudoForm.removeClass("js-formIsInvalid");
        }

        return inputsAreValid;
    };

    var $forms = $("form");
    $forms.attr("novalidate", "novalidate");
    $(document).on("click", "button[type=submit]", function (event) {

        var $triggerButton = $(this);
        if (!$triggerButton.is("[data-nospinner]")) {
            $triggerButton.addClass("fshr-isWorking");
        }

        var $pseudoForm = $triggerButton.closest(".js-form");
        if($pseudoForm.length > 0){

            event.preventDefault();
            var inputsAreValid = window.validateForm($triggerButton);


            if(typeof $pseudoForm.attr("data-callbyvalid") != "undefined" && inputsAreValid){
                var callbyvalid = $pseudoForm.attr("data-callbyvalid");
                window[callbyvalid]($pseudoForm);
            }else{
                var prom = recaptchaValidator($pseudoForm);
                prom.then(function ($form) {
                    if(!$form.hasClass("js-sendByAjax") && inputsAreValid){
                        $form.submit();
                    }
                    $form.trigger("validation-complete");
                }, function ($form) {
                    if(!$form.hasClass("js-sendByAjax") && inputsAreValid){
                        $form.submit();
                    }
                    $form.trigger("validation-complete");
                });
            }

        }


    });

    $(document).on("input keydown change select-change", "input[data-form-required], textarea[data-form-required], select[data-form-required], .js-date-group", function () {
        var $input = $(this);
        if($input.hasClass("js-date-group")){
            var $label = $input;
            var $labelParent = $label;
        }else{
            var $label = $input.parent();
            var $labelParent = $label;
        }


        var selector = $input.attr("data-label-selector");
        if (selector) {
            $label = global.getElementsBySelector(selector, $input);
            $labelParent = $label.parent();
        }
        var cssClassInvalid = "fshr-validation-error";
        var cssClassEmpty = "fshr-validation-empty";
        var cssClassValid = "fshr-validation-valid";
        var cssClassNoValid = "fshr-validation-noValid";



        var $requiredInputs = $labelParent.find("input[data-form-required], textarea[data-form-required], select[data-form-required], .js-date-group");
        var validateResult = validateInput($input);

        if ($requiredInputs.length >= 1) {

            validateResult = {
                empty: false,
                valid: true
            };



            $requiredInputs.each(function () {
                var $input = $(this);
                var result = validateInput($input);
                if (result.empty || !result.valid) {
                    validateResult = {
                        empty: result.empty,
                        valid: result.valid
                    };
                } else {
                    var fakeInputSelector = $input.attr("data-fakeinput-selector");
                    if (fakeInputSelector) {
                        $input = global.getElementsBySelector(fakeInputSelector, $input);
                    }
                    $input.removeClass(cssClassNoValid);
                    $input.closest(".form-field.form-field-enhanced").removeClass(cssClassNoValid);
                    $input.closest(".js-select-wrapper").find(".js-select-value").removeClass(cssClassNoValid);
                }
            });
        }

        if (!validateResult.empty) {
            $label.removeClass(cssClassEmpty);
            if (validateResult.valid) {
                var fakeInputSelector = $input.attr("data-fakeinput-selector");
                if (fakeInputSelector) {
                    $input = global.getElementsBySelector(fakeInputSelector, $input);
                }
                if($input.closest(".form-field-radiogroup").length === 0){
                    $label.addClass(cssClassValid);
                    $label.removeClass(cssClassInvalid);
                    $input.removeClass(cssClassNoValid);
                }
                $input.closest(".js-select-wrapper").find(".js-select-value").removeClass(cssClassNoValid);

                removeValidationMessages ();
            } else {
                $label.removeClass(cssClassValid);
                $label.addClass(cssClassInvalid);
            }
        } else {
            $label.removeClass(cssClassInvalid);
            $label.removeClass(cssClassValid);
            $label.addClass(cssClassEmpty);
        }
    });

    $(document).on("click keydown captcha-send", removeValidationMessages);
    $(window).on("resize", removeValidationMessages);

    $("[required]").each(function () {
        var $element = $(this);
        $element.removeAttr("required");
        $element.attr("data-form-required", true);
    });

})(jQuery, globalWrapper.fshr);


/**
 * send form by ajax
 * */
(function ($, global) {
    /*
    function handleAjaxError ($form) {
        var message = $form.attr("data-ajaxerror-message") || "Při odesílání formuláře došlo k chybě.";
        var $messagePlaceholder = $form.find(".js-ajaxResultMessage");
        $messagePlaceholder.addClass("fshr-ajaxResultMessage--error");
        $messagePlaceholder.html(message);
        var $submitButton = $form.find("button[type=submit]");
        $submitButton.removeClass("fshr-isWorking");
        hideMessage($messagePlaceholder, delayToHideMessage);
    }

    $(".js-sendByAjax").on("validation-complete", function () {
        var $pseudoForm = $(this);
        var method = $pseudoForm.attr("data-ajaxform-method") || $pseudoForm.attr("method") ||  "get";
        var dataType = $pseudoForm.attr("data-ajaxform-datatype") || "html";
        var url = $pseudoForm.attr("data-ajaxform-url") || $pseudoForm.attr("action") || window.location.href;
        var ajaxPlaceholderSelector = $pseudoForm.attr("data-form-ajaxplaceholder");
        var $ajaxPlaceholder = global.getElementsBySelector(ajaxPlaceholderSelector, $pseudoForm);
        $ajaxPlaceholder.addClass("fshr-ajaxLoading");

        var data = $pseudoForm.find("input, select, textarea").serialize();

        if ($pseudoForm.is("[data-form-withsorting]")) {
            var $activeSorting = $ajaxPlaceholder.find(".js-ajaxSort.fshr-sorted");
            if ($activeSorting.length && $activeSorting.attr("data-sortby")) {
                data = data + "&" + $activeSorting.attr("data-sortby");
            }
        }


        $.ajax({
            data: data,
            dataType: dataType,
            method: method,
            url: url,
            success: function (response, textStatus, jqXHR) {
                $ajaxPlaceholder.html(response).removeClass("fshr-ajaxLoading");
            },
            error: function () {
                handleAjaxError($pseudoForm);
            }
        });
    });
*/

    var delayToHideMessage = 5000;
    function clearInputs ($form) {
        var $inputs = $form.find("input, textarea");
        $inputs.each(function () {
            var $input = $(this);
            var inputType = $input.attr("type");
            switch (inputType) {
                case "checkbox":
                    $input.prop("checked", false);
                break;
                case "radio":
                    $input.prop("checked", false);
                break;
                default:
                    $input.val("");
            }
            $input.trigger("change");
        })
    }
    function clearSelect ($form) {
        var $selects = $form.find("select");
        $selects.each(function () {
            var $select = $(this);
            $select.find("option").prop("selected", false);
        });
        $selects.trigger("change").trigger("select-change");
    }
    function clearRecaptcha ($form) {
        /*
        var $recaptcha = $form.find(".g-recaptcha");
        if ($recaptcha.length && "grecaptcha" in window) {
            var recaptchaId = $recaptcha.attr("data-captcha-id");
            grecaptcha.reset(recaptchaId);
        }
        */
    }
    function removeValidationClasses ($form) {
        $form.find(".fshr-validation-valid").removeClass("fshr-validation-valid");
        $form.find(".fshr-validation-error").removeClass("fshr-validation-error");
        $form.find(".fshr-validation-empty").removeClass("fshr-validation-empty");
    }
    function hideMessage ($messagePlaceholder, delay) {
        setTimeout (function () {
            $messagePlaceholder.fadeOut(500, function () {
                $messagePlaceholder.html("");
                $messagePlaceholder.removeAttr("style");
                $messagePlaceholder.removeClass("fshr-ajaxResultMessage--error fshr-ajaxResultMessage--success");
            });
        }, delay);
    }
    function handleAjaxSuccess (response, textStatus, jqXHR, $pseudoForm) {
        if (typeof response === "object" && "url" in response && response.url) {
            window.location = response.url;
        } else {
            var errorOccurred = !response.success;
            var message = response.message;
            var $messagePlaceholder = $pseudoForm.find(".js-ajaxResultMessage");
            var closeAfterSubmission = $pseudoForm.attr("data-closeaftersubmission");
            var $newPopup = $();
            if (!errorOccurred) {
                var newPopupSelector = $pseudoForm.attr("data-popupselector");
                if (newPopupSelector) {
                    $newPopup = global.getElementsBySelector(newPopupSelector, $pseudoForm);
                    if ($newPopup.length) {
                        $messagePlaceholder = $newPopup.find(".js-ajaxResultMessage");
                    }
                }
            }
            var $submitButton = $pseudoForm.find("button[type=submit]");
            $messagePlaceholder.html(message);

            if (typeof response === "object" && "message" in response) {
                if (errorOccurred) {
                    $messagePlaceholder.addClass("fshr-ajaxResultMessage--error");
                } else {
                    $messagePlaceholder.addClass("fshr-ajaxResultMessage--success");
                    if("redirect_url" in response){
                        $pseudoForm.attr("action", response.redirect_url);
                        $pseudoForm.removeClass("js-sendByAjax");
                        $pseudoForm.submit();
                    }

                    var doIClear = $pseudoForm.attr("data-clear");
                    if(typeof doIClear == "undefined"){
                        doIClear = true;
                    }

                    if(doIClear == true){
                        clearInputs($pseudoForm);
                        clearSelect($pseudoForm);
                        clearRecaptcha($pseudoForm);
                        removeValidationClasses($pseudoForm);
                    }



                    if ("c" in response) {
                        $pseudoForm.attr("data-gtm-trackgoal-c", response.c);
                    } else {
                        $pseudoForm.removeAttr("data-gtm-trackgoal-c");
                    }

                    if(closeAfterSubmission){
                        setTimeout(function(){
                            global.popup.close();
                        },2000);
                    }

                    $pseudoForm.trigger("successfully-send");
                    if ($newPopup.length) {
                        global.popup.close();
                        global.popup.open($newPopup);
                    }
                    $submitButton.removeClass("fshr-isWorking");
                }
                //hideMessage($messagePlaceholder, response.delayToHideMessage || delayToHideMessage);
            } else {
                handleAjaxError($pseudoForm);
            }
            $submitButton.removeClass("fshr-isWorking");
        }
    }
    function handleAjaxError ($form) {

        var message = $form.attr("data-ajaxerror-message") || "Při odesílání formuláře došlo k chybě.";
        var $messagePlaceholder = $form.find(".js-ajaxResultMessage");
        $messagePlaceholder.addClass("fshr-ajaxResultMessage--error");
        $messagePlaceholder.html(message);
        var $submitButton = $form.find("button[type=submit]");
        $submitButton.removeClass("fshr-isWorking");
        hideMessage($messagePlaceholder, delayToHideMessage);
    }

    $("body").on("validation-complete",".js-sendByAjax", function (e) {
        var $pseudoForm = $(this);
        if (!$pseudoForm.is(".js-formIsInvalid")) {
            var $form = $pseudoForm.closest("form");
            var method = $pseudoForm.attr("data-ajaxform-method") || $form.attr("data-ajaxform-method") || $form.attr("method") || "get";
            var url = $pseudoForm.attr("data-ajaxform-url") || $form.attr("data-ajaxform-url") || $form.attr("action") || window.location.href;
            var selectorHelperPool = $pseudoForm.attr("data-selector-helperdatapool");
            var $helperPool = global.getElementsBySelector(selectorHelperPool, $pseudoForm);
            var data = $pseudoForm.add($helperPool).find("input, select, textarea").serialize();
            if($(this).hasClass("js-form-groups")){
                var objectToSend = {};
                $(this).trigger("processGroups", objectToSend);
                data = objectToSend;
            }


            $.ajax({
                data: data,
                method: method,
                url: url,
                success: function (response, textStatus, jqXHR) {
                    handleAjaxSuccess(response, textStatus, jqXHR, $pseudoForm)
                    $pseudoForm.trigger("ajax-form-send-success");
                },
                error: function (textStatus) {
                    handleAjaxError($pseudoForm);
                    $pseudoForm.trigger("ajax-form-send-fail");
                }
            });

        }
    });

})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 *  filter by js
 *  */
(function ($, global) {
    $(document).on("change", ".js-customFilter", function () {
        var $filter = $(this);
        var contentSelector = $filter.attr("data-filter-content");
        var missingContentSelector = $filter.attr("data-filter-missingcontent");
        var $content = global.getElementsBySelector(contentSelector, $filter);
        var $missingContent = global.getElementsBySelector(missingContentSelector, $filter);

        var $filteredItems = $content.find(".js-filteredItem");

        var $selects = $filter.find("select");
        $filteredItems.removeClass("fshr-hidden");
        var itemsToHide = [];
        $selects.each(function () {
            var $select = $(this);
            var value = $select.val();
            var name = $select.attr("name");

            if (Array.isArray(value) && value.length && value[0]) {
                $filteredItems.each(function () {
                    var $item = $(this);
                    var showItem = false;
                    var dataToFilter = $item.attr("data-filter-" + name);
                    var valuesToFilter = [];
                    if (dataToFilter) {
                        valuesToFilter = dataToFilter.split(",");
                    }

                    var containNonOfThem = true;
                    if (valuesToFilter.length) {
                        $.each(value, function (index, filterValue) {
                            showItem = valuesToFilter.indexOf(filterValue);
                            if (showItem > -1) {
                                containNonOfThem = false;
                                return false;
                            }
                        });
                    } else {
                        containNonOfThem = true;
                    }
                    if (containNonOfThem) {
                        itemsToHide.push($item);
                    }
                });
            }
        });


        $.each(itemsToHide, function (index, $item) {
            $item.addClass("fshr-hidden");
        });

        if (!$filteredItems.filter(":not(.fshr-hidden)").length) {
            $missingContent.removeClass("fshr-hidden");
            $content.addClass("fshr-hidden");
        } else {
            $missingContent.addClass("fshr-hidden");
            $content.removeClass("fshr-hidden");
        }

    });
    $(document).on("click", ".js-customSort", function (event) {
        event.preventDefault();
        var $element = $(this);
        var $parent = $element.closest(".js-ajaxResult");
        var $sortingArea = $parent.find(".js-sortingArea");
        var $allSortingElement = $parent.find(".js-customSort");
        var $itemsToSort = $sortingArea.find(".js-sortingItem");
        var $titles = $sortingArea.find(".fshr-flexTable-title");
        var sortBy = $element.attr("data-sortby");

        var switchDefaultSorting = false;
        if ($element.hasClass("fshr-icon--sortAsc")) {
            switchDefaultSorting = true;
        }

        $allSortingElement.removeClass("fshr-sorted fshr-icon fshr-icon--sortAsc fshr-icon--sortDesc");

        if (switchDefaultSorting) {
            $element.addClass("fshr-sorted fshr-icon fshr-icon--sortDesc");
        } else {
            $element.addClass("fshr-sorted fshr-icon fshr-icon--sortAsc");
        }

        if (sortBy) {
            $itemsToSort.sort(function (item1, item2) {
                var $item1 = $(item1);
                var $item2 = $(item2);

                var sortStatus = 0;

                var item1sortValue = $item1.attr("data-sort-" + sortBy);
                var item2sortValue = $item2.attr("data-sort-" + sortBy);

                if (item1sortValue && item2sortValue) {
                    item1sortValue = item1sortValue.toLowerCase();
                    item2sortValue = item2sortValue.toLowerCase();
                    if (item1sortValue < item2sortValue) {
                        if (switchDefaultSorting) {
                            sortStatus = 1;
                        } else {
                            sortStatus = -1;
                        }
                    }
                    if (item1sortValue > item2sortValue) {
                        if (switchDefaultSorting) {
                            sortStatus = -1;
                        } else {
                            sortStatus = 1;
                        }
                    }
                }

                return sortStatus;
            });

            $sortingArea.html($itemsToSort);
            $sortingArea.append($titles);

            $titles.addClass("fshr-hidden");
            if (sortBy == "date") {
                var prevValue = "";
                $itemsToSort.filter(":not(.fshr-flexTable-title)").each(function () {
                    var $item = $(this);
                    if (!$item.is(".fshr-hidden")) {
                        var value = $item.attr("data-sort-datetitle");
                        if (value != prevValue) {
                            var $validTitle = $titles.filter("[data-sort-datetitle='" + value + "']");
                            $validTitle.insertBefore($item);
                            $validTitle.removeClass("fshr-hidden");
                            prevValue = value;
                        }
                    }
                });
            }
        }

    });

})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 *  mobile search filter
 *  */
(function ($, global) {
    $(document).on("change", ".js-searchResultFilters--mobile input", function (event) {
        var $input = $(this);
        var selector = $input.attr("data-filterItem-selector");
        var $relatedElements = global.getElementsBySelector(selector, $input);
        $relatedElements.prop("checked", $input.is(":checked")).trigger("change");
    });
})(jQuery, globalWrapper.fshr);


/**
 * working after click
 * */
(function ($, global) {
    $(document).on("click", ".js-workingAfterClick", function () {
        var $element = $(this);
        $element.addClass("fshr-isWorking fshr-button--disabled");
        if ($element.is("button")) {
            setTimeout(function () {
                $element.attr("disabled", "disabled");
            }, 200);
        } else if ($element.is("a")) {
            setTimeout(function () {
                $element.removeAttr("href");
            }, 200);
        }
    });
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 * show content when input has value, hide otherwise
 * */
(function ($, global) {
    function showHideContentBasedOnInputValue () {
        var $input = $(this);
        var contentSelector = $input.attr("data-showcontentifvalue-selector");
        if (contentSelector) {
            var $content = global.getElementsBySelector(contentSelector, $input);
            if ($content.length) {
                if ($input.val() && !$content.is(":visible")) {
                    $content.slideDown();
                } else if (!$input.val() && $content.is(":visible")) {
                    $content.slideUp();
                }
            }
        }
    }
    $(".js-showContentIfValue").each(showHideContentBasedOnInputValue);
    $(document).on("input", ".js-showContentIfValue", showHideContentBasedOnInputValue);
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/**
 * highlight calendar days
 * */
(function ($, global) {
    $(document).on("change select-change", "select.js-calendar-highlight", function () {
        var $select = $(this);
        var calendarSelector = $select.attr("data-calendar-selector");
        var $calendar = global.getElementsBySelector(calendarSelector, $select);
        if ($calendar.length) {
            var calendarHighDaysLength = [];
            var $selectedOptions = $select.find("option:selected");
            if (!$selectedOptions.length) {
                $selectedOptions = $select.find("option:first-child");
            }
            $selectedOptions.each(function () {
                var $option = $(this);
                var highDays = $option.attr("data-calendar-highlight");
                if (highDays || highDays == 0) {
                    calendarHighDaysLength.push(highDays);
                }
            });
            $calendar.attr("data-datepicker-highdays-length", calendarHighDaysLength.join("|"));
            $calendar.trigger("update-highlighting");
        }
    });
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/*
* change anchor href
* */
(function ($, global) {
    $(document).on("click", ".js-anchorHrefChanger", function (event) {
        var $changer = $(this);
        var anchorSelector = $changer.attr("data-anchor-selector");
        var $anchors = global.getElementsBySelector(anchorSelector, $changer);
        var hrefType = $changer.attr("data-anchor-type");
        if ($anchors.length && hrefType) {
            $anchors.each(function () {
                var $anchor = $(this);
                var anchorNewHref = $anchor.attr("data-anchorhref-" + hrefType);
                $anchor.attr("href", anchorNewHref);
            });
        }
    });
})(jQuery, globalWrapper.fshr);

/* TO DISABLE */
/* SEARCH SELECT */
(function ($, global) {

    function filterFunction(that, event) {
        var container, input, filter, li, input_val;
        container = $(that).closest(".searchable");
        input_val = container.find("input.js-typer").val().toUpperCase();

        if (["ArrowDown", "ArrowUp", "Enter"].indexOf(event.key) != -1) {
            keyControl(event, container)
        } else {
            li = container.find("ul li");
            li.each(function (i, obj) {
                if ($(this).text().toUpperCase().search(input_val) > -1) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });

            if(input_val.length == 0){
                li.each(function(i, obj){
                    $(this).show();
                });
            }

            container.find("ul li").removeClass("selected");
            setTimeout(function () {
                container.find("ul li:visible").first().addClass("selected");
            }, 100)
        }
    }

    function keyControl(e, container) {
        if (e.key == "ArrowDown") {

            if (container.find("ul li").hasClass("selected")) {
                if (container.find("ul li:visible").index(container.find("ul li.selected")) + 1 < container.find("ul li:visible").length) {
                    container.find("ul li.selected").removeClass("selected").nextAll().not('[style*="display: none"]').first().addClass("selected");
                }

            } else {
                container.find("ul li:first-child").addClass("selected");
            }

        } else if (e.key == "ArrowUp") {

            if (container.find("ul li:visible").index(container.find("ul li.selected")) > 0) {
                container.find("ul li.selected").removeClass("selected").prevAll().not('[style*="display: none"]').first().addClass("selected");
            }
        } else if (e.key == "Enter") {
            e.preventDefault();
            var selected = container.find("ul li.selected");
            container.find("input.js-typer").val(container.find("ul li.selected").text()).blur();
            onSelect(this,container.find("ul li.selected").text(), selected.attr("data-value"));
        }

        var selected = container.find("ul li.selected").eq(0);
        console.log(selected.position().top);
        container.find("ul").animate({
            scrollTop: selected.position().top + container.find("ul").scrollTop()
        }, 200);

    }

    function onSelect(element, text, value) {
        var searchElement = $(element).closest(".js-searchSelect");

        if(typeof text != "undefined" && typeof value != "undefined"){
            searchElement.find(".js-val").val(value);
            searchElement.find(".js-typer").val(text);
        }else{
            var first = $(element).find("ul li:first");
            first.addClass("selected");
            $(element).find(".js-typer").val(first.text());
            alert("Hodnota musí být vybrána");
        }
    }

    $(document).ready(function(e){

        $("body").on("keyup", ".js-searchSelect", function (e) {
            e.preventDefault();
            e.stopPropagation();
            filterFunction(this, e);
        });

        $("body").on("keydown", ".js-searchSelect", function (e) {
            if (e.key == "Enter") {
                e.preventDefault();
            }
        });

        if ($(".js-searchSelect").length > 0) {
            window.addEventListener("keydown", function (e) {
                if ([32, 37, 38, 39, 40].indexOf(e.keyCode) > -1) {
                    e.preventDefault();
                }
            }, false);
        }

        $(".searchable input").focus(function () {
            $(this).closest(".searchable").find("ul").show();
            $(this).closest(".searchable").find("ul li").show();
        });

        $(".searchable input").blur(function () {
            var parent = $(this).closest(".js-searchSelect");

            var isSelectedItems = parent.find("ul li.selected");

            if(isSelectedItems && isSelectedItems.length == 1){
                selectedItem = isSelectedItems.eq(0);

                parent.find(".js-typer").val(selectedItem.text());
                parent.find(".js-val").val(selectedItem.attr("data-value"));
            }else{
                var first = parent.find("ul li:first");
                first.addClass("selected");
                parent.find(".js-typer").val(first.text());
            }

            var that = this;
            setTimeout(function () {
                $(that).closest(".searchable").find("ul").hide();
            }, 300);

        });

        $(document).on('click', '.searchable ul li', function () {
            $(this).closest(".searchable").find("input.js-typer").val($(this).text()).blur();
            onSelect(this,$(this).text(), $(this).attr("data-value"));
        });

        $(".searchable ul li").hover(function () {
            $(this).closest(".searchable").find("ul li.selected").removeClass("selected");
            $(this).addClass("selected");
        });
    });
})(jQuery, globalWrapper.fshr);



/*!
 * modernizr v3.6.0
 * Build https://modernizr.com/download?-addtest-atrule-domprefixes-prefixed-prefixedcss-prefixes-setclasses-testallprops-testprop-teststyles-dontmin
 *
 * Copyright (c)
 *  Faruk Ates
 *  Paul Irish
 *  Alex Sexton
 *  Ryan Seddon
 *  Patrick Kettner
 *  Stu Cox
 *  Richard Herrera

 * MIT License
 */

/*
 * Modernizr tests which native CSS3 and HTML5 features are available in the
 * current UA and makes the results available to you in two ways: as properties on
 * a global `Modernizr` object, and as classes on the `<html>` element. This
 * information allows you to progressively enhance your pages with a granular level
 * of control over the experience.
*/

;(function(window, document, undefined){
  var classes = [];


  var tests = [];


  /**
   *
   * ModernizrProto is the constructor for Modernizr
   *
   * @class
   * @access public
   */

  var ModernizrProto = {
    // The current version, dummy
    _version: '3.6.0',

    // Any settings that don't work as separate modules
    // can go in here as configuration.
    _config: {
      'classPrefix': '',
      'enableClasses': true,
      'enableJSClass': true,
      'usePrefixes': true
    },

    // Queue of tests
    _q: [],

    // Stub these for people who are listening
    on: function(test, cb) {
      // I don't really think people should do this, but we can
      // safe guard it a bit.
      // -- NOTE:: this gets WAY overridden in src/addTest for actual async tests.
      // This is in case people listen to synchronous tests. I would leave it out,
      // but the code to *disallow* sync tests in the real version of this
      // function is actually larger than this.
      var self = this;
      setTimeout(function() {
        cb(self[test]);
      }, 0);
    },

    addTest: function(name, fn, options) {
      tests.push({name: name, fn: fn, options: options});
    },

    addAsyncTest: function(fn) {
      tests.push({name: null, fn: fn});
    }
  };



  // Fake some of Object.create so we can force non test results to be non "own" properties.
  var Modernizr = function() {};
  Modernizr.prototype = ModernizrProto;

  // Leak modernizr globally when you `require` it rather than force it here.
  // Overwrite name so constructor name is nicer :D
  Modernizr = new Modernizr();



  /**
   * List of property values to set for css tests. See ticket #21
   * http://git.io/vUGl4
   *
   * @memberof Modernizr
   * @name Modernizr._prefixes
   * @optionName Modernizr._prefixes
   * @optionProp prefixes
   * @access public
   * @example
   *
   * Modernizr._prefixes is the internal list of prefixes that we test against
   * inside of things like [prefixed](#modernizr-prefixed) and [prefixedCSS](#-code-modernizr-prefixedcss). It is simply
   * an array of kebab-case vendor prefixes you can use within your code.
   *
   * Some common use cases include
   *
   * Generating all possible prefixed version of a CSS property
   * ```js
   * var rule = Modernizr._prefixes.join('transform: rotate(20deg); ');
   *
   * rule === 'transform: rotate(20deg); webkit-transform: rotate(20deg); moz-transform: rotate(20deg); o-transform: rotate(20deg); ms-transform: rotate(20deg);'
   * ```
   *
   * Generating all possible prefixed version of a CSS value
   * ```js
   * rule = 'display:' +  Modernizr._prefixes.join('flex; display:') + 'flex';
   *
   * rule === 'display:flex; display:-webkit-flex; display:-moz-flex; display:-o-flex; display:-ms-flex; display:flex'
   * ```
   */

  // we use ['',''] rather than an empty array in order to allow a pattern of .`join()`ing prefixes to test
  // values in feature detects to continue to work
  var prefixes = (ModernizrProto._config.usePrefixes ? ' -webkit- -moz- -o- -ms- '.split(' ') : ['','']);

  // expose these for the plugin API. Look in the source for how to join() them against your input
  ModernizrProto._prefixes = prefixes;



  /**
   * is returns a boolean if the typeof an obj is exactly type.
   *
   * @access private
   * @function is
   * @param {*} obj - A thing we want to check the type of
   * @param {string} type - A string to compare the typeof against
   * @returns {boolean}
   */

  function is(obj, type) {
    return typeof obj === type;
  }
  ;

  /**
   * Run through all tests and detect their support in the current UA.
   *
   * @access private
   */

  function testRunner() {
    var featureNames;
    var feature;
    var aliasIdx;
    var result;
    var nameIdx;
    var featureName;
    var featureNameSplit;

    for (var featureIdx in tests) {
      if (tests.hasOwnProperty(featureIdx)) {
        featureNames = [];
        feature = tests[featureIdx];
        // run the test, throw the return value into the Modernizr,
        // then based on that boolean, define an appropriate className
        // and push it into an array of classes we'll join later.
        //
        // If there is no name, it's an 'async' test that is run,
        // but not directly added to the object. That should
        // be done with a post-run addTest call.
        if (feature.name) {
          featureNames.push(feature.name.toLowerCase());

          if (feature.options && feature.options.aliases && feature.options.aliases.length) {
            // Add all the aliases into the names list
            for (aliasIdx = 0; aliasIdx < feature.options.aliases.length; aliasIdx++) {
              featureNames.push(feature.options.aliases[aliasIdx].toLowerCase());
            }
          }
        }

        // Run the test, or use the raw value if it's not a function
        result = is(feature.fn, 'function') ? feature.fn() : feature.fn;


        // Set each of the names on the Modernizr object
        for (nameIdx = 0; nameIdx < featureNames.length; nameIdx++) {
          featureName = featureNames[nameIdx];
          // Support dot properties as sub tests. We don't do checking to make sure
          // that the implied parent tests have been added. You must call them in
          // order (either in the test, or make the parent test a dependency).
          //
          // Cap it to TWO to make the logic simple and because who needs that kind of subtesting
          // hashtag famous last words
          featureNameSplit = featureName.split('.');

          if (featureNameSplit.length === 1) {
            Modernizr[featureNameSplit[0]] = result;
          } else {
            // cast to a Boolean, if not one already
            if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
              Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
            }

            Modernizr[featureNameSplit[0]][featureNameSplit[1]] = result;
          }

          classes.push((result ? '' : 'no-') + featureNameSplit.join('-'));
        }
      }
    }
  }
  ;

  /**
   * hasOwnProp is a shim for hasOwnProperty that is needed for Safari 2.0 support
   *
   * @author kangax
   * @access private
   * @function hasOwnProp
   * @param {object} object - The object to check for a property
   * @param {string} property - The property to check for
   * @returns {boolean}
   */

  // hasOwnProperty shim by kangax needed for Safari 2.0 support
  var hasOwnProp;

  (function() {
    var _hasOwnProperty = ({}).hasOwnProperty;
    /* istanbul ignore else */
    /* we have no way of testing IE 5.5 or safari 2,
     * so just assume the else gets hit */
    if (!is(_hasOwnProperty, 'undefined') && !is(_hasOwnProperty.call, 'undefined')) {
      hasOwnProp = function(object, property) {
        return _hasOwnProperty.call(object, property);
      };
    }
    else {
      hasOwnProp = function(object, property) { /* yes, this can give false positives/negatives, but most of the time we don't care about those */
        return ((property in object) && is(object.constructor.prototype[property], 'undefined'));
      };
    }
  })();



  /**
   * docElement is a convenience wrapper to grab the root element of the document
   *
   * @access private
   * @returns {HTMLElement|SVGElement} The root element of the document
   */

  var docElement = document.documentElement;


  /**
   * A convenience helper to check if the document we are running in is an SVG document
   *
   * @access private
   * @returns {boolean}
   */

  var isSVG = docElement.nodeName.toLowerCase() === 'svg';


  /**
   * setClasses takes an array of class names and adds them to the root element
   *
   * @access private
   * @function setClasses
   * @param {string[]} classes - Array of class names
   */

  // Pass in an and array of class names, e.g.:
  //  ['no-webp', 'borderradius', ...]
  function setClasses(classes) {
    var className = docElement.className;
    var classPrefix = Modernizr._config.classPrefix || '';

    if (isSVG) {
      className = className.baseVal;
    }

    // Change `no-js` to `js` (independently of the `enableClasses` option)
    // Handle classPrefix on this too
    if (Modernizr._config.enableJSClass) {
      var reJS = new RegExp('(^|\\s)' + classPrefix + 'no-js(\\s|$)');
      className = className.replace(reJS, '$1' + classPrefix + 'js$2');
    }

    if (Modernizr._config.enableClasses) {
      // Add the new classes
      className += ' ' + classPrefix + classes.join(' ' + classPrefix);
      if (isSVG) {
        docElement.className.baseVal = className;
      } else {
        docElement.className = className;
      }
    }

  }

  ;


   // _l tracks listeners for async tests, as well as tests that execute after the initial run
  ModernizrProto._l = {};

  /**
   * Modernizr.on is a way to listen for the completion of async tests. Being
   * asynchronous, they may not finish before your scripts run. As a result you
   * will get a possibly false negative `undefined` value.
   *
   * @memberof Modernizr
   * @name Modernizr.on
   * @access public
   * @function on
   * @param {string} feature - String name of the feature detect
   * @param {function} cb - Callback function returning a Boolean - true if feature is supported, false if not
   * @example
   *
   * ```js
   * Modernizr.on('flash', function( result ) {
   *   if (result) {
   *    // the browser has flash
   *   } else {
   *     // the browser does not have flash
   *   }
   * });
   * ```
   */

  ModernizrProto.on = function(feature, cb) {
    // Create the list of listeners if it doesn't exist
    if (!this._l[feature]) {
      this._l[feature] = [];
    }

    // Push this test on to the listener list
    this._l[feature].push(cb);

    // If it's already been resolved, trigger it on next tick
    if (Modernizr.hasOwnProperty(feature)) {
      // Next Tick
      setTimeout(function() {
        Modernizr._trigger(feature, Modernizr[feature]);
      }, 0);
    }
  };

  /**
   * _trigger is the private function used to signal test completion and run any
   * callbacks registered through [Modernizr.on](#modernizr-on)
   *
   * @memberof Modernizr
   * @name Modernizr._trigger
   * @access private
   * @function _trigger
   * @param {string} feature - string name of the feature detect
   * @param {function|boolean} [res] - A feature detection function, or the boolean =
   * result of a feature detection function
   */

  ModernizrProto._trigger = function(feature, res) {
    if (!this._l[feature]) {
      return;
    }

    var cbs = this._l[feature];

    // Force async
    setTimeout(function() {
      var i, cb;
      for (i = 0; i < cbs.length; i++) {
        cb = cbs[i];
        cb(res);
      }
    }, 0);

    // Don't trigger these again
    delete this._l[feature];
  };

  /**
   * addTest allows you to define your own feature detects that are not currently
   * included in Modernizr (under the covers it's the exact same code Modernizr
   * uses for its own [feature detections](https://github.com/Modernizr/Modernizr/tree/master/feature-detects)). Just like the offical detects, the result
   * will be added onto the Modernizr object, as well as an appropriate className set on
   * the html element when configured to do so
   *
   * @memberof Modernizr
   * @name Modernizr.addTest
   * @optionName Modernizr.addTest()
   * @optionProp addTest
   * @access public
   * @function addTest
   * @param {string|object} feature - The string name of the feature detect, or an
   * object of feature detect names and test
   * @param {function|boolean} test - Function returning true if feature is supported,
   * false if not. Otherwise a boolean representing the results of a feature detection
   * @example
   *
   * The most common way of creating your own feature detects is by calling
   * `Modernizr.addTest` with a string (preferably just lowercase, without any
   * punctuation), and a function you want executed that will return a boolean result
   *
   * ```js
   * Modernizr.addTest('itsTuesday', function() {
   *  var d = new Date();
   *  return d.getDay() === 2;
   * });
   * ```
   *
   * When the above is run, it will set Modernizr.itstuesday to `true` when it is tuesday,
   * and to `false` every other day of the week. One thing to notice is that the names of
   * feature detect functions are always lowercased when added to the Modernizr object. That
   * means that `Modernizr.itsTuesday` will not exist, but `Modernizr.itstuesday` will.
   *
   *
   *  Since we only look at the returned value from any feature detection function,
   *  you do not need to actually use a function. For simple detections, just passing
   *  in a statement that will return a boolean value works just fine.
   *
   * ```js
   * Modernizr.addTest('hasJquery', 'jQuery' in window);
   * ```
   *
   * Just like before, when the above runs `Modernizr.hasjquery` will be true if
   * jQuery has been included on the page. Not using a function saves a small amount
   * of overhead for the browser, as well as making your code much more readable.
   *
   * Finally, you also have the ability to pass in an object of feature names and
   * their tests. This is handy if you want to add multiple detections in one go.
   * The keys should always be a string, and the value can be either a boolean or
   * function that returns a boolean.
   *
   * ```js
   * var detects = {
   *  'hasjquery': 'jQuery' in window,
   *  'itstuesday': function() {
   *    var d = new Date();
   *    return d.getDay() === 2;
   *  }
   * }
   *
   * Modernizr.addTest(detects);
   * ```
   *
   * There is really no difference between the first methods and this one, it is
   * just a convenience to let you write more readable code.
   */

  function addTest(feature, test) {

    if (typeof feature == 'object') {
      for (var key in feature) {
        if (hasOwnProp(feature, key)) {
          addTest(key, feature[ key ]);
        }
      }
    } else {

      feature = feature.toLowerCase();
      var featureNameSplit = feature.split('.');
      var last = Modernizr[featureNameSplit[0]];

      // Again, we don't check for parent test existence. Get that right, though.
      if (featureNameSplit.length == 2) {
        last = last[featureNameSplit[1]];
      }

      if (typeof last != 'undefined') {
        // we're going to quit if you're trying to overwrite an existing test
        // if we were to allow it, we'd do this:
        //   var re = new RegExp("\\b(no-)?" + feature + "\\b");
        //   docElement.className = docElement.className.replace( re, '' );
        // but, no rly, stuff 'em.
        return Modernizr;
      }

      test = typeof test == 'function' ? test() : test;

      // Set the value (this is the magic, right here).
      if (featureNameSplit.length == 1) {
        Modernizr[featureNameSplit[0]] = test;
      } else {
        // cast to a Boolean, if not one already
        if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
          Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
        }

        Modernizr[featureNameSplit[0]][featureNameSplit[1]] = test;
      }

      // Set a single class (either `feature` or `no-feature`)
      setClasses([(!!test && test != false ? '' : 'no-') + featureNameSplit.join('-')]);

      // Trigger the event
      Modernizr._trigger(feature, test);
    }

    return Modernizr; // allow chaining.
  }

  // After all the tests are run, add self to the Modernizr prototype
  Modernizr._q.push(function() {
    ModernizrProto.addTest = addTest;
  });




  /**
   * If the browsers follow the spec, then they would expose vendor-specific styles as:
   *   elem.style.WebkitBorderRadius
   * instead of something like the following (which is technically incorrect):
   *   elem.style.webkitBorderRadius

   * WebKit ghosts their properties in lowercase but Opera & Moz do not.
   * Microsoft uses a lowercase `ms` instead of the correct `Ms` in IE8+
   *   erik.eae.net/archives/2008/03/10/21.48.10/

   * More here: github.com/Modernizr/Modernizr/issues/issue/21
   *
   * @access private
   * @returns {string} The string representing the vendor-specific style properties
   */

  var omPrefixes = 'Moz O ms Webkit';


  /**
   * List of JavaScript DOM values used for tests
   *
   * @memberof Modernizr
   * @name Modernizr._domPrefixes
   * @optionName Modernizr._domPrefixes
   * @optionProp domPrefixes
   * @access public
   * @example
   *
   * Modernizr._domPrefixes is exactly the same as [_prefixes](#modernizr-_prefixes), but rather
   * than kebab-case properties, all properties are their Capitalized variant
   *
   * ```js
   * Modernizr._domPrefixes === [ "Moz", "O", "ms", "Webkit" ];
   * ```
   */

  var domPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.toLowerCase().split(' ') : []);
  ModernizrProto._domPrefixes = domPrefixes;


  var cssomPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.split(' ') : []);
  ModernizrProto._cssomPrefixes = cssomPrefixes;


  /**
   * atRule returns a given CSS property at-rule (eg @keyframes), possibly in
   * some prefixed form, or false, in the case of an unsupported rule
   *
   * @memberof Modernizr
   * @name Modernizr.atRule
   * @optionName Modernizr.atRule()
   * @optionProp atRule
   * @access public
   * @function atRule
   * @param {string} prop - String name of the @-rule to test for
   * @returns {string|boolean} The string representing the (possibly prefixed)
   * valid version of the @-rule, or `false` when it is unsupported.
   * @example
   * ```js
   *  var keyframes = Modernizr.atRule('@keyframes');
   *
   *  if (keyframes) {
   *    // keyframes are supported
   *    // could be `@-webkit-keyframes` or `@keyframes`
   *  } else {
   *    // keyframes === `false`
   *  }
   * ```
   *
   */

  var atRule = function(prop) {
    var length = prefixes.length;
    var cssrule = window.CSSRule;
    var rule;

    if (typeof cssrule === 'undefined') {
      return undefined;
    }

    if (!prop) {
      return false;
    }

    // remove literal @ from beginning of provided property
    prop = prop.replace(/^@/, '');

    // CSSRules use underscores instead of dashes
    rule = prop.replace(/-/g, '_').toUpperCase() + '_RULE';

    if (rule in cssrule) {
      return '@' + prop;
    }

    for (var i = 0; i < length; i++) {
      // prefixes gives us something like -o-, and we want O_
      var prefix = prefixes[i];
      var thisRule = prefix.toUpperCase() + '_' + rule;

      if (thisRule in cssrule) {
        return '@-' + prefix.toLowerCase() + '-' + prop;
      }
    }

    return false;
  };

  ModernizrProto.atRule = atRule;



  /**
   * cssToDOM takes a kebab-case string and converts it to camelCase
   * e.g. box-sizing -> boxSizing
   *
   * @access private
   * @function cssToDOM
   * @param {string} name - String name of kebab-case prop we want to convert
   * @returns {string} The camelCase version of the supplied name
   */

  function cssToDOM(name) {
    return name.replace(/([a-z])-([a-z])/g, function(str, m1, m2) {
      return m1 + m2.toUpperCase();
    }).replace(/^-/, '');
  }
  ;

  /**
   * domToCSS takes a camelCase string and converts it to kebab-case
   * e.g. boxSizing -> box-sizing
   *
   * @access private
   * @function domToCSS
   * @param {string} name - String name of camelCase prop we want to convert
   * @returns {string} The kebab-case version of the supplied name
   */

  function domToCSS(name) {
    return name.replace(/([A-Z])/g, function(str, m1) {
      return '-' + m1.toLowerCase();
    }).replace(/^ms-/, '-ms-');
  }
  ;


  /**
   * contains checks to see if a string contains another string
   *
   * @access private
   * @function contains
   * @param {string} str - The string we want to check for substrings
   * @param {string} substr - The substring we want to search the first string for
   * @returns {boolean}
   */

  function contains(str, substr) {
    return !!~('' + str).indexOf(substr);
  }

  ;

  /**
   * createElement is a convenience wrapper around document.createElement. Since we
   * use createElement all over the place, this allows for (slightly) smaller code
   * as well as abstracting away issues with creating elements in contexts other than
   * HTML documents (e.g. SVG documents).
   *
   * @access private
   * @function createElement
   * @returns {HTMLElement|SVGElement} An HTML or SVG element
   */

  function createElement() {
    if (typeof document.createElement !== 'function') {
      // This is the case in IE7, where the type of createElement is "object".
      // For this reason, we cannot call apply() as Object is not a Function.
      return document.createElement(arguments[0]);
    } else if (isSVG) {
      return document.createElementNS.call(document, 'http://www.w3.org/2000/svg', arguments[0]);
    } else {
      return document.createElement.apply(document, arguments);
    }
  }

  ;

  /**
   * getBody returns the body of a document, or an element that can stand in for
   * the body if a real body does not exist
   *
   * @access private
   * @function getBody
   * @returns {HTMLElement|SVGElement} Returns the real body of a document, or an
   * artificially created element that stands in for the body
   */

  function getBody() {
    // After page load injecting a fake body doesn't work so check if body exists
    var body = document.body;

    if (!body) {
      // Can't use the real body create a fake one.
      body = createElement(isSVG ? 'svg' : 'body');
      body.fake = true;
    }

    return body;
  }

  ;

  /**
   * injectElementWithStyles injects an element with style element and some CSS rules
   *
   * @access private
   * @function injectElementWithStyles
   * @param {string} rule - String representing a css rule
   * @param {function} callback - A function that is used to test the injected element
   * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
   * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
   * @returns {boolean}
   */

  function injectElementWithStyles(rule, callback, nodes, testnames) {
    var mod = 'modernizr';
    var style;
    var ret;
    var node;
    var docOverflow;
    var div = createElement('div');
    var body = getBody();

    if (parseInt(nodes, 10)) {
      // In order not to give false positives we create a node for each test
      // This also allows the method to scale for unspecified uses
      while (nodes--) {
        node = createElement('div');
        node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
        div.appendChild(node);
      }
    }

    style = createElement('style');
    style.type = 'text/css';
    style.id = 's' + mod;

    // IE6 will false positive on some tests due to the style element inside the test div somehow interfering offsetHeight, so insert it into body or fakebody.
    // Opera will act all quirky when injecting elements in documentElement when page is served as xml, needs fakebody too. #270
    (!body.fake ? div : body).appendChild(style);
    body.appendChild(div);

    if (style.styleSheet) {
      style.styleSheet.cssText = rule;
    } else {
      style.appendChild(document.createTextNode(rule));
    }
    div.id = mod;

    if (body.fake) {
      //avoid crashing IE8, if background image is used
      body.style.background = '';
      //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
      body.style.overflow = 'hidden';
      docOverflow = docElement.style.overflow;
      docElement.style.overflow = 'hidden';
      docElement.appendChild(body);
    }

    ret = callback(div, rule);
    // If this is done after page load we don't want to remove the body so check if body exists
    if (body.fake) {
      body.parentNode.removeChild(body);
      docElement.style.overflow = docOverflow;
      // Trigger layout so kinetic scrolling isn't disabled in iOS6+
      // eslint-disable-next-line
      docElement.offsetHeight;
    } else {
      div.parentNode.removeChild(div);
    }

    return !!ret;

  }

  ;

  /**
   * testStyles injects an element with style element and some CSS rules
   *
   * @memberof Modernizr
   * @name Modernizr.testStyles
   * @optionName Modernizr.testStyles()
   * @optionProp testStyles
   * @access public
   * @function testStyles
   * @param {string} rule - String representing a css rule
   * @param {function} callback - A function that is used to test the injected element
   * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
   * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
   * @returns {boolean}
   * @example
   *
   * `Modernizr.testStyles` takes a CSS rule and injects it onto the current page
   * along with (possibly multiple) DOM elements. This lets you check for features
   * that can not be detected by simply checking the [IDL](https://developer.mozilla.org/en-US/docs/Mozilla/Developer_guide/Interface_development_guide/IDL_interface_rules).
   *
   * ```js
   * Modernizr.testStyles('#modernizr { width: 9px; color: papayawhip; }', function(elem, rule) {
   *   // elem is the first DOM node in the page (by default #modernizr)
   *   // rule is the first argument you supplied - the CSS rule in string form
   *
   *   addTest('widthworks', elem.style.width === '9px')
   * });
   * ```
   *
   * If your test requires multiple nodes, you can include a third argument
   * indicating how many additional div elements to include on the page. The
   * additional nodes are injected as children of the `elem` that is returned as
   * the first argument to the callback.
   *
   * ```js
   * Modernizr.testStyles('#modernizr {width: 1px}; #modernizr2 {width: 2px}', function(elem) {
   *   document.getElementById('modernizr').style.width === '1px'; // true
   *   document.getElementById('modernizr2').style.width === '2px'; // true
   *   elem.firstChild === document.getElementById('modernizr2'); // true
   * }, 1);
   * ```
   *
   * By default, all of the additional elements have an ID of `modernizr[n]`, where
   * `n` is its index (e.g. the first additional, second overall is `#modernizr2`,
   * the second additional is `#modernizr3`, etc.).
   * If you want to have more meaningful IDs for your function, you can provide
   * them as the fourth argument, as an array of strings
   *
   * ```js
   * Modernizr.testStyles('#foo {width: 10px}; #bar {height: 20px}', function(elem) {
   *   elem.firstChild === document.getElementById('foo'); // true
   *   elem.lastChild === document.getElementById('bar'); // true
   * }, 2, ['foo', 'bar']);
   * ```
   *
   */

  var testStyles = ModernizrProto.testStyles = injectElementWithStyles;


  /**
   * Create our "modernizr" element that we do most feature tests on.
   *
   * @access private
   */

  var modElem = {
    elem: createElement('modernizr')
  };

  // Clean up this element
  Modernizr._q.push(function() {
    delete modElem.elem;
  });



  var mStyle = {
    style: modElem.elem.style
  };

  // kill ref for gc, must happen before mod.elem is removed, so we unshift on to
  // the front of the queue.
  Modernizr._q.unshift(function() {
    delete mStyle.style;
  });




  /**
   * wrapper around getComputedStyle, to fix issues with Firefox returning null when
   * called inside of a hidden iframe
   *
   * @access private
   * @function computedStyle
   * @param {HTMLElement|SVGElement} - The element we want to find the computed styles of
   * @param {string|null} [pseudoSelector]- An optional pseudo element selector (e.g. :before), of null if none
   * @returns {CSSStyleDeclaration}
   */

  function computedStyle(elem, pseudo, prop) {
    var result;

    if ('getComputedStyle' in window) {
      result = getComputedStyle.call(window, elem, pseudo);
      var console = window.console;

      if (result !== null) {
        if (prop) {
          result = result.getPropertyValue(prop);
        }
      } else {
        if (console) {
          var method = console.error ? 'error' : 'log';
          console[method].call(console, 'getComputedStyle returning null, its possible modernizr test results are inaccurate');
        }
      }
    } else {
      result = !pseudo && elem.currentStyle && elem.currentStyle[prop];
    }

    return result;
  }

  ;

  /**
   * nativeTestProps allows for us to use native feature detection functionality if available.
   * some prefixed form, or false, in the case of an unsupported rule
   *
   * @access private
   * @function nativeTestProps
   * @param {array} props - An array of property names
   * @param {string} value - A string representing the value we want to check via @supports
   * @returns {boolean|undefined} A boolean when @supports exists, undefined otherwise
   */

  // Accepts a list of property names and a single value
  // Returns `undefined` if native detection not available
  function nativeTestProps(props, value) {
    var i = props.length;
    // Start with the JS API: http://www.w3.org/TR/css3-conditional/#the-css-interface
    if ('CSS' in window && 'supports' in window.CSS) {
      // Try every prefixed variant of the property
      while (i--) {
        if (window.CSS.supports(domToCSS(props[i]), value)) {
          return true;
        }
      }
      return false;
    }
    // Otherwise fall back to at-rule (for Opera 12.x)
    else if ('CSSSupportsRule' in window) {
      // Build a condition string for every prefixed variant
      var conditionText = [];
      while (i--) {
        conditionText.push('(' + domToCSS(props[i]) + ':' + value + ')');
      }
      conditionText = conditionText.join(' or ');
      return injectElementWithStyles('@supports (' + conditionText + ') { #modernizr { position: absolute; } }', function(node) {
        return computedStyle(node, null, 'position') == 'absolute';
      });
    }
    return undefined;
  }
  ;

  // testProps is a generic CSS / DOM property test.

  // In testing support for a given CSS property, it's legit to test:
  //    `elem.style[styleName] !== undefined`
  // If the property is supported it will return an empty string,
  // if unsupported it will return undefined.

  // We'll take advantage of this quick test and skip setting a style
  // on our modernizr element, but instead just testing undefined vs
  // empty string.

  // Property names can be provided in either camelCase or kebab-case.

  function testProps(props, prefixed, value, skipValueTest) {
    skipValueTest = is(skipValueTest, 'undefined') ? false : skipValueTest;

    // Try native detect first
    if (!is(value, 'undefined')) {
      var result = nativeTestProps(props, value);
      if (!is(result, 'undefined')) {
        return result;
      }
    }

    // Otherwise do it properly
    var afterInit, i, propsLength, prop, before;

    // If we don't have a style element, that means we're running async or after
    // the core tests, so we'll need to create our own elements to use

    // inside of an SVG element, in certain browsers, the `style` element is only
    // defined for valid tags. Therefore, if `modernizr` does not have one, we
    // fall back to a less used element and hope for the best.
    // for strict XHTML browsers the hardly used samp element is used
    var elems = ['modernizr', 'tspan', 'samp'];
    while (!mStyle.style && elems.length) {
      afterInit = true;
      mStyle.modElem = createElement(elems.shift());
      mStyle.style = mStyle.modElem.style;
    }

    // Delete the objects if we created them.
    function cleanElems() {
      if (afterInit) {
        delete mStyle.style;
        delete mStyle.modElem;
      }
    }

    propsLength = props.length;
    for (i = 0; i < propsLength; i++) {
      prop = props[i];
      before = mStyle.style[prop];

      if (contains(prop, '-')) {
        prop = cssToDOM(prop);
      }

      if (mStyle.style[prop] !== undefined) {

        // If value to test has been passed in, do a set-and-check test.
        // 0 (integer) is a valid property value, so check that `value` isn't
        // undefined, rather than just checking it's truthy.
        if (!skipValueTest && !is(value, 'undefined')) {

          // Needs a try catch block because of old IE. This is slow, but will
          // be avoided in most cases because `skipValueTest` will be used.
          try {
            mStyle.style[prop] = value;
          } catch (e) {}

          // If the property value has changed, we assume the value used is
          // supported. If `value` is empty string, it'll fail here (because
          // it hasn't changed), which matches how browsers have implemented
          // CSS.supports()
          if (mStyle.style[prop] != before) {
            cleanElems();
            return prefixed == 'pfx' ? prop : true;
          }
        }
        // Otherwise just return true, or the property name if this is a
        // `prefixed()` call
        else {
          cleanElems();
          return prefixed == 'pfx' ? prop : true;
        }
      }
    }
    cleanElems();
    return false;
  }

  ;

  /**
   * testProp() investigates whether a given style property is recognized
   * Property names can be provided in either camelCase or kebab-case.
   *
   * @memberof Modernizr
   * @name Modernizr.testProp
   * @access public
   * @optionName Modernizr.testProp()
   * @optionProp testProp
   * @function testProp
   * @param {string} prop - Name of the CSS property to check
   * @param {string} [value] - Name of the CSS value to check
   * @param {boolean} [useValue] - Whether or not to check the value if @supports isn't supported
   * @returns {boolean}
   * @example
   *
   * Just like [testAllProps](#modernizr-testallprops), only it does not check any vendor prefixed
   * version of the string.
   *
   * Note that the property name must be provided in camelCase (e.g. boxSizing not box-sizing)
   *
   * ```js
   * Modernizr.testProp('pointerEvents')  // true
   * ```
   *
   * You can also provide a value as an optional second argument to check if a
   * specific value is supported
   *
   * ```js
   * Modernizr.testProp('pointerEvents', 'none') // true
   * Modernizr.testProp('pointerEvents', 'penguin') // false
   * ```
   */

  var testProp = ModernizrProto.testProp = function(prop, value, useValue) {
    return testProps([prop], undefined, value, useValue);
  };


  /**
   * fnBind is a super small [bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind) polyfill.
   *
   * @access private
   * @function fnBind
   * @param {function} fn - a function you want to change `this` reference to
   * @param {object} that - the `this` you want to call the function with
   * @returns {function} The wrapped version of the supplied function
   */

  function fnBind(fn, that) {
    return function() {
      return fn.apply(that, arguments);
    };
  }

  ;

  /**
   * testDOMProps is a generic DOM property test; if a browser supports
   *   a certain property, it won't return undefined for it.
   *
   * @access private
   * @function testDOMProps
   * @param {array.<string>} props - An array of properties to test for
   * @param {object} obj - An object or Element you want to use to test the parameters again
   * @param {boolean|object} elem - An Element to bind the property lookup again. Use `false` to prevent the check
   * @returns {false|*} returns false if the prop is unsupported, otherwise the value that is supported
   */
  function testDOMProps(props, obj, elem) {
    var item;

    for (var i in props) {
      if (props[i] in obj) {

        // return the property name as a string
        if (elem === false) {
          return props[i];
        }

        item = obj[props[i]];

        // let's bind a function
        if (is(item, 'function')) {
          // bind to obj unless overriden
          return fnBind(item, elem || obj);
        }

        // return the unbound function or obj or value
        return item;
      }
    }
    return false;
  }

  ;

  /**
   * testPropsAll tests a list of DOM properties we want to check against.
   * We specify literally ALL possible (known and/or likely) properties on
   * the element including the non-vendor prefixed one, for forward-
   * compatibility.
   *
   * @access private
   * @function testPropsAll
   * @param {string} prop - A string of the property to test for
   * @param {string|object} [prefixed] - An object to check the prefixed properties on. Use a string to skip
   * @param {HTMLElement|SVGElement} [elem] - An element used to test the property and value against
   * @param {string} [value] - A string of a css value
   * @param {boolean} [skipValueTest] - An boolean representing if you want to test if value sticks when set
   * @returns {false|string} returns the string version of the property, or false if it is unsupported
   */
  function testPropsAll(prop, prefixed, elem, value, skipValueTest) {

    var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
      props = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');

    // did they call .prefixed('boxSizing') or are we just testing a prop?
    if (is(prefixed, 'string') || is(prefixed, 'undefined')) {
      return testProps(props, prefixed, value, skipValueTest);

      // otherwise, they called .prefixed('requestAnimationFrame', window[, elem])
    } else {
      props = (prop + ' ' + (domPrefixes).join(ucProp + ' ') + ucProp).split(' ');
      return testDOMProps(props, prefixed, elem);
    }
  }

  // Modernizr.testAllProps() investigates whether a given style property,
  // or any of its vendor-prefixed variants, is recognized
  //
  // Note that the property names must be provided in the camelCase variant.
  // Modernizr.testAllProps('boxSizing')
  ModernizrProto.testAllProps = testPropsAll;



  /**
   * prefixed returns the prefixed or nonprefixed property name variant of your input
   *
   * @memberof Modernizr
   * @name Modernizr.prefixed
   * @optionName Modernizr.prefixed()
   * @optionProp prefixed
   * @access public
   * @function prefixed
   * @param {string} prop - String name of the property to test for
   * @param {object} [obj] - An object to test for the prefixed properties on
   * @param {HTMLElement} [elem] - An element used to test specific properties against
   * @returns {string|false} The string representing the (possibly prefixed) valid
   * version of the property, or `false` when it is unsupported.
   * @example
   *
   * Modernizr.prefixed takes a string css value in the DOM style camelCase (as
   * opposed to the css style kebab-case) form and returns the (possibly prefixed)
   * version of that property that the browser actually supports.
   *
   * For example, in older Firefox...
   * ```js
   * prefixed('boxSizing')
   * ```
   * returns 'MozBoxSizing'
   *
   * In newer Firefox, as well as any other browser that support the unprefixed
   * version would simply return `boxSizing`. Any browser that does not support
   * the property at all, it will return `false`.
   *
   * By default, prefixed is checked against a DOM element. If you want to check
   * for a property on another object, just pass it as a second argument
   *
   * ```js
   * var rAF = prefixed('requestAnimationFrame', window);
   *
   * raf(function() {
   *  renderFunction();
   * })
   * ```
   *
   * Note that this will return _the actual function_ - not the name of the function.
   * If you need the actual name of the property, pass in `false` as a third argument
   *
   * ```js
   * var rAFProp = prefixed('requestAnimationFrame', window, false);
   *
   * rafProp === 'WebkitRequestAnimationFrame' // in older webkit
   * ```
   *
   * One common use case for prefixed is if you're trying to determine which transition
   * end event to bind to, you might do something like...
   * ```js
   * var transEndEventNames = {
   *     'WebkitTransition' : 'webkitTransitionEnd', * Saf 6, Android Browser
   *     'MozTransition'    : 'transitionend',       * only for FF < 15
   *     'transition'       : 'transitionend'        * IE10, Opera, Chrome, FF 15+, Saf 7+
   * };
   *
   * var transEndEventName = transEndEventNames[ Modernizr.prefixed('transition') ];
   * ```
   *
   * If you want a similar lookup, but in kebab-case, you can use [prefixedCSS](#modernizr-prefixedcss).
   */

  var prefixed = ModernizrProto.prefixed = function(prop, obj, elem) {
    if (prop.indexOf('@') === 0) {
      return atRule(prop);
    }

    if (prop.indexOf('-') != -1) {
      // Convert kebab-case to camelCase
      prop = cssToDOM(prop);
    }
    if (!obj) {
      return testPropsAll(prop, 'pfx');
    } else {
      // Testing DOM property e.g. Modernizr.prefixed('requestAnimationFrame', window) // 'mozRequestAnimationFrame'
      return testPropsAll(prop, obj, elem);
    }
  };



  /**
   * prefixedCSS is just like [prefixed](#modernizr-prefixed), but the returned values are in
   * kebab-case (e.g. `box-sizing`) rather than camelCase (boxSizing).
   *
   * @memberof Modernizr
   * @name Modernizr.prefixedCSS
   * @optionName Modernizr.prefixedCSS()
   * @optionProp prefixedCSS
   * @access public
   * @function prefixedCSS
   * @param {string} prop - String name of the property to test for
   * @returns {string|false} The string representing the (possibly prefixed)
   * valid version of the property, or `false` when it is unsupported.
   * @example
   *
   * `Modernizr.prefixedCSS` is like `Modernizr.prefixed`, but returns the result
   * in hyphenated form
   *
   * ```js
   * Modernizr.prefixedCSS('transition') // '-moz-transition' in old Firefox
   * ```
   *
   * Since it is only useful for CSS style properties, it can only be tested against
   * an HTMLElement.
   *
   * Properties can be passed as both the DOM style camelCase or CSS style kebab-case.
   */

  var prefixedCSS = ModernizrProto.prefixedCSS = function(prop) {
    var prefixedProp = prefixed(prop);
    return prefixedProp && domToCSS(prefixedProp);
  };


  /**
   * testAllProps determines whether a given CSS property is supported in the browser
   *
   * @memberof Modernizr
   * @name Modernizr.testAllProps
   * @optionName Modernizr.testAllProps()
   * @optionProp testAllProps
   * @access public
   * @function testAllProps
   * @param {string} prop - String naming the property to test (either camelCase or kebab-case)
   * @param {string} [value] - String of the value to test
   * @param {boolean} [skipValueTest=false] - Whether to skip testing that the value is supported when using non-native detection
   * @example
   *
   * testAllProps determines whether a given CSS property, in some prefixed form,
   * is supported by the browser.
   *
   * ```js
   * testAllProps('boxSizing')  // true
   * ```
   *
   * It can optionally be given a CSS value in string form to test if a property
   * value is valid
   *
   * ```js
   * testAllProps('display', 'block') // true
   * testAllProps('display', 'penguin') // false
   * ```
   *
   * A boolean can be passed as a third parameter to skip the value check when
   * native detection (@supports) isn't available.
   *
   * ```js
   * testAllProps('shapeOutside', 'content-box', true);
   * ```
   */

  function testAllProps(prop, value, skipValueTest) {
    return testPropsAll(prop, undefined, undefined, value, skipValueTest);
  }
  ModernizrProto.testAllProps = testAllProps;


  // Run each test
  testRunner();

  // Remove the "no-js" class if it exists
  setClasses(classes);

  delete ModernizrProto.addTest;
  delete ModernizrProto.addAsyncTest;

  // Run the things that are supposed to run after the tests
  for (var i = 0; i < Modernizr._q.length; i++) {
    Modernizr._q[i]();
  }

  // Leak Modernizr namespace
  window.Modernizr = Modernizr;


;

})(window, document);

(function(Modernizr){

// Here are all the values we will test. If you want to use just one or two, comment out the lines of test you don't need.
var tests = [
  { name: 'svg', value: 'url(#test)' }, // False positive in IE, supports SVG clip-path, but not on HTML element
  { name: 'inset', value: 'inset(10px 20px 30px 40px)' },
  { name: 'circle', value: 'circle(60px at center)' },
  { name: 'ellipse', value: 'ellipse(50% 50% at 50% 50%)' },
  { name: 'polygon', value: 'polygon(50% 0%, 0% 100%, 100% 100%)' }
];

var t = 0,
    name, value, prop;

for (; t < tests.length; t++) {
  name = tests[t].name;
  value = tests[t].value;
  Modernizr.addTest('cssclippath' + name, function(){
    // Try using window.CSS.supports
    if ( 'CSS' in window && 'supports' in window.CSS ) {
      for (var i = 0; i < Modernizr._prefixes.length; i++) {
        prop = Modernizr._prefixes[i] + 'clip-path'

        if ( window.CSS.supports(prop,value) ) { return true; }
      }
      return false;
    }
    // Otherwise, use Modernizr.testStyles and examine the property manually
    return Modernizr.testStyles('#modernizr { '+Modernizr._prefixes.join('clip-path:'+value+'; ')+' }',function(elem, rule) {
      var style = getComputedStyle(elem),
          clip = style.clipPath;

      if ( !clip || clip == "none" ) {
        clip = false;

        for (var i = 0; i < Modernizr._domPrefixes.length; i++) {
          test = Modernizr._domPrefixes[i] + 'ClipPath';
          if ( style[test] && style[test] !== "none" ) {
            clip = true;
            break;
          }
        }
      }

      return Modernizr.testProp('clipPath') && clip;
    });
  });

}

})(Modernizr);


$(window).on("load", function () {
    if ($("body").is(".fshr-page-search")) {
        $("body").removeClass("fshr-groupView");
        $(".js-map--searchResults").trigger("mappins-updated");
    }
});



//MB.JS
// Last minute filter
function lastMinuteFilterSize() {
    $('.js-lastMinuteFilter').each(function () {
        var $filterHeader = $(this).find('.fshr-filter-header'),
            $filterContent = $(this).find('.fshr-filter-content'),
            $filterFooter = $(this).find('.fshr-filter-footer'),
            viewportHeight = $(window).outerHeight(),
            filterHeaderHeight = $filterHeader.outerHeight(),
            filterFooterHeight = $filterFooter.outerHeight(),
            filterContentHeight = viewportHeight - filterHeaderHeight - filterFooterHeight - 20;

        $filterContent.css({
            'height': filterContentHeight
        });
    });
}

// jQuery ready
(function ($) {
    lastMinuteFilterSize();

    var resizeId = 0;
    $(window).on('resize', function () {
        clearTimeout(resizeId);
        resizeId = setTimeout(function () {
            lastMinuteFilterSize();
        }, 300);
    });

    $(document).on("click", ".js-lastMinuteFilter .js-filter-btn", function (event) {
        event.preventDefault();
        $('body').toggleClass('filter-active');
    });
    $(document).keyup(function (event) {
        if (event.keyCode == 27) {
            $('body').removeClass('filter-active');
        }
    });
})(jQuery);


function ObjectLength( object ) {
    var length = 0;
    for( var key in object ) {
        if( object.hasOwnProperty(key) ) {
            ++length;
        }
    }
    return length;
};
